import React,{useState,useEffect,useRef} from 'react';
import PropTypes from 'prop-types';
import httpClient from '../../../../httpClient';
import botHttpClient from '../../../../bothttpClient';
import './chatTemplate.css'
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ReplayIcon from '@mui/icons-material/Replay';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EditNoteIcon from '@mui/icons-material/EditNote';
import AddIcon from '@mui/icons-material/Add';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Popover from '@mui/material/Popover';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Avatar from '@mui/material/Avatar';
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Chip from '@mui/material/Chip';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import produce from 'immer';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Fab from '@mui/material/Fab';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import MarkChatUnreadIcon from '@mui/icons-material/MarkChatUnread';
import ListAltIcon from '@mui/icons-material/ListAlt';
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import InfoIcon from '@mui/icons-material/Info';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import RefreshIcon from '@mui/icons-material/Refresh';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/Card';
import CardActions from '@mui/material/Card';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import LinearProgress from '@mui/material/LinearProgress'
import { debounce } from 'lodash';
import { useParams,useLocation } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Menu from '@mui/material/Menu';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs, { Dayjs } from 'dayjs';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import { dynApi } from '../../../../httpClient';
import { ConstructionOutlined } from '@mui/icons-material';
import ReportIcon from '@mui/icons-material/Report'
import CheckIcon from '@mui/icons-material/Check';
import { isImmutable, Map } from 'immutable';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
let hhmm_time_opt = Array.from({ length: 401 }, (value, index) => index);
const ChatTemplate = (props) => {
  const [selectedTime,set_selected_time] = useState('')
  const [hovered, setHovered] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const cf_trunc_len = {
    50: 4,
    100: 15,
    150: 20,
    200: 25,
    250: 30,
    // Add more values as needed
  };


  
  // // ////console.log("\n\n\n\n\n props :: ",props)
  
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [SendMsgLoader, setSendMsgLoader] =  useState(false);
  const [GetMsgListLoader, setGetMsgListLoader] = useState(false);
  const [widget, setwidgets] = useState([]);
  const [nomalmsg, setNormalmsg] = useState([]);
  const [message,setMessage] = useState([]);
  let [wholePageLoad,SetWholePageLoad] = useState(false);
  let [curr_submit_load_flag,setCurr_submit_load_flag] = useState(false);
  let SPECIAL_SUBMIT_NON_MUTLI = "dirrect_database_upload_non_multi_sub_form"
  const message_index = 0;
  let FORM_RESP_TYPE_FREE_TEXT = "free text"
  let FORM_RESP_TYPE_POS_NO = "Positive Number"
  let FORM_RESP_TYPE_POS_DEC = "Positive Decimal"
  let FORM_RESP_TYPE_INT = "Integer"
  let FORM_RESP_TYPE_DEC = "Decimal"
  let FORM_RESP_TYPE_DATE = "Date"
  let FORM_RESP_TYPE_TIME = "Time"
  let FORM_RESP_TYPE_TIME_IN_NO = "Time in Numbers"
  let FORM_RESP_TYPE_FILE_UPL = "file upload"
  let FORM_RESP_TYPE_NONE = "None"
  let FORM_RESP_DICT = {  FORM_RESP_TYPE_NONE:0,
                      FORM_RESP_TYPE_FREE_TEXT:1,
                      FORM_RESP_TYPE_POS_NO:2,
                      FORM_RESP_TYPE_POS_DEC:3,
                      FORM_RESP_TYPE_INT:4,
                      FORM_RESP_TYPE_DEC:5,
                      FORM_RESP_TYPE_DATE:6,
                      FORM_RESP_TYPE_TIME:9,
                      FORM_RESP_TYPE_TIME_IN_NO:10,
                      FORM_RESP_TYPE_FILE_UPL:0}
  let FORM_RESP_REV_DICT = {  0:FORM_RESP_TYPE_NONE,
                          1:FORM_RESP_TYPE_FREE_TEXT,
                          2:FORM_RESP_TYPE_POS_NO,
                          3:FORM_RESP_TYPE_POS_DEC,
                          4:FORM_RESP_TYPE_INT,
                          5:FORM_RESP_TYPE_DEC,
                          6:FORM_RESP_TYPE_DATE,
                          9:FORM_RESP_TYPE_TIME,
                          10:FORM_RESP_TYPE_TIME_IN_NO
                        }
  
  let FORM_SUB_RESP_TYPE_ALL = "ALL"
  let FORM_SUB_RESP_TYPE_FULL_NAME = "FULL_NAME"
  let FORM_SUB_RESP_TYPE_MAIL_ID = "MAIL_ID"
  let FORM_SUB_RESP_TYPE_PHONE = "PHONE_NUMBER"
  let FORM_SUB_RESP_TYPE_URL = "URL"
  let FORM_SUB_RESP_TYPE_PHONE_WITH_CONT_CODE = "PHONE_NUMBER_WITH_CONT_CODE"

  let FORM_SUB_RESP_REV_DICT = {  0:FORM_SUB_RESP_TYPE_ALL,
                              1:FORM_SUB_RESP_TYPE_FULL_NAME,
                              2:FORM_SUB_RESP_TYPE_MAIL_ID,
                              3:FORM_SUB_RESP_TYPE_PHONE,
                              4:FORM_SUB_RESP_TYPE_URL,
                              5:FORM_SUB_RESP_TYPE_PHONE_WITH_CONT_CODE}
  let ques_resp_error_msg_map = {normal:{},multiple:{}};
  let [subform_search_key,setsubform_search_key] = useState("");
  let isvisiblebulkUpload_formResp = false;
  let onLoadbulkUpload_formResp = false;
  let currBulkUploadForm_formResp =  null;
  let FileUploadDiasable_formResp = false;
  let visibleFileUpload_formResp = false;
  let [CurrBulkUplFormIndx,setCurrBulkUplFormIndx]  = useState(null);
  let [CurrBulkUplFormId,setCurrBulkUplFormId]  = useState(null);
  let [CurrBulkUplSubFormId,setCurrBulkUplSubFormId]  = useState(null);
  let [CurrBulkUplAddData,setCurrBulkUplAddData]  = useState({});
  let [CURR_FORM_IS_MULTI_SUB,setCURR_FORM_IS_MULTI_SUB]  =  useState(false);
  let [CURR_MULTI_SUBFORM_Q1_TOGGLE,setCURR_MULTI_SUBFORM_Q1_TOGGLE]  =  useState(false);
  let [CURR_MULTI_SUBFORM_TEMP,setCURR_MULTI_SUBFORM_TEMP]  = useState([]);
  let [CURR_MULTI_SUBFORM_TEMP_CACHE,setCURR_MULTI_SUBFORM_TEMP_CACHE]  = useState([]);
  let [CURR_MULTI_SUBFORM_ROW_INDX,setCURR_MULTI_SUBFORM_ROW_INDX] = useState(-1);
  let CURR_MULTI_SUBFORM_CF_INST_ID  = null;
  let [CURR_MULTI_SUBFORM_Q1_TOGGLE_RESP_TYPE,setCURR_MULTI_SUBFORM_Q1_TOGGLE_RESP_TYPE] = useState(null) ;
  let [CURR_MULTI_SUBFORM_TOTAL_PAGE_NO,setCURR_MULTI_SUBFORM_TOTAL_PAGE_NO] = useState(1) ;
  let CURR_MULTI_SUBFORM_TOTAL_ROWS  = 0;
  let [MULTI_SUB_BATCH_COUNT,setMULTI_SUB_BATCH_COUNT] = useState(15);
  let [onTableRowLoad,setonTableRowLoad]  =  useState(false);
  let multiSubFormWidth = 500;
  let [multisub_page_no,setmultisub_page_no] = useState(1);
  let filters  = [];
  let FETCH_ALL_LIMIT = 100;
  let EXP_FORM_MASTER = "MASTER_ALONE"
  let isProgressVisible  =  false;
  let [currBulkUpldPerct,setcurrBulkUpldProgPerct] = useState(0);
  let progressLoop ;
  let [curr_master_filter_list,setcurr_master_filter_list]  =  useState({"cfm":{},"seq":{}});
  let [curr_master_order_by_list,setcurr_master_order_by_list] = useState({"cfm":{},"seq":{}});
  let check_multi_sub_track  = {"all":false,"215360":true}
  let [expMasterTaskUpdates,setexpMasterTaskUpdates]  = useState([]);
  let img_formats = ["jpg","jpeg","png","gif","jpe",".jpg",".jpeg",".png",".gif",".jpe","..jpg","..jpeg","..png","..gif","..jpe"];
  let CURR_MULTI_SUB_HIDE_CURR_VAL = false;
  let MULTIPLE_SUBFORM_MODE_START = "multiple_subform_starts"
  let MULTIPLE_SUBFORM_MODE_END   = "multiple_subform_end"
  let CONVO_PARAM_SUBFORM_MODE_MULTI_CURR_INDX = "multiple_subform_mode_curr_indx"
  let SPECIAL_SUBMIT_TYPE = "dirrect_database_upload"
  let SPECIAL_SUBMIT_TYPE_DREAM_DASH = "dirrect_database_upload_dream_dash"
  let SPECIAL_SUBMIT_GRID_ROW_SUBMIT_DREAM_DASH = "dirrect_database_upload_grid_row_submit_dream_dash"
  let [curr_date_pick_mess_indx,setCurr_date_pick_mess_indx] = useState(null);
  let [curr_date_pick_form_indx,setCurr_date_pick_form_indx] = useState(null);
  let [curr_date_pick_ques_indx,setCurr_date_pick_ques_indx] = useState(null);
  let [curr_date_pick_form_type,setCurr_date_pick_form_type] = useState(null);
  let [curr_date_pick_is_multi,setCurr_date_pick_is_multi] = useState(null);
  let [curr_date_pick_sub_form_indx,setCurr_date_pick_sub_form_indx] = useState(null);
  let [curr_act_mess_indx,setCurr_act_mess_indx] = useState(null);
  let [curr_act_form_indx,setCurr_act_form_indx] = useState(null);
  let [curr_act_ques_indx,setCurr_act_ques_indx] = useState(null);
  let [curr_act_form_type,setCurr_act_form_type] = useState(null);
  let [curr_act_is_multi,setCurr_act_is_multi] = useState(null);
  let [curr_act_sub_form_indx,setCurr_act_sub_form_indx] = useState(null);
  let [visble_datepick,setvisble_datepick] = useState(false);
  let [visble_col_filtr,setvisble_col_filtr] = useState(false);
  let [datepickvar,setDatepickvar] = useState(null);
  let [fileuploadType,setfileuploadType] = useState('form_response');
  let [visibleFileUpload,setvisibleFileUpload] = useState(false);
  let [FileUploadDisable,setFileUploadDisable] = useState(false);
  let [temp_Upld_fileList,settemp_Upld_fileList] = useState([]);
  let [form_display_view,setform_display_view] = useState('multi_sub');
  let [curr_card_view_form_ind,setcurr_card_view_form_ind] = useState(null);
  let [imageObject,setimageObject] = useState([...[]]);
  let [CFimageObject, setCFimageObject] = useState([...[]]);
  let [currImgIndx,setcurrImgIndx] = useState([]);
  let [CfcurrImgIndx,setCfcurrImgIndx] = useState(0)
  let [imgGalVisible,setimgGalVisible] = useState(false);
  let [CfimgGalVisible,setCfimgGalVisible] = useState(false);
  let [updateNoteTaskform,setupdateNoteTaskform] = useState({
    description: "",
    attachments: [],
    task_id: "",
    revision: 0
  })
  let empyImgLink = "https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
  let defFileImg = "https://vector.cloobot.ai/backend/database_download?file_id=8a1bdb62-8e7c-4587-812f-1f4f40b79093"
  let [BulkExImp,setBulkExImp] = useState(false);
  let EXCEL_EXTENSION = '.xlsx'
  let [fileStatusModal,setfileStatusModal] = useState(false);
  let [File_status_list,setFile_status_list] = useState([]);
  let [fullScreenToggle,setfullScreenToggle] = useState(0)
  let [MasterFilterCfIndx,setMasterFilterCfIndx] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [copiedMessage, setCopiedMessage] = useState('');
  const [clickedUpArrowIndex, setClickedUpArrowIndex] = useState(null);
  const [clickedDownArrowIndex, setClickedDownArrowIndex] = useState(null);
  const [clickedColumn, setClickedColumn] = useState(null);
  const [clickedArrows, setClickedArrows] = useState({});
  const [pressed, setPressed] = useState(false);
  const [user_fill_action,set_user_fill_action] = useState(true)
  const [mul_sub_index_list,set_mul_sub_index_list] = useState([])
  const [filter_cf_index_list,set_filter_cf_index_list] = useState([])
  const [retryAttempt, setRetryAttempt] = useState(1);
  const [loading,setLoading] = useState(false);
  const [loading2,setLoading2] = useState(false);
  const location = useLocation();
  const [submit_button_list,set_submit_button_list] = useState([])
  const queryParams = new URLSearchParams(location.search);
  const [disp_form_submit_msg,enable_disp_form_submit_msg] = useState(false)

  const [TimeVisible,SetTimeVisible] = useState(false)
  const [HoursTimeVisible,SetHoursTimeVisible] =useState(false)
  let [curr_time_pick_mess_indx,setCurr_time_pick_mess_indx] = useState(null);
  let [curr_time_pick_form_indx,setCurr_time_pick_form_indx] = useState(null);
  let [curr_time_pick_ques_indx,setCurr_time_pick_ques_indx] = useState(null);
  let [curr_time_pick_form_type,setCurr_time_pick_form_type] = useState(null);
  let [curr_time_pick_is_multi,setCurr_time_pick_is_multi] = useState(null);
  let [curr_time_pick_sub_form_indx,setCurr_time_pick_sub_form_indx] = useState(null);
  const [hour_value,setHourVal] = useState('')
  const [min_value,setMinVal] = useState('')
  let [timepickvar,setTimepickvar] = useState(null);
  let [CurrBulkUplFormType,setCurrBulkUplFormType]  = useState(false);
  const liveDate = new Date();

  // Declare timeoutId state variable
  const [timeoutId, setTimeoutId] = useState(null);

  // State to store loading state and response details for each input field
  const [PsaValMap, setPsaValMap] = useState({});
  const [valid_check,set_valid_check] = useState(true)
  const [psa_val_submit,set_psa_val_submit] = useState(false)
  const handleSort = (cf_indx, each_cf, order) => {
      ////console.log("cf_indx, each_cf, order::::::",cf_indx, each_cf, order)
    setClickedArrows((prevState) => {
      const newOrder = prevState[each_cf.cf_key] === order ? '' : order;
      ////console.log("newOrder ::",newOrder)
      if (newOrder !== ''){
        ////console.log(" Check 1")
        changeOrder(cf_indx, each_cf, 'task_custom_field', each_cf.cf_key, each_cf.cfm_id, each_cf.seq_id, order);
      } else{
        changeOrder(cf_indx, each_cf, 'task_custom_field', each_cf.cf_key, each_cf.cfm_id, each_cf.seq_id, newOrder);
      }
      return {
        ...prevState,
        [each_cf.cf_key]: newOrder,
      };
    });
  };
  

  const handleCopyClick = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy);
    props.triggerNotification('success', 'Copied to clipboard!',1000);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    
  };
  
  const sendmsg = (msg) => {
    sendApi(msg.msg, msg.msg_id, 'widget')
  }
  const sendmsg_text = (msg, msg_id)  =>{
    sendApi(msg, msg_id, 'text')
  }

  const sendApi = (msg, msg_id, type) => {
    setSendMsgLoader(true);
    try{
      let payloadGM = {
        token: localStorage.getItem('vector_token'),
        to: 'vector',
        message: msg,
        chat_type: type,
        message_id: msg_id,
        channel:"UI Chat"
      }

      botHttpClient.post('/getUiBotappmessage',payloadGM )
        .then(respBody => {
          let response = respBody.data;
          setSendMsgLoader(false);
          if (response.status) {
            // ////console.log("send msg success")
          } else {
            // ////console.log("send msg error")
          }
        })
        .catch(error => {
          console.error('sm Error 1:', error);
          setSendMsgLoader(false);
        });
    } catch (error) {
      setSendMsgLoader(false);
      console.error('sm Error 2:', error);
    }
  }
  const handleHover = () => {
    setHovered(true);
  };

  const handleLeave = () => {
    setHovered(false);
  };

  const handleImageClick = (imageURL) => {
    // Set the selected image URL when an image name is clicked
    setSelectedImage(imageURL);
  };

  const handleImageHover = (imageURL) => {
    // Set the selected image URL on hover for displaying a larger version
    setSelectedImage(imageURL);
  };
  

  const [selectedImageIndex, setSelectedImageIndex] = useState(-1);

  const handleCountClick = () => {
    setSelectedImageIndex(-1); // Reset selected index to show all images
  };


  const getMsgList = () => {
    setGetMsgListLoader(true);
    try{
      let payloadGM = {
        token: localStorage.getItem('vector_token'),
        to: 'vector',
        limit: 30,
      }

      httpClient.post('/getInitialMessages',payloadGM )
        .then(respBody => {
          let response = respBody.data;
          setGetMsgListLoader(false);
          setwidgets(response.data['widget']);
          setNormalmsg(response.data['normal']);
        })
        .catch(error => {
          console.error('getMsgList Error 1:', error);
          setGetMsgListLoader(false);
        });
    } catch (error) {
      setGetMsgListLoader(false);
      console.error('getMsgList Error 2:', error);
    }
  }

  const last_widg_has_notification = (input_data) => {
    let prev_succ = 'prev_success_notification' in input_data['data'] ? true : false
    if(prev_succ){
      // ////console.log("notification :: ",input_data['data']['prev_success_notification']);
      props.triggerNotification('success',input_data['data']['prev_success_notification']);
    }
  }
  const [filledRows, setFilledRows] = useState([]);

  const handleFillRow = (blockSno) => {
    // Toggle the filled status of the row
    setFilledRows((prevFilledRows) => {
      const isFilled = prevFilledRows.includes(blockSno);
      if (isFilled) {
        return prevFilledRows.filter((row) => row !== blockSno);
      } else {
        return [...prevFilledRows, blockSno];
      }
    });
  };

  const refresh_form = () => {
    SetWholePageLoad(true);
    refreshPSaVal();
    try{
      let payloadGM = {
        token: localStorage.getItem('vector_token'),
        form_id : props.trigger_form_data.type_id,
        form_link_conf: props.trigger_form_data.form_link_conf,
        batch_id : props.batch_id,
        stage_id : props.stage_id,
        batch_task_id : props.batch_task_id
      }

      botHttpClient.post('/get-form-response',payloadGM )
        .then(respBody => {
          let response = respBody.data;
          //console.log("\n\nget-form-response resp refresh: ",response,response.status)
          if(response.status){
            // ////console.log("ch1")
            console.log('response data :: ',response)
            
            SetWholePageLoad(false);
            setwidgets([response.data]);
            setMessage(response.data);
            last_widg_has_notification(response.data);
            last_widg_has_multiple_subform(response.data["data"]);
            check_pre_filled_response_for_validation(response.data)
          }else{
            props.triggerNotification('warning', 'Something went wrong!');
          }
        })
        .catch(error => {
          console.error('sm Error 1:', error);
          SetWholePageLoad(false);
        });
    } catch (error) {
      SetWholePageLoad(false);
      console.error('sm Error 2:', error);
    }
  }

  const handleRetry = () => {
    // Reset retry attempt count and retry fetching data
    if(retryAttempt != 0){
      setRetryAttempt(0);
      refresh_form();
    }
  };

  useEffect(() => {
    refresh_form();
    console.log('location ',location)
    enable_disp_form_submit_msg(false)
  }, [props.trigger_form_data.type_id]
  );

  useEffect(() => {
    // console.log("\n\n\n CURR_MULTI_SUBFORM_Q1_TOGGLE value updated");
    // console.log("\n\n\ncheck batch :: ",props.batch_id,props.stage,props.batch_task_id);
    if(props.batch_id && props.stage && props.batch_task_id){
      // console.log("\n\nbatch yes");
      onFixedMasterSearch(message_index,1);
    }
    }, [CURR_MULTI_SUBFORM_Q1_TOGGLE]
  );

  function displayCurTime(ref){
    let new_time = new Date();
    // ////console.log("time ",ref, " :: ",new_time,new_time.getMilliseconds());
  }
  function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
}


  const handleAllInOneResp = (formIndex, QuesIndx, Response,form_type,mul_sub_index = null,file_data = null,ques_id = null,ques = null,free_text = null,ques_response = null,is_mul_sub = false) => {
    // console.log("\n\n\nform_type :: ",formIndex, QuesIndx, Response,typeof(Response));
    // console.log('form type :: ',form_type)
    console.log('response check :: ',Response)
    // console.log('ques info :; ',ques)
    // console.log('resp value :: ',Response.target.value)
    set_user_fill_action(false)
    const temp_mul_sub_index_list = [...mul_sub_index_list]
    if(mul_sub_index!=null){
      temp_mul_sub_index_list.push(mul_sub_index)
    }
    const uniqueIndexList = Array.from(new Set(temp_mul_sub_index_list));

    ////console.log('mul sub index :: ',uniqueIndexList)
    set_mul_sub_index_list(uniqueIndexList)
    let temp_resp = Response;
    ////console.log('response :: ',Response)
    if(form_type !== 'multi_subform'){
      
      if([7,8,11].includes(message.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx].free_text)){
        temp_resp = (Response ? Response.id : "");
      }else if([9].includes(message.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx].free_text)){
        // //console.log("cond pass1")
        if(Response){
          
          const dateObject = new Date(Response);
          const hours = dateObject.getHours().toString().padStart(2, '0');
          const minutes = dateObject.getMinutes().toString().padStart(2, '0');
          // //console.log("cond pass2 :: ",dateObject,hours,minutes);
          temp_resp = `${hours}:${minutes}`;
          console.log('temp resp :: ',temp_resp)
        }else{
          temp_resp = "";
        }
      }else{
        // pass
      }
      // //console.log("temp_resp :: ",temp_resp);
      setMessage((prevMessage) =>
        produce(prevMessage, (draft) => {
          if(file_data == null){
            // console.log('initialising time response :: ',temp_resp)
            draft.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx].response = temp_resp;
          }else{
            draft.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx].user_resp_files.push(file_data);
          }
        })
      );
      // //console.log("\n\temp_resp :: ",temp_resp)
      if([7, 8, 11].includes(message.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx].free_text)){
        onOptionSelect(message.data.form_list[formIndex].ques_resp_list.data.list,
          message.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx],
          message_index,
          formIndex,
          QuesIndx,
          Response,
          'all_in_one')
      }
      // console.log('ques_id, freee text, response :: ',ques_id,free_text,Response)
      const valid_check = validate_response_format(ques_id,ques,free_text,Response,false)
      // console.log('all in one valid check :: ',valid_check)
      if(message.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx].free_text == 9){
        Response = temp_resp
      }
      if(message.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx].validator && valid_check !='error' && Response != 'NaN:NaN'){
        debouncedhandlePsaValidator(message.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx].validator,Response,formIndex, QuesIndx,mul_sub_index,message.data.form_list[formIndex].ques_resp_list.data.list[QuesIndx],'all_in_one_input',message.data.form_list[formIndex]);
      }

    }else{
      if([7, 8, 11].includes(CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx].free_text)){
        temp_resp = (Response ? Response.id : "");
      }else if([9].includes(CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx].free_text)){
        if(Response){
          const dateObject = new Date(Response);
          const hours = dateObject.getHours().toString().padStart(2, '0');
          const minutes = dateObject.getMinutes().toString().padStart(2, '0');
          temp_resp = `${hours}:${minutes}`;
        }else{
          temp_resp = "";
        }
      }else{
        // pass
      }
      // //console.log("multi temp_resp :: ",temp_resp);
      if([7, 8, 11].includes(CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx].free_text)){
        onOptionSelect(CURR_MULTI_SUBFORM_TEMP[mul_sub_index],
          CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx],
          message_index,
          formIndex,
          QuesIndx,
          Response,
          'all_in_one',
          true,
          mul_sub_index)
      }
      // displayCurTime("t2")
      setCURR_MULTI_SUBFORM_TEMP((prevMessage) =>
        {
          if(file_data == null){
            const updatedCURR_MULTI_SUBFORM_TEMP = produce(prevMessage, (draft) => {
              draft[mul_sub_index][QuesIndx]['response'] = temp_resp;
            });
            on_multi_subform_row_update(mul_sub_index,updatedCURR_MULTI_SUBFORM_TEMP[mul_sub_index]);
            return updatedCURR_MULTI_SUBFORM_TEMP;
          }
          else{
            const updatedCURR_MULTI_SUBFORM_TEMP = produce(prevMessage, (draft) => {
              draft[mul_sub_index][QuesIndx]['response'] = file_data;
            });
            on_multi_subform_row_update(mul_sub_index,updatedCURR_MULTI_SUBFORM_TEMP[mul_sub_index]);
            return updatedCURR_MULTI_SUBFORM_TEMP;
          }
          
          }
        );
      if(CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx].validator != null){
        let temp_form_indx = (message['data']['bulk_ques_resp_list']['q1_toggle']) ? (
          // CURR_MULTI_SUBFORM_TEMP[mul_sub_index][0].response
          mul_sub_index
        ) : (
          mul_sub_index
        );
        let custom_form_data = {
          form_data : message['data']['form_list'][0],
          ques_resp : CURR_MULTI_SUBFORM_TEMP[mul_sub_index]
        };
        // console.log('cehck block :: ',CURR_MULTI_SUBFORM_TEMP)
        const mul_sub_valid_check = validate_response_format(ques_id,ques,free_text,Response,true,mul_sub_index)
        // console.log('multi sub valid check :: ',mul_sub_valid_check)
        if(CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx].free_text == 9){
          Response = temp_resp
        }
        if(mul_sub_valid_check!= 'error' && Response != 'NaN:NaN' && CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx].validator){
          debouncedhandlePsaValidator(CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx].validator,Response,temp_form_indx, QuesIndx,mul_sub_index,CURR_MULTI_SUBFORM_TEMP[mul_sub_index][QuesIndx],'multi_subform_input',custom_form_data);
        }
        
      }
    }
      

  };


  // Debounced function to delay API calls while user is typing
  const debouncedFetchOptions = debounce(refresh_option, 500);


  function reloadOptions(req_type,ques_list,ques,mess_indx,formIndex,ques_indx,curr_resp,form_type,is_multiple_subform = false,mul_sub_index = null){
    // console.log("\n\n\n\nreloadOptions :: ",req_type,curr_resp);
    ////console.log('ques :: ',ques)
    if(req_type !== 'search'){
      refresh_option(req_type,ques_list,ques,mess_indx,formIndex,ques_indx,curr_resp,form_type,undefined,is_multiple_subform,mul_sub_index);
    }else{
      debouncedFetchOptions(req_type,ques_list,ques,mess_indx,formIndex,ques_indx,curr_resp,form_type,undefined,is_multiple_subform,mul_sub_index);
    }
  }

  function get_ques_resp_map(ques_list,ques,form_type,temp_resp = "empty_response"){ // instead of null - it has changed to empty_response because of current value updation when user clears the master response
    // console.log("\n temp_resp on select :: ",temp_resp);
    let quest_id_resp_map = {}
    if (form_type ==='all_in_one'){
      for (let i = 0; i < ques_list.length; i++) {
        quest_id_resp_map[String(ques_list[i]["ques_id"])] = (temp_resp != 'empty_response' ? (temp_resp ? temp_resp.id : '') : ques_list[i]["response"]);
      }
      // console.log("multi form quesidrespmap :: ",quest_id_resp_map);
    }else{
      quest_id_resp_map[ques["ques_id"]] =  (temp_resp != 'empty_response' ? (temp_resp ? temp_resp.id : '') : ques["response"]);
    }
    return quest_id_resp_map
  }



  function check_for_master_cf(ques,signle_opt_resp,is_multiple_subform,mess_indx,formIndex,ques_indx,mul_sub_index){
    ////console.log("check :: ",signle_opt_resp)
    if("master_cust_fields" in ques){
      // // ////console.log("sss")
      try{
        let payloadTCV = {
          token: localStorage.getItem('vector_token'),
          task_id:signle_opt_resp,
          cf_key_list:ques['master_cust_fields'],
          ques_id: ques['ques_id']
        }
  
        httpClient.post('/task/getTaskCustomFiledsValue',payloadTCV )
          .then(respBody => {
              let res = respBody.data;
              ////console.log("master cf res :: ",res)
              if(res.status){
                if(!is_multiple_subform){
                  setMessage((prevMessage) =>
                    produce(prevMessage, (draft) => {
                      draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['master_cf_value_pairs'] = res.data;
                    })
                  );
                }else{
                  CURR_MULTI_SUBFORM_TEMP[mul_sub_index][ques_indx]['master_cf_value_pairs'] = res.data 
                }
              }
            }).catch(error => {
              console.error('getTaskCustomFiledsValue Error 1:', error);
            });
        } catch (error) {
          console.error('getTaskCustomFiledsValue Error 2:', error);
        }
    }
    return true
  }

function load_master_options(ques_indx,master_list,form_type){
    let new_opt_list = [];
    let alph_no = 1;
    return new Promise((resolve, reject) => {
      if(master_list.length > 0){
        for (let k = 0; k < master_list.length; k++) {
          // if(ques['option_as_no'])
          let new_opt;
          if (form_type ==='all_in_one'){
            new_opt = {"id":master_list[k]['option_id'], "val": master_list[k]['option_value'],"as": [String(ques_indx + 1) + "," + String(alph_no)] };
          }
          else{
            new_opt = { "id":master_list[k]['option_id'],"val": master_list[k]['option_value'],"as": [String(k+1)] };
          }
          new_opt_list.push(new_opt);
          alph_no += 1;
          if(k == master_list.length -1){
            resolve(new_opt_list);
          }
        }
      }else{
        resolve(new_opt_list);
      }
    });
  }

async function refresh_option(req_type,ques_list,ques,mess_indx,formIndex,ques_indx,curr_resp,form_type,ques_reps_map,is_multiple_subform = false,mul_sub_index = null){
    // //console.log("inside refresh_option",ques['free_text'],req_type,curr_resp)
    if((ques['free_text'] === 7 || ques['free_text'] === 8  || (ques['free_text'] === 8 && req_type === 'search') || (ques['free_text'] === 11 && req_type === 'search')) && ((req_type !== 'search' && (((typeof curr_resp) === 'boolean' && curr_resp) || ((typeof curr_resp) === 'string' && curr_resp === ''))) || (req_type === 'search' ) || (req_type === 'refresh' )) ){
      ////console.log("pass refresh_option")
      if(req_type !== 'search'){
        curr_resp = '' //event give boolean
        ////console.log('ping condition')
      }
      let quest_id_resp_map = null
      // ////console.log("ques_reps_map :: ",ques_reps_map)
      if(ques_reps_map !== undefined){
        quest_id_resp_map = ques_reps_map
      }else{
        quest_id_resp_map = get_ques_resp_map(ques_list,ques,form_type)
        // console.log("quest_id_resp_mapss :: ",quest_id_resp_map)
      }
      let child_inst_ref = null;
      if(!is_multiple_subform){
        child_inst_ref = ques["cf_instance_id"]
      }else{
        child_inst_ref = message['data']['bulk_ques_resp_list']['subform_cf_instance_id'];
      }
      try{
        let payloadGM = {
          phone:null,
          token:localStorage.getItem('vector_token'),
          search_key: curr_resp,
          quest_id: ques["ques_id"],
          instance_id:child_inst_ref,
          form_id:ques["form_id"],
          quest_id_resp_map:quest_id_resp_map,
          no_of_opt_limit:true,
          resp_type:ques['free_text'],
          is_multi_subform:is_multiple_subform,
          mul_subform_indx:mul_sub_index,
          search_map_need : true
        }
        const respBody = await httpClient.post('/bot/QuestResponseRefresh', payloadGM);

            ////console.log("\n\n\n\n\nresp QuestResponseRefresh :: ",respBody,form_type,is_multiple_subform);
            let resp = respBody.data;
            
            let master_list = resp["data"]["master_task_list"];
            let new_opt_list = await load_master_options(ques_indx,master_list,form_type);
            // Example using closure
            const updatedOptList = [...new_opt_list];
            // //console.log('updated option :: ',updatedOptList)
            if (form_type ==='all_in_one'){
              ////console.log('all in one')
              if(!is_multiple_subform){
                setMessage((prevMessage) =>
                  produce(prevMessage, (draft) => {
                    draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['options'] = updatedOptList;
                  })
                );
                // if(updatedOptList.length == 0){
                //   setMessage((prevMessage) =>
                //   produce(prevMessage, (draft) => {
                //     draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['response'] = '';
                //     draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['master_cf_value_pairs'] = []
                //   })
                // );
                // }
              }else{
                setCURR_MULTI_SUBFORM_TEMP((prevList) => {
                  const newList = [...prevList];
                  newList[mul_sub_index] = [...newList[mul_sub_index]];
                  newList[mul_sub_index][ques_indx] = { ...newList[mul_sub_index][ques_indx], 'options': updatedOptList };
                  return newList;
                });

              //   if(updatedOptList.length == 0){
              //     setCURR_MULTI_SUBFORM_TEMP((prevList) => {
              //       const newList = [...prevList];
              //       newList[mul_sub_index] = [...newList[mul_sub_index]];
              //       newList[mul_sub_index][ques_indx] = { ...newList[mul_sub_index][ques_indx], 'master_cf_value_pairs': [] };
              //       return newList;
              //     });
              //   }
              }
              if(req_type === 'refresh' && new_opt_list.length === 1 && ques['auto_select_single']){
                ////console.log('referesh aut selcct check :: ',ques)
                check_for_master_cf(ques,new_opt_list[0]['id'],is_multiple_subform,mess_indx,formIndex,ques_indx,mul_sub_index)
                if(!is_multiple_subform){
                  setMessage((prevMessage) =>
                    produce(prevMessage, (draft) => {
                      draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['response'] = new_opt_list[0]['id']
                      ////console.log('draft 1 :: ',draft)
                    })
                  );
                }else{
                  const updatedResponses = [...CURR_MULTI_SUBFORM_TEMP];
                  updatedResponses[mul_sub_index][ques_indx]['response'] = new_opt_list[0]['id']
                  setCURR_MULTI_SUBFORM_TEMP(updatedResponses);
                  on_multi_subform_row_update(mul_sub_index)
                }
              }
            }else{
              setMessage((prevMessage) =>
                  produce(prevMessage, (draft) => {
                    draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['options'] = updatedOptList;
                    ////console.log('draft 2 :: ',draft)
                  })
                );
              if(req_type === 'refresh' && new_opt_list.length === 1 && ques['auto_select_single']){
                ////console.log('autoselct cehck :: ',ques)
                setMessage((prevMessage) =>
                  produce(prevMessage, (draft) => {
                    draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['response'] = new_opt_list[0]['id']
                    ////console.log('draft 3 :: ',draft)
                  })
                );
              }
            }
      } catch (error) {
        console.error('QuestResponseRefresh Error 12:', error);
      }
    }
  }
  

  function get_selected_master_cf(ques,mess_indx,formIndex,ques_indx,is_multiple_subform = false,mul_sub_index = null,response = null){
    if('master_cust_fields' in ques){
      try{
        let payloadTCV = {
          token: localStorage.getItem('vector_token'),
          task_id:response,
          cf_key_list:ques['master_cust_fields'],
          ques_id: ques['ques_id']
        }
        httpClient.post('/task/getTaskCustomFiledsValue',payloadTCV )
          .then(respBody => {
            ////console.log('resp body :: ',respBody)
            let res = respBody.data;
            ////console.log("master cf res :: ",res)
            if(res.status){
              if(!is_multiple_subform){
                setMessage((prevMessage) =>
                  produce(prevMessage, (draft) => {
                    draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['master_cf_value_pairs'] = res.data;
                  })
                );
              }else{
                setCURR_MULTI_SUBFORM_TEMP((prevList) => {
                  const newList = [...prevList];
                  newList[mul_sub_index] = [...newList[mul_sub_index]];
                  newList[mul_sub_index][ques_indx] = { ...newList[mul_sub_index][ques_indx], 'master_cf_value_pairs': res.data };
                  return newList;
                });
              }
            }
          }).catch(error => {
            console.error('getTaskCustomFiledsValue Error 1:', error);
          });
        } catch (error) {
          console.error('getTaskCustomFiledsValue Error 2:', error);
        }
      }
  }

  function onOptionSelect(ques_list,ques,mess_indx,formIndex,ques_indx,curr_resp,form_type,is_multiple_subform = false,mul_sub_index = null){
    // console.log("on option selected :: ",form_type)
    if(ques['free_text'] === 7){
      let quest_id_resp_map = get_ques_resp_map(ques_list,ques,form_type,curr_resp);
      if ("is_master_ques" in ques){
        if (form_type ==='all_in_one'){
          for (let k = 0; k < ques_list.length; k++) {
            let edit_task_hint = ""
            if("edit_task_conf" in ques_list[k]){
              let payload = {
                phone:null,
                token:localStorage.getItem('vector_token'),
                form_id:ques_list[k]['form_id'],
                ques_id:ques_list[k]['ques_id'],
                instance_id:ques_list[k]['cf_instance_id'],
                edit_task_conf:ques_list[k]['edit_task_conf'],
                quest_id_resp_map : quest_id_resp_map
              }
              try{
                httpClient.post('/bot/hintEditTaskPfa',payload )
                  .then(respBody => {
                    let res = respBody.data;
                    edit_task_hint = res.data
                    let new_hint_format = " <span style='font-style: italic;'>Current Value : " + edit_task_hint + "</span>"
                    if(!is_multiple_subform){
                      setMessage((prevMessage) =>
                        produce(prevMessage, (draft) => {
                          draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][k]['edit_task_hint'] = new_hint_format
                          draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][k]['edit_task_hint_val'] = edit_task_hint
                          if(draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][k]['overwrite_resp_flag'] && edit_task_hint.length ){
                            draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][k]['response'] = edit_task_hint
                          }
                        })
                      );

                    }else{
                      setCURR_MULTI_SUBFORM_TEMP((prevList) => {
                        const newList = [...prevList];
                        newList[mul_sub_index] = [...newList[mul_sub_index]];
                        newList[mul_sub_index][k] = { ...newList[mul_sub_index][k], 
                          'master_cf_value_pairs': res.data,
                          'edit_task_hint_val': edit_task_hint };
                        if(CURR_MULTI_SUBFORM_TEMP[mul_sub_index][k]['overwrite_resp_flag'] && edit_task_hint.length){
                          newList[mul_sub_index][k] = { ...newList[mul_sub_index][k], 
                            'response':edit_task_hint };
                          on_multi_subform_row_update(mul_sub_index);
                        }
                        return newList;
                      });
                    }
                  })
                  .catch(error => {
                    console.error('hintEditTaskPfa Error 1:', error);
                  });
                } catch (error) {
                  console.error('hintEditTaskPfa Error 2:', error);
                }
            }
          }
        }
      }
      if ('refresh_after_resp' in ques){
        if (form_type ==='all_in_one'){
          if(ques_indx < ques_list.length - 1){
            for (let k = ques_indx + 1; k < ques_list.length; k++) {
              // if(k !== ques_indx && !('refresh_after_resp' in ques_list[k])){
                refresh_option('refresh',ques_list,ques_list[k],mess_indx,formIndex,k,'','all_in_one',quest_id_resp_map,is_multiple_subform,mul_sub_index)
              // }
            }
          }
        }
      }
      ////console.log('curr_resp :: ',curr_resp)
      if(curr_resp!=null){
        get_selected_master_cf(ques,mess_indx,formIndex,ques_indx,is_multiple_subform,mul_sub_index,curr_resp['id'])
      }
      else{
        get_selected_master_cf(ques,mess_indx,formIndex,ques_indx,is_multiple_subform,mul_sub_index,null)
      }
      ////console.log('ques check :: ',ques)
    }
    if(is_multiple_subform){
      on_multi_subform_row_update(mul_sub_index)
      // no multi as for now
    }
  }

  function formsubMit(data, msg_id,submit_type,btn_index) {
    // ////console.log("\n\n\n\nform submit check :: ",data)
    // if(!submit_button_list.includes(btn_index)){
    //   setCurr_submit_load_flag(false)
    // }
    setLoading(true);
    //console.log('curr submit load flag :: ',curr_submit_load_flag)
    if(!curr_submit_load_flag || !submit_button_list.includes(btn_index)){
      // //console.log("formed submit check")
      dirrect_submit_single_primary_form(data,btn_index,submit_type)
    }else{
      // ////console.log("submit ignored")
    }
    // const temp_button_list = [...submit_button_list]
    // temp_button_list.push(btn_index)
    // set_submit_button_list(temp_button_list)
  }

  function get_resp_check_non_multi_sub(ques_block){
    let resp = ''
    let file_list = [];
    if (
      ques_block.options.length === 0 &&
      ques_block.free_text >= 1
    ) {
      if (ques_block['response'] !== '') {
        resp = ques_block['response']
      }
    } else if (
      ques_block.options.length !== 0 &&
      (ques_block.free_text < 1 || ques_block.free_text === 7 || ques_block.free_text === 8 || ques_block.free_text === 11)
    ) {
      if (ques_block['response'] !== '') {
        resp = ques_block['response'];
      }
    } else if (ques_block.file_upload === 1) {
        file_list = ques_block['user_resp_files']
    } else {
      resp = ques_block['response']
    }
    // ////console.log("\n\n check :: ",ques_block.free_text,resp)
    return {"resp":resp,"file_list":file_list}
  }

  function closeAfterSubmit(){
    // ////console.log("\n\nclose after submit trigger")
    //console.log('')
    props.CloseWidget(props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index);
  }



  function dirrect_submit_single_primary_form(data,submit_button_index,submit_type){
    setLoading(true);
    setCurr_submit_load_flag(true);
    let whole_struct = [];
    for (let k = submit_button_index; k < data.length; k++) {
      let forms_data = data[k];
      let ques_block_list = data[k]['ques_resp_list']['data']['list']
      let temp_cf_instance_id = forms_data["cf_instance_id"]
      //console.log('variable is initialised here ')
        
      let new_form = {
            form_type : "form", 
            form_id : ques_block_list[0]['form_id'],
            cf_instance_id : temp_cf_instance_id,
            ques_list : []
          }

      for (let i = 0; i < ques_block_list.length; i++) {
        let response_data = get_resp_check_non_multi_sub(ques_block_list[i])
        // console.log("response_data ::",response_data)
        let resp = response_data["resp"]
        let file_list = response_data["file_list"]
        new_form.ques_list.push({
                            ques_id : ques_block_list[i]['ques_id'],
                            resp_type : ques_block_list[i].free_text,
                            response : resp,
                            file_list : file_list,
                            file_upload_flag : ques_block_list[i].file_upload,
                            task_id : ques_block_list[i].task_id,
                            revision : ques_block_list[i].revision,
                            contrib_id : ques_block_list[i].contrib_id,
                            custom_field : ques_block_list[i].custom_field,
                            scope : ques_block_list[i].scope,
                            task_assct_flag : ques_block_list[i].task_assct_flag
                          })
        }
      whole_struct.push(new_form)
    }
    let out_resp = {}
    out_resp[SPECIAL_SUBMIT_NON_MUTLI] = whole_struct
    // ////console.log("whole_struct :: ",whole_struct)
    //console.log('batch id :: ', props.batch_id)
    try{
      let payload = {
        token: localStorage.getItem('vector_token'),
        response : out_resp,
        batch_id : props.batch_id,
        stage_id : props.stage_id,
        batch_task_id : props.batch_task_id
      }
      let temp_form_data = data[0];
      // console.log('psa val submit prim all in one ::  ',psa_val_submit)
      let valid_status = false
      if(temp_form_data.validator){
        let temp_submit_type = ('form_submit_' + ((submit_type == 'normal_sumbit') ? 'form' : 'subform'))
        // status =  handlePsaValidator(temp_form_data.validator,'form_submit', 'form', temp_form_data['form_id'], null, temp_form_data,temp_submit_type,temp_form_data );
        let inputId = ('form_'+temp_form_data['form_id'])
        if(!(inputId in PsaValMap)){
          setPsaValMap(previousState => ({
            ...previousState,
            [inputId]: { loading: true, status: true, value: '',timeoutId: null }
          }));
        }else{
          if(!PsaValMap[inputId].loading){
            setPsaValMap(previousState => ({
              ...previousState,
              [inputId]: { loading: true, status: true, value: '',timeoutId: null }
            }));
          }
          if(PsaValMap[inputId].timeoutId){
            clearTimeout(PsaValMap[inputId].timeoutId);
          }
        }
        const postdata={
          token: localStorage.getItem('vector_token'),
          input: temp_form_data, //resp_obj
          data_type: temp_submit_type,
          validator_info: temp_form_data.validator
        }
        httpClient.post('/bot/psaValidMiddleWare',postdata)
          .then(respBody => {
              let res = respBody.data;
              console.log(`API response for ${inputId}:`, res);
              console.log('res :: ',res)
              set_psa_val_submit(res.status)
              valid_status = res.status
              console.log('submit status :: ',valid_status)
              if (valid_status == true){
              botHttpClient.post('/uibot/submitGridRow',payload )
                .then(res => {
                  curr_submit_load_flag = false;
                  curr_submit_load_flag = true;
                  // //console.log("before submit :: ",props.triggerNotification);
                  let temp_form_data = data[0];
                  setLoading(false)
                  if(submit_button_index!=null){
                    const temp_button_list = [...submit_button_list]
                    temp_button_list.push(submit_button_index)
                    set_submit_button_list(temp_button_list) 
                    }     
                  // console.log("temp_form_data :: ",temp_form_data);
                  // if(temp_form_data.validator){
                  //   // let temp_submit_type = ('form_submit_' + ((submit_type == 'normal_sumbit') ? 'form' : 'subform'))
                  //   // handlePsaValidator(temp_form_data.validator,'form_submit', 'form', temp_form_data['form_id'], null, temp_form_data,temp_submit_type,temp_form_data );
                  //   console.log('temp form validator :: ',temp_form_data)
                  // }else{
                  //   closeAfterSubmit();
                  // }
                  // closeAfterSubmit();
                  
                  // props.disableWidgetorView(props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index) 
                  if(res.data.form_link_data!=null){
                    //console.log('type :: ',props.trigger_comp_type)
                    //console.log(' props :: ',res.data.form_link_data,props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)
                    props.submit_form(res.data.form_link_data,props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)    
                    if (props.batch_id == null){
                      props.disableWidgetorView(props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)
                    }
                         
                  }
                  else{
                    enable_disp_form_submit_msg(true);
                    if(submit_button_index!=null){
                      const temp_button_list = [...submit_button_list]
                      temp_button_list.push(submit_button_index)
                      set_submit_button_list(temp_button_list) 
                      }     
  
                  }
                  props.triggerNotification('success', 'submitted successfully');
                  // enable_disp_form_submit_msg(true);
                })
                .catch(error => {
                  console.error('submitGridRow Error 1:', error);
                })
              }
              else{
                setLoading(false)
              }
              setPsaValMap(previousState => ({
                ...previousState,
                [inputId]: {loading: false, status: res.status, value: res.data, timeoutId:null}
              }));
            }).catch(error => {
              console.error('dynApi Error 1:', error);
            });
      }
      else{
        set_psa_val_submit(false)
      }
    // console.log('valid status :: ',valid_status)
    if(temp_form_data.validator == null){
      botHttpClient.post('/uibot/submitGridRow',payload )
      .then(res => {
        setLoading(false)
        curr_submit_load_flag = false;
        curr_submit_load_flag = true;
        // ////console.log("before submit :: ",props.triggerNotification);
        console.log('submit no validator response :: ',res)
        if(res.data.form_link_data!=null){
          //console.log('type :: ',props.trigger_comp_type)
          //console.log(' props :: ',res.data.form_link_data,props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)
          props.submit_form(res.data.form_link_data,props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)    
          if (props.batch_id == null){
            props.disableWidgetorView(props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)
          }
          if(submit_button_index!=null){
            const temp_button_list = [...submit_button_list]
            temp_button_list.push(submit_button_index)
            set_submit_button_list(temp_button_list) 
            }     

               
        }
        else{
          // closeAfterSubmit();
          //console.log('call close function :: ')
          enable_disp_form_submit_msg(true)
          if(submit_button_index!=null){
            const temp_button_list = [...submit_button_list]
            temp_button_list.push(submit_button_index)
            set_submit_button_list(temp_button_list) 
            }     

        }
        // closeAfterSubmit();
        props.triggerNotification('success', 'submitted successfully');
        
        let temp_form_data = data[0];
        console.log("temp_form_data :: ",temp_form_data);
        // if(temp_form_data.validator){
        //   // let temp_submit_type = ('form_submit_' + ((submit_type == 'normal_sumbit') ? 'form' : 'subform'))
        //   // handlePsaValidator(temp_form_data.validator,'form_submit', 'form', temp_form_data['form_id'], null, temp_form_data,temp_submit_type,temp_form_data );
        //   console.log('temp form validator :: ',temp_form_data)
        // }else{
        //   closeAfterSubmit();
        // }
        
        // props.triggerNotification('success', 'submitted successfully');
      })
      .catch(error => {
        console.error('submitGridRow Error 1:', error);
      });
      }
    } catch (error) {
      console.error('submitGridRow Error 2:', error);
    }
  }

  function updateValidationobj(ques_id,validation_msg,is_mul_sub,mul_sub_indx){
    // // ////console.log("\n on update :: ",ques_id,validation_msg,is_mul_sub,mul_sub_indx)
    if(!is_mul_sub){
      ques_resp_error_msg_map['normal'][ques_id] = validation_msg
    }else{
      if(mul_sub_indx in ques_resp_error_msg_map['multiple']){
        ques_resp_error_msg_map['multiple'][mul_sub_indx][ques_id] = validation_msg
      }else{
        ques_resp_error_msg_map['multiple'][mul_sub_indx] = {}
        ques_resp_error_msg_map['multiple'][mul_sub_indx][ques_id] = validation_msg
      }
      
    }
  }

  function validate_response_format(ques_id,ques_data,resp_no,user_resp,is_mul_sub = false,mul_sub_indx = 0){
    // // ////console.log("\n\nrecent quesit ::",ques_id)
    let resp_type = get_resp_format(user_resp)
    let curr_ques_free_txt_flag = resp_no
    // // ////console.log("received resp type :: ",user_resp," :: ",resp_type,FORM_RESP_REV_DICT[curr_ques_free_txt_flag])
    let int_array = [('Positive ' + FORM_RESP_TYPE_INT),('Negative ' + FORM_RESP_TYPE_INT)] 
    let dec_arr = [('Positive ' + FORM_RESP_TYPE_INT),('Negative ' + FORM_RESP_TYPE_INT),('Negative ' + FORM_RESP_TYPE_DEC),'Positive ' + FORM_RESP_TYPE_DEC]
    let pos_dec = [FORM_RESP_TYPE_POS_DEC,('Positive ' + FORM_RESP_TYPE_INT)]
    if (curr_ques_free_txt_flag > 1 && user_resp != null && user_resp.length > 0){
        updateValidationobj(ques_id,"",is_mul_sub,mul_sub_indx)
        if ((FORM_RESP_REV_DICT[curr_ques_free_txt_flag] === FORM_RESP_TYPE_POS_NO) && (resp_type !== ('Positive ' + FORM_RESP_TYPE_INT))){
          // // ////console.log("p1")
          updateValidationobj(ques_id,("Response should  be '" + FORM_RESP_REV_DICT[resp_no] +"'"),is_mul_sub,mul_sub_indx)
          return "error"
        }    
        else if (FORM_RESP_REV_DICT[curr_ques_free_txt_flag] === FORM_RESP_TYPE_POS_DEC && pos_dec.indexOf(resp_type) === -1){
          // // ////console.log("p2")
          updateValidationobj(ques_id,("Response should  be '" + FORM_RESP_REV_DICT[resp_no] +"'"),is_mul_sub,mul_sub_indx)
          return "error"
        }
        else if (FORM_RESP_REV_DICT[curr_ques_free_txt_flag] === FORM_RESP_TYPE_INT &&  int_array.indexOf(resp_type) === -1 ){
          // // ////console.log("p3")
          updateValidationobj(ques_id,("Response should  be '" + FORM_RESP_REV_DICT[resp_no] +"'"),is_mul_sub,mul_sub_indx)
          return "error"
        }
        else if (FORM_RESP_REV_DICT[curr_ques_free_txt_flag] === FORM_RESP_TYPE_DEC && dec_arr.indexOf(resp_type) === -1 ){
          // // ////console.log("p4")
          updateValidationobj(ques_id,("Response should  be '" + FORM_RESP_REV_DICT[resp_no] +"'"),is_mul_sub,mul_sub_indx)
          return "error"
        }
        else if (FORM_RESP_REV_DICT[curr_ques_free_txt_flag] === FORM_RESP_TYPE_DATE && resp_type !== FORM_RESP_TYPE_DATE ){
          // // ////console.log("p5")
          updateValidationobj(ques_id,("Response should  be '" + FORM_RESP_REV_DICT[resp_no] +" (dd/mm/yy)'"),is_mul_sub,mul_sub_indx)
          return "error"
        }
        else if (FORM_RESP_REV_DICT[curr_ques_free_txt_flag] === FORM_RESP_TYPE_TIME && resp_type !== FORM_RESP_TYPE_TIME ){
          // // ////console.log("p5")
          updateValidationobj(ques_id,("Response should  be '" + FORM_RESP_REV_DICT[resp_no] +" (HH:MM)'"),is_mul_sub,mul_sub_indx)
          return "error"
        }
        else if (FORM_RESP_REV_DICT[curr_ques_free_txt_flag] === FORM_RESP_TYPE_TIME_IN_NO && (resp_type !== FORM_RESP_TYPE_TIME && resp_type !== FORM_RESP_TYPE_TIME_IN_NO) ){
          // // ////console.log("p5")
          updateValidationobj(ques_id,("Response should be 'hh:mm Eg : 156:50'"),is_mul_sub,mul_sub_indx)
          return "error"
        }

        if("advanced_features" in ques_data){
          // // ////console.log(" r1 :: ",user_resp,FORM_RESP_TYPE_DEC)
            let user_resp_num_val = null
            if(resp_type.includes(FORM_RESP_TYPE_DEC)){
                user_resp_num_val = parseFloat(user_resp)
            }else if(resp_type.includes(FORM_RESP_TYPE_INT)){
                user_resp_num_val = parseInt(user_resp)
            }
            
            if( user_resp_num_val != null){
              // // ////console.log(" r2 :: ",('range_data' in ques_data['advanced_features']),', r22 :: ',ques_data['advanced_features']['range_data']['isRangeTrue'],",r222 :: ",ques_data['advanced_features']['range_data']['isMin'],", r2222 :: ",ques_data['advanced_features']['range_data']['isMax'])
                if (('range_data' in ques_data['advanced_features']) && (ques_data['advanced_features']['range_data']['isRangeTrue'] && (ques_data['advanced_features']['range_data']['isMin'] || ques_data['advanced_features']['range_data']['isMax']))){
                  // // ////console.log(" r33 :: ")  
                  if(ques_data['advanced_features']['range_data']['isMin'] && ques_data['advanced_features']['range_data']['minRange'] != null && parseFloat(ques_data['advanced_features']['range_data']['minRange']) >  user_resp_num_val){
                      updateValidationobj(ques_id,("Response value should be greater than or equal to " + ques_data['advanced_features']['range_data']['minRange']),is_mul_sub,mul_sub_indx)
                      // // ////console.log(" r3 :: ")
                      return "error"
                    }
                    if(ques_data['advanced_features']['range_data']['isMax'] && ques_data['advanced_features']['range_data']['maxRange'] != null && parseFloat(ques_data['advanced_features']['range_data']['maxRange']) <  user_resp_num_val){
                      updateValidationobj(ques_id,("Response value should be lesser than or equal to " + ques_data['advanced_features']['range_data']['maxRange']),is_mul_sub,mul_sub_indx)
                      // // ////console.log(" r4 :: ")
                      return "error"
                    }
                }
                
                  // // ////console.log(" r5 :: ",('link_data' in ques_data['advanced_features']),', r55 :: ',ques_data['advanced_features']['link_data']['isLinkTrue'],",r555 :: ",ques_data['advanced_features']['link_data']['isMin'],", r5555 :: ",ques_data['advanced_features']['link_data']['isMax'])
                if(('link_data' in ques_data['advanced_features']) && (ques_data['advanced_features']['link_data']['isLinkTrue'] && (ques_data['advanced_features']['link_data']['isMin'] || ques_data['advanced_features']['link_data']['isMax']))){
                  // // ////console.log(" r6 :: ")
                  if('edit_task_conf' in ques_data){
                      if ('edit_task_hint_val' in ques_data){
                        // // ////console.log(" r77 :: ",ques_data['edit_task_hint_val'])
                        let edit_task_hint_val = ques_data['edit_task_hint_val']
                        if(edit_task_hint_val){
                          // // ////console.log(" r8 :: ",edit_task_hint_val,", r88 :: ",user_resp_num_val,", r888 ::",ques_data['advanced_features']['link_data']['minRange'])
                          edit_task_hint_val = parseFloat(edit_task_hint_val)
                            let rangeDiff = user_resp_num_val - edit_task_hint_val
                            if(ques_data['advanced_features']['link_data']['isMin'] && ques_data['advanced_features']['link_data']['minRange'] != null  && parseFloat(ques_data['advanced_features']['link_data']['minRange']) >  rangeDiff){
                              // // ////console.log(" r9 :: ",)
                              updateValidationobj(ques_id,("Difference between the current value(" + String(edit_task_hint_val) + ") and your response value should be greater than or equal to " + ques_data['advanced_features']['link_data']['minRange']),is_mul_sub,mul_sub_indx)
                              return "error"
                            }
                            if(ques_data['advanced_features']['link_data']['isMax'] && ques_data['advanced_features']['link_data']['maxRange'] != null && parseFloat(ques_data['advanced_features']['link_data']['maxRange']) <  rangeDiff){
                              // // ////console.log(" r10 :: ")
                              updateValidationobj(ques_id,("Difference between the current value(" + String(edit_task_hint_val) + ") and your response value should be lesser than or equal to " + ques_data['advanced_features']['link_data']['maxRange']),is_mul_sub,mul_sub_indx)
                              return "error"
                            }
                        }
                      }
                  }
                }
                
            }
        }
    }else if(curr_ques_free_txt_flag === 1 && user_resp.length > 0 && FORM_SUB_RESP_REV_DICT[ques_data['sub_resp_type']] !== FORM_SUB_RESP_TYPE_ALL  ){
      if(FORM_SUB_RESP_REV_DICT[ques_data['sub_resp_type']] === FORM_SUB_RESP_TYPE_FULL_NAME && (!is_full_name(user_resp))){
        updateValidationobj(ques_id,("Response format should be 'FIRSTNAME SECONDNAME' Eg : William jones"),is_mul_sub,mul_sub_indx)
        return "error"
      }else if(FORM_SUB_RESP_REV_DICT[ques_data['sub_resp_type']] === FORM_SUB_RESP_TYPE_MAIL_ID && (!is_mail(user_resp))){
        updateValidationobj(ques_id,("Response format should be 'abc@domain.xyz' Eg : johnsmith@gmail.com"),is_mul_sub,mul_sub_indx)
        return "error"
      }else if(FORM_SUB_RESP_REV_DICT[ques_data['sub_resp_type']] === FORM_SUB_RESP_TYPE_PHONE && (!is_phone_no(user_resp))){
        updateValidationobj(ques_id,("Response format should be 10 digits Eg : 8834010237"),is_mul_sub,mul_sub_indx)
        return "error"
      }else if(FORM_SUB_RESP_REV_DICT[ques_data['sub_resp_type']] === FORM_SUB_RESP_TYPE_URL && (!is_url(user_resp))){
        updateValidationobj(ques_id,("Response format should be 'https://www.example.com/' Eg : https://www.google.com/"),is_mul_sub,mul_sub_indx)
        return "error"
      }else if(FORM_SUB_RESP_REV_DICT[ques_data['sub_resp_type']] === FORM_SUB_RESP_TYPE_PHONE_WITH_CONT_CODE && (!is_phone_no_with_cont_code(user_resp))){
        updateValidationobj(ques_id,("Response format should be 10-12 digits with country code Eg : +918834010237"),is_mul_sub,mul_sub_indx)
        return "error"
      }
    }
    else{
      return 'success'
    }
    return 'success'  
  }


  function get_resp_format(resp){
    resp = String(resp)
    // // ////console.log("\n validate resp :: ",resp)
    // // ////console.log("resp :: ",resp," cond :: resp.indexOf('.') :: ",resp.indexOf('.'),",sec :: ",isdigit(resp.replace('.','').replace('-','')),", third :: ",isdigit(resp.replace('-','')))
    if(resp.indexOf('/') > -1){
      if(resp.match("^([0]?[1-9]|[1|2][0-9]|[3][0|1])[/]([0]?[1-9]|[1][0-2])[/]([0-9]{2})$")){
        return FORM_RESP_TYPE_DATE
      }
      else{
        return "Not " + FORM_RESP_TYPE_DATE
      }
    }else if(resp.indexOf(':') > -1){ //check for time
      if(resp.match("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")){
        return FORM_RESP_TYPE_TIME
      }
      else if(resp.match("^[0-9]+:[0-5][0-9]$")){
        return FORM_RESP_TYPE_TIME_IN_NO
      }
      else{
        return "Not " + FORM_RESP_TYPE_TIME
      }
    }
    else{if((resp.indexOf('.') > -1) && (isdigit(resp))){
              if((resp.indexOf('-') > -1)){
                return 'Negative ' + FORM_RESP_TYPE_DEC 
              }    
              else{
                return 'Positive ' + FORM_RESP_TYPE_DEC
              }    
            }
        else if(isdigit(resp)){
            if (resp.indexOf('-') > -1){
              return 'Negative ' + FORM_RESP_TYPE_INT
            }   
            else{
              return 'Positive ' + FORM_RESP_TYPE_INT
            }
                
        }}
            
  }

  function isdigit(str){
    return !isNaN(str) && isFinite(str) && !/e/i.test(str)
  }

  function validate_mandatory(ques){
    if( ques['mandatory'] &&
        (
          (ques['file_upload'] === 0 && (ques['response'] === '' || ques['response'] === null)) ||
          (ques['file_upload'] === 1 && ques['user_resp_files'].length === 0)
        )
      ){
        return false
      }
      return true
    }

    function get_validate_message(ques_id,resp_type,is_mul_sub,mul_sub_indx = null){
      // // ////console.log("ques_resp_error_msg_map :: ",ques_resp_error_msg_map,ques_id,is_mul_sub,mul_sub_indx)
      if(!is_mul_sub){
        if(ques_id in ques_resp_error_msg_map['normal'] && ques_resp_error_msg_map['normal'][ques_id] !== ""){
          return ques_resp_error_msg_map['normal'][ques_id]
        }
      }else{
        if(ques_resp_error_msg_map['multiple'][mul_sub_indx] && ques_id in ques_resp_error_msg_map['multiple'][mul_sub_indx] && ques_resp_error_msg_map['multiple'][mul_sub_indx][ques_id] !== ""){
          return ques_resp_error_msg_map['multiple'][mul_sub_indx][ques_id]
        }
      }
    }

    function refresh_ques_resp_error_map(){
      ques_resp_error_msg_map = {'normal':{},'multiple':{}}
    }

    function is_mail(inp){
      if(inp.match(/[a-z0-9]+@[a-z]+\.[a-z]{2,3}/g)){
        return true;
      }   
      return false;
    }

    function is_full_name(inp){
      
      if(inp.match(/^[A-Za-z]+\s[A-Za-z]+$/g)){
        return true;
      }
      return false;
    }

    function is_phone_no(inp){
      if(inp.match(/^[0-9]{10}$/g)){
        return true;
      } 
      return false;
    }

    function is_phone_no_with_cont_code(inp){
      if(inp.match(/^\+?[0-9]{10}$|^\+?[0-9]{12}$/g)){
        return true;
      } 
      return false;
    }

    function is_url(inp){
      if(inp.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)){
        return true;
      } 
      return false;
    }

    function validate_mandatory(ques){
    if( ques['mandatory'] &&
        (
          (ques['file_upload'] === 0 && (ques['response'] === '' || ques['response'] === null)) ||
          (ques['file_upload'] === 1 && ques['user_resp_files'].length === 0)
        )
      ){
        return false
      }
      return true
    }

    function have_bulk_subform(input_data){
      // // ////console.log("\n\n\n have_bulk_subform :: ",input_data)
      return 'bulk_ques_resp_list' in input_data ? true : false
    }

    function assign_multi_subform_table_width(multi_subform_list,master_cf,each_row_submit){
      let col_count = multi_subform_list[0].length;
      if(each_row_submit){
        col_count += 1;
      }
  
      let master_cf_width = 0;
      for(let i=0;i<master_cf.length;i++){
        master_cf_width += Number(master_cf[i].col_size)
      }
      // ////console.log("master_cf_width :: ",master_cf_width)
      multiSubFormWidth = (col_count * 200) + (master_cf_width)
      // ////console.log("multiSubFormWidth :: ",multiSubFormWidth)
    }

    function store_userResp_TempCacheJson_serv(multi_subform_resp_cache){
      // // ////console.log("store_userResp_TempCacheJson_serv :: ",multi_subform_resp_cache)
      localStorage.setItem("multi_subform_resp_cache",JSON.stringify(multi_subform_resp_cache));
      return true
    }

    function store_userResp_TempCacheJson(multi_subform_resp_cache){
      store_userResp_TempCacheJson_serv(multi_subform_resp_cache);
    }

    function write_all_rows_inside_response_tracker(msg_data){
      setLoading(true);
      let ques_resp_list = msg_data['bulk_ques_resp_list']['ques_block_list'];
      let single_ques_resp_temp = Object.assign([], msg_data['bulk_ques_resp_list']['ques_block_list'][0])
        // ////console.log("d2")
        if(msg_data['bulk_ques_resp_list']['q1_toggle']){
          if(ques_resp_list.length > 15){
            
                try{
                  let payload = {
                    phone:null,
                    token:localStorage.getItem('vector_token'),
                    search_key: subform_search_key,
                    quest_id: ques_resp_list[0][0]["ques_id"],
                    instance_id:msg_data['bulk_ques_resp_list']['subform_cf_instance_id'],
                    form_id:ques_resp_list[0][0]["form_id"],
                    resp_type:ques_resp_list[0][0]["free_text"],
                    ques_resp_list_struct : single_ques_resp_temp,
                    construct_for_submit_flag : false,
                    already_exist_resp : null,
                    page_no : 1,
                    master_filter_list : null,
                    master_order_list : null,
                    page_size : FETCH_ALL_LIMIT,
                    batch_id : props.batch_id,
                    stage_id : props.stage_id,
                    stage : props.stage,
                    batch_task_id : props.batch_task_id
                  }
                  httpClient.post('/bot/searchMultiSubformFixedMaster',payload )
                  .then(response => {
                    let resp = response.data;
                    setLoading(false);
                    if(resp["data"].length > 0){
                      let multi_subform_resp_cache = {};
                      for(let i=0;i < resp["data"].length;i++){
                        let key = resp["data"][i][0]['response'];
                        multi_subform_resp_cache[String(key)] = resp["data"][i];
                      }
                      // ////console.log("searchMultiSubformFixedMaster all :: ",multi_subform_resp_cache)
                      store_userResp_TempCacheJson(multi_subform_resp_cache)
                    }
                  })
                  .catch(error => {
                    console.error('submitGridRow Error 1:', error);
                  });
                } catch (error) {
                  console.error('submitGridRow Error 2:', error);
                }
          }
          else{
            // ////console.log("d3 :: ",ques_resp_list.length)
            let multi_subform_resp_cache = {};
            for(let i=0;i < ques_resp_list.length;i++){
              let key = ques_resp_list[i][0]['response'];
              multi_subform_resp_cache[String(key)] = ques_resp_list[i];
            }
            // ////console.log("multi_subform_resp_cache :: ",multi_subform_resp_cache)
            store_userResp_TempCacheJson(multi_subform_resp_cache)
          }
        }else{
          // ////console.log("d3 :: ",ques_resp_list.length)
            let multi_subform_resp_cache = {};
            for(let i=0;i < ques_resp_list.length;i++){
              let key = i;
              multi_subform_resp_cache[String(key)] = ques_resp_list[i];
            }
            // ////console.log("multi_subform_resp_cache :: ",multi_subform_resp_cache)
            store_userResp_TempCacheJson(multi_subform_resp_cache)
        }
    }

    function filter_subform_multiple(){
      setCURR_MULTI_SUBFORM_TEMP(message['data']['bulk_ques_resp_list']['ques_block_list'].filter(each_set => (each_set[0]["response_preview"].toLowerCase().includes(subform_search_key.toLowerCase()))));
    }

    function reset_multisub(){
      // ////console.log("on reset");
      for(let mcf_indx = 0;mcf_indx < message['data']['bulk_ques_resp_list']['master_cf_ordered_list'].length;mcf_indx ++ ){
        OnResetMultiSubFilters(message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][mcf_indx],mcf_indx,false)
        message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][mcf_indx]['order_by'] = ""
      }
      setcurr_master_order_by_list({"cfm":{},"seq":{}});
      setcurr_master_filter_list({"cfm":{},"seq":{}});
      setTimeout(() => {
        setmultisub_page_no(1);
        onFixedMasterSearch(message_index,1,15);
      }, 500);
    }

    function refresh_mutiSub(){
      // ////console.log("on refresh :: ");
      setmultisub_page_no(1);
      onFixedMasterSearch(message_index,1);
    }

    function OnResetMultiSubFilters(cf_data,cf_indx,refresh_flag = true){
      const updatedmessage = {...message};
      updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]['filter_visible'] = false;
      if('selected_filters' in cf_data){
        let tempcurr_master_filter_list = {...curr_master_filter_list};
        for(let mcf_indx = 0;mcf_indx < cf_data.selected_filters.length;mcf_indx ++ ){
          if(cf_data.cfm_id){
            if(cf_data.cfm_id in curr_master_filter_list["cfm"] ){
              tempcurr_master_filter_list["cfm"][cf_data.cfm_id] = []
            }
          }
          if(cf_data.seq_id){
            if(cf_data.seq_id in curr_master_filter_list["seq"]){
              tempcurr_master_filter_list["seq"][cf_data.seq_id] = []
            }
          }
        }
        setcurr_master_filter_list(tempcurr_master_filter_list);
      }
      updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]['selected_filters'] = []
      setMessage(updatedmessage);
      if(refresh_flag){
        setmultisub_page_no(1);
        onFixedMasterSearch(message_index);
      }

      let temp_cf_filter_index = [...filter_cf_index_list]
      if(temp_cf_filter_index.includes(cf_indx)){
          temp_cf_filter_index = temp_cf_filter_index.filter((item) => item != cf_indx)
      }
      const unique_filter_cf_index_list =  Array.from(new Set(temp_cf_filter_index));   
      ////console.log('unique filter index :: ',unique_filter_cf_index_list)   
      set_filter_cf_index_list(unique_filter_cf_index_list)

    }

    function triggerMasterSearch(message_index){
      setmultisub_page_no(1);
      onFixedMasterSearch(message_index,1,null,null);
    }

    function onFixedMasterSearch(mess_indx,temp_page_no = null,temp_page_size = null,temp_order_by = null,temp_filter = null){
      setLoading(true);
      //console.log("cccccccc",temp_page_no,CURR_MULTI_SUBFORM_Q1_TOGGLE,CURR_MULTI_SUBFORM_Q1_TOGGLE_RESP_TYPE)
      ////console.log("temp_order_by :: ",temp_order_by);
      if(CURR_MULTI_SUBFORM_Q1_TOGGLE && (CURR_MULTI_SUBFORM_Q1_TOGGLE_RESP_TYPE === 7 || CURR_MULTI_SUBFORM_Q1_TOGGLE_RESP_TYPE === 8 || CURR_MULTI_SUBFORM_Q1_TOGGLE_RESP_TYPE === 11)){
        setonTableRowLoad(true);
        //console.log("enter 1")
        let single_ques_resp_temp = Object.assign([], message['data']['bulk_ques_resp_list']['ques_block_list'][0])
        try{
          let temp_MULTI_SUB_BATCH_COUNT = temp_page_size ? temp_page_size : MULTI_SUB_BATCH_COUNT;
          let payload = {
            phone:null,
            token:localStorage.getItem('vector_token'),
            search_key: subform_search_key,
            quest_id: CURR_MULTI_SUBFORM_TEMP[0][0]["ques_id"],
            instance_id:message['data']['bulk_ques_resp_list']['subform_cf_instance_id'],
            form_id:CURR_MULTI_SUBFORM_TEMP[0][0]["form_id"],
            resp_type:CURR_MULTI_SUBFORM_TEMP[0][0]["free_text"],
            ques_resp_list_struct : single_ques_resp_temp,
            construct_for_submit_flag : false,
            already_exist_resp : null,
            page_no : temp_page_no ? temp_page_no : multisub_page_no,
            master_filter_list : temp_filter ? temp_filter : curr_master_filter_list,
            master_order_list : temp_order_by ? temp_order_by : curr_master_order_by_list,
            page_size : temp_MULTI_SUB_BATCH_COUNT,
            batch_id : props.batch_id,
            stage_id : props.stage_id,
            stage : props.stage,
            batch_task_id : props.batch_task_id
          }
          httpClient.post('/bot/searchMultiSubformFixedMaster',payload )
          .then(response => {
            let resp = response.data;
            setLoading(false);
              setonTableRowLoad(false);
              if(resp["data"].length > 0){
                let temp_pages = Math.floor(resp["data"][0][0]["total_rows"]/temp_MULTI_SUB_BATCH_COUNT)
                if(resp["data"][0][0]["total_rows"] % temp_MULTI_SUB_BATCH_COUNT !== 0){
                  temp_pages = temp_pages + 1;
                }
                setCURR_MULTI_SUBFORM_TOTAL_PAGE_NO(temp_pages);
                setCURR_MULTI_SUBFORM_TEMP_CACHE(resp["data"]);
                setCURR_MULTI_SUBFORM_TEMP(resp["data"].slice(0,temp_MULTI_SUB_BATCH_COUNT));
                replace_already_fill_on_search_multi_sub(0,resp["data"].slice(0,temp_MULTI_SUB_BATCH_COUNT));
              }else{
                props.triggerNotification('warning','No data found');
                if(props.batch_id && props.stage && props.batch_task_id){
                  setCURR_MULTI_SUBFORM_TEMP([]);
                }
              }
          })
          .catch(error => {
            console.error('searchMultiSubformFixedMaster 111 Error 1:', error);
          });
        } catch (error) {
          console.error('searchMultiSubformFixedMaster 222 Error 2:', error);
        }
      }else if(CURR_MULTI_SUBFORM_Q1_TOGGLE){
        //console.log("enter 2")
        filter_subform_multiple();
      }else{
        //console.log("enter 3");
      }
    }

    function last_widg_has_multiple_subform(input_data){
      setsubform_search_key("");
      setmultisub_page_no(1);
      setonTableRowLoad(true);
      // ////console.log("\n\nlast_widg_has_multiple_subform :: ")
      if(have_bulk_subform(input_data)){
        // ////console.log("\n\have_bulk_subform :: ")
        setCURR_FORM_IS_MULTI_SUB(true);
        setCURR_MULTI_SUBFORM_Q1_TOGGLE(input_data['bulk_ques_resp_list']['q1_toggle'])
        CURR_MULTI_SUB_HIDE_CURR_VAL = input_data['bulk_ques_resp_list']['hide_curr_value']
        setCURR_MULTI_SUBFORM_TEMP_CACHE(input_data['bulk_ques_resp_list']['ques_block_list'])
        let temp_CURR_MULTI_SUBFORM_TEMP = null;
        // ////console.log("\n\n\nMULTI_SUB_BATCH_COUNT :: ",MULTI_SUB_BATCH_COUNT);
        if(input_data['bulk_ques_resp_list']['q1_toggle']){
          temp_CURR_MULTI_SUBFORM_TEMP = input_data['bulk_ques_resp_list']['ques_block_list'].slice(0,MULTI_SUB_BATCH_COUNT)
          setCURR_MULTI_SUBFORM_TEMP(input_data['bulk_ques_resp_list']['ques_block_list'].slice(0,MULTI_SUB_BATCH_COUNT))
        }else{
          temp_CURR_MULTI_SUBFORM_TEMP = input_data['bulk_ques_resp_list']['ques_block_list']
          setCURR_MULTI_SUBFORM_TEMP(input_data['bulk_ques_resp_list']['ques_block_list'])
        }
        CURR_MULTI_SUBFORM_CF_INST_ID = input_data['bulk_ques_resp_list']['subform_cf_instance_id']
        if(temp_CURR_MULTI_SUBFORM_TEMP.length > 0){
        setCURR_MULTI_SUBFORM_Q1_TOGGLE_RESP_TYPE(temp_CURR_MULTI_SUBFORM_TEMP[0][0]["free_text"]);
        let multi_subform_resp_cache = {}
        if(input_data['bulk_ques_resp_list']['q1_toggle']){
          CURR_MULTI_SUBFORM_TOTAL_ROWS = temp_CURR_MULTI_SUBFORM_TEMP[0][0]["total_rows"]
          let temp_pages = Math.floor(temp_CURR_MULTI_SUBFORM_TEMP[0][0]["total_rows"] / MULTI_SUB_BATCH_COUNT)
          if(temp_CURR_MULTI_SUBFORM_TEMP[0][0]["total_rows"] % MULTI_SUB_BATCH_COUNT !== 0){
            temp_pages = temp_pages + 1;
          }
          setCURR_MULTI_SUBFORM_TOTAL_PAGE_NO(temp_pages);
        }else{
          CURR_MULTI_SUBFORM_TOTAL_ROWS = input_data['bulk_ques_resp_list']['ques_block_list'].length;
          let temp_pages = Math.floor(input_data['bulk_ques_resp_list']['ques_block_list'].length/MULTI_SUB_BATCH_COUNT)
          if(input_data['bulk_ques_resp_list']['ques_block_list'].length % MULTI_SUB_BATCH_COUNT !== 0){
            temp_pages = temp_pages + 1;
          }
          setCURR_MULTI_SUBFORM_TOTAL_PAGE_NO(temp_pages);
        }
        assign_multi_subform_table_width(temp_CURR_MULTI_SUBFORM_TEMP,input_data['bulk_ques_resp_list']['master_cf_ordered_list'],input_data['bulk_ques_resp_list']['each_row_submit'])
        if(input_data['bulk_ques_resp_list']['all_row_mandatory']){
          write_all_rows_inside_response_tracker(input_data)
        }else{
          store_userResp_TempCacheJson(multi_subform_resp_cache)
        }}
        // ////console.log("\n\nfirst temp_CURR_MULTI_SUBFORM_TEMP :: ",temp_CURR_MULTI_SUBFORM_TEMP)
      }else{
        setCURR_FORM_IS_MULTI_SUB(false);
        setCURR_MULTI_SUBFORM_Q1_TOGGLE(false);
        setCURR_MULTI_SUBFORM_Q1_TOGGLE_RESP_TYPE(0);
        setCURR_MULTI_SUBFORM_TEMP([])
        setCURR_MULTI_SUBFORM_TEMP_CACHE([])
        CURR_MULTI_SUBFORM_CF_INST_ID = null
        let multi_subform_resp_cache = {}
        CURR_MULTI_SUB_HIDE_CURR_VAL = false;
        store_userResp_TempCacheJson(multi_subform_resp_cache)
      }
      setonTableRowLoad(false);
    }

    function get_user_resp_cache_key(multi_subform_indx,temp_CURR_MULTI_SUBFORM_TEMP){
      // // ////console.log("get_user_resp_cache_key :: ",temp_CURR_MULTI_SUBFORM_TEMP,multi_subform_indx)
      if(CURR_MULTI_SUBFORM_Q1_TOGGLE){
        return temp_CURR_MULTI_SUBFORM_TEMP[multi_subform_indx][0]['response']
      }else{
        return  multi_subform_indx
      }
    }

  function get_userResp_TempCacheJson_serv(){
    return JSON.parse(localStorage.getItem("multi_subform_resp_cache"))
  }

  function get_userResp_TempCacheJson(){
    return get_userResp_TempCacheJson_serv()
  }

    function replace_already_fill_on_search_multi_sub(check_start_point,temp_CURR_MULTI_SUBFORM_TEMP){
      let multi_subform_resp_cache = get_userResp_TempCacheJson()
      // Create a new array with the updated object at the specified index
      const updatedList = [...temp_CURR_MULTI_SUBFORM_TEMP];
      for (let k = check_start_point; k < temp_CURR_MULTI_SUBFORM_TEMP.length; k++) {
        let row_id = get_user_resp_cache_key(k,temp_CURR_MULTI_SUBFORM_TEMP)
        if(row_id in multi_subform_resp_cache){
          updatedList[k] = multi_subform_resp_cache[temp_CURR_MULTI_SUBFORM_TEMP[k][0]["response"]]
        }
      }
      // Update the state with the new array
      setCURR_MULTI_SUBFORM_TEMP(updatedList);
    }

    function onPageChange(pageIndx,direct_val = null){
      // ////console.log("pageIndx,direct_val :: ",pageIndx,direct_val);
      let page_no = (direct_val !== null) ? direct_val : (pageIndx.target.value);
      // ////console.log("page_no :: ",page_no)
      setmultisub_page_no(page_no);
      onFixedMasterSearch(message_index,page_no);    
    }

    function onPageForwRBACK(direction){
      // ////console.log("onPageForwRBACK :: ",direction,CURR_MULTI_SUBFORM_TOTAL_PAGE_NO);
      if(direction === 'front' && multisub_page_no < CURR_MULTI_SUBFORM_TOTAL_PAGE_NO){
        onPageChange(null,multisub_page_no + 1);
      }else if(direction === 'back' && multisub_page_no > 1){
        onPageChange(null,multisub_page_no - 1);
      }else{
        props.triggerNotification('warning','Action not allowed!')
      }
      // ////console.log("onPageForwRBACK :: ",multisub_page_no);
    }
  
    function onPageSizeChange(pageSize){
      let temp_psize = pageSize.target.value;
      // ////console.log("pageSize :: ",pageSize)
      setMULTI_SUB_BATCH_COUNT(temp_psize);
      setmultisub_page_no(1);
      onFixedMasterSearch(message_index,1,temp_psize);
    }  

    function changeOrder(cf_indx,cf_data,col_type,col_type_name,col_type_id,col_type_id_2,order_by){
      const updatedmessage = {...message};
      updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]['order_by'] = order_by;
      setMessage(updatedmessage);
      let tempcurr_master_order_by_list = {...curr_master_order_by_list};
      if(cf_data.cfm_id){
        let obj = {"type":col_type,"type_name":col_type_name,"type_id":col_type_id,"order_by":order_by};
        if(order_by === '' && (cf_data.cfm_id in tempcurr_master_order_by_list["cfm"])){
          const newCfmObject = { ...tempcurr_master_order_by_list["cfm"] };
          delete newCfmObject[cf_data.cfm_id];
          tempcurr_master_order_by_list["cfm"] = newCfmObject;
        }else{
          tempcurr_master_order_by_list["cfm"][cf_data.cfm_id] = obj
        }
      }else {
        tempcurr_master_order_by_list["cfm"] = {}
      }
      if(cf_data.seq_id){
        let obj = {"type":col_type,"type_name":col_type_name,"type_id":col_type_id_2,"order_by":order_by}
        if(order_by === '' && (cf_data.seq_id in tempcurr_master_order_by_list["seq"])){
          const newSeqObject = { ...tempcurr_master_order_by_list["seq"] };
          delete newSeqObject[cf_data.seq_id];
          tempcurr_master_order_by_list["seq"] = newSeqObject;
        }else{
          tempcurr_master_order_by_list["seq"][cf_data.seq_id] = obj
        }
      }else {
        tempcurr_master_order_by_list["seq"] = {}
      }
      onFixedMasterSearch(message_index,null,null,tempcurr_master_order_by_list);
      setcurr_master_order_by_list(tempcurr_master_order_by_list);
      setClickedColumn(cf_data.cf_key);
    }

    function on_multi_subform_row_update(mul_sub_index,dirr_val = null){
      // // ////console.log("try multi_subform_resp_cache :: ",mul_sub_index,CURR_FORM_IS_MULTI_SUB)
      if(CURR_FORM_IS_MULTI_SUB){
        let recent_edit_row_q1_id = get_user_resp_cache_key(mul_sub_index,CURR_MULTI_SUBFORM_TEMP)
        let multi_subform_resp_cache = get_userResp_TempCacheJson()
        // ////console.log("\n\non local st update :: ",CURR_MULTI_SUBFORM_TEMP[mul_sub_index],dirr_val);
        multi_subform_resp_cache[String(recent_edit_row_q1_id)] = (dirr_val!==null ? dirr_val : CURR_MULTI_SUBFORM_TEMP[mul_sub_index])
        store_userResp_TempCacheJson(multi_subform_resp_cache)
        // // ////console.log("multi_subform_resp_cache :: ",multi_subform_resp_cache)
      }
    }

    function get_resp_check(k,i,ques_block_list){
      let resp = ''
      let file_list = [];
      if (
        ques_block_list[k][i].options.length === 0 &&
        ques_block_list[k][i].free_text >= 1
      ) {
        if (ques_block_list[k][i]['response'] !== '') {
          resp = ques_block_list[k][i]['response']
        }
      } else if (
        ques_block_list[k][i].options.length !== 0 &&
        (ques_block_list[k][i].free_text < 1 || ques_block_list[k][i].free_text === 7 || ques_block_list[k][i].free_text === 8 || ques_block_list[k][i].free_text === 11)
      ) {
        if (ques_block_list[k][i]['response'] !== '') {
          resp = ques_block_list[k][i]['response'];
        }
      } else if (ques_block_list[k][i].file_upload === 1) {
          file_list = ques_block_list[k][i]['user_resp_files']
      } else {
        resp = ques_block_list[k][i]['response']
      }
      return {"resp":resp,"file_list":file_list}
    }

    function set_mutli_sub_key_val(multi_subform_indx,eqIndx,key,resp_val){
      setCURR_MULTI_SUBFORM_TEMP((prevList) => {
        const newList = [...prevList];
        newList[multi_subform_indx] = [...newList[multi_subform_indx]];
        newList[multi_subform_indx][eqIndx] = { ...newList[multi_subform_indx][eqIndx], [key]: resp_val };
        return newList;
      });
    }

    function clear_multi_sub_resp(multi_subform_indx){
      // ////console.log("before_clear :: ",multi_subform_indx,CURR_MULTI_SUBFORM_TEMP[multi_subform_indx])
      for(let eqIndx = 1;eqIndx < CURR_MULTI_SUBFORM_TEMP[multi_subform_indx].length; eqIndx++){
        // CURR_MULTI_SUBFORM_TEMP[multi_subform_indx][eqIndx].response = ""
        set_mutli_sub_key_val(multi_subform_indx,eqIndx,"response","")
        if(CURR_MULTI_SUBFORM_TEMP[multi_subform_indx][eqIndx].tag_option_flag){
          set_mutli_sub_key_val(multi_subform_indx,eqIndx,"options",clear_checked_if_tag_enable(CURR_MULTI_SUBFORM_TEMP[multi_subform_indx][eqIndx].options))
          // CURR_MULTI_SUBFORM_TEMP[multi_subform_indx][eqIndx].options = clear_checked_if_tag_enable(CURR_MULTI_SUBFORM_TEMP[multi_subform_indx][eqIndx].options)
        }
        set_mutli_sub_key_val(multi_subform_indx,eqIndx,"user_resp_files",[])
      }
      // ////console.log("after_clear :: ",multi_subform_indx,CURR_MULTI_SUBFORM_TEMP[multi_subform_indx])
      let recent_edit_row_q1_id = get_user_resp_cache_key(multi_subform_indx,CURR_MULTI_SUBFORM_TEMP)
      let multi_subform_resp_cache = get_userResp_TempCacheJson()
      delete multi_subform_resp_cache[String(recent_edit_row_q1_id)]
      store_userResp_TempCacheJson(multi_subform_resp_cache)
    }

    function remove_master_from_list(multi_subform_indx){
      let recent_edit_row_q1_id = get_user_resp_cache_key(multi_subform_indx,CURR_MULTI_SUBFORM_TEMP)
      let multi_subform_resp_cache = get_userResp_TempCacheJson()
      delete multi_subform_resp_cache[String(recent_edit_row_q1_id)]
      store_userResp_TempCacheJson(multi_subform_resp_cache)
      CURR_MULTI_SUBFORM_TEMP.splice(multi_subform_indx, 1);
      CURR_MULTI_SUBFORM_TOTAL_ROWS -= 1;
    }

    function submit_single_row_grid_view(data,k,mess_indx = null) {
      setLoading(true);
      let subforms_data = data["bulk_ques_resp_list"]
      let ques_block_list = CURR_MULTI_SUBFORM_TEMP
      let temp_cf_instance_id = subforms_data["subform_cf_instance_id"]
      let whole_struct = [];
      let new_subform = {
            form_type : "subform", 
            form_id : ques_block_list[k][0]['form_id'],
            cf_instance_id : temp_cf_instance_id,
            ques_list : []
          }
      temp_cf_instance_id = null;
      for (let i = 0; i < ques_block_list[k].length; i++) {
        let response_data = get_resp_check(k,i,ques_block_list)
        let resp = response_data["resp"]
        let file_list = response_data["file_list"]
        new_subform.ques_list.push({
                            ques_id : ques_block_list[k][i]['ques_id'],
                            resp_type : ques_block_list[k][i].free_text,
                            response : resp,
                            file_list : file_list,
                            file_upload_flag : ques_block_list[k][i].file_upload,
                            task_id : ques_block_list[k][i].task_id,
                            revision : ques_block_list[k][i].revision,
                            contrib_id : ques_block_list[k][i].contrib_id,
                            custom_field : ques_block_list[k][i].custom_field,
                            scope : ques_block_list[k][i].scope,
                            task_assct_flag : ques_block_list[k][i].task_assct_flag
                          })
      }
      whole_struct.push(new_subform)
      let out_resp = {}
      out_resp[SPECIAL_SUBMIT_GRID_ROW_SUBMIT_DREAM_DASH] = whole_struct
      try{
        let payload = {
          token: localStorage.getItem('vector_token'),
          response : out_resp,
          batch_id : props.batch_id,
          batch_task_id : props.batch_task_id,
          stage_id: props.stage_id
        }
        if(subforms_data.validator!=null){
          console.log('resp from single submit :: ',out_resp)
          // handlePsaValidator(subforms_data.validator,out_resp, 'form', ques_block_list[k][0]['response'], null, subforms_data, 'form_submit_subform_row',whole_struct);
          console.log('subform validator :: ',subforms_data.validator)
          let inputId = ('form_'+ques_block_list[k][0].response)
          console.log('single submit imput id ',inputId)
          if(!(inputId in PsaValMap)){
            setPsaValMap(previousState => ({
              ...previousState,
              [inputId]: { loading: true, status: true, value: '',timeoutId: null }
            }));
          }else{
            if(!PsaValMap[inputId].loading){
              setPsaValMap(previousState => ({
                ...previousState,
                [inputId]: { loading: true, status: true, value: '',timeoutId: null }
              }));
            }
            if(PsaValMap[inputId].timeoutId){
              clearTimeout(PsaValMap[inputId].timeoutId);
            }
          }
          const postdata={
            token: localStorage.getItem('vector_token'),
            input: out_resp['dirrect_database_upload_grid_row_submit_dream_dash'], //resp_obj
            data_type: 'form_submit_subform_row',
            validator_info: subforms_data.validator
          }
          httpClient.post('/bot/psaValidMiddleWare',postdata)
          .then(respBody=>{
            let res = respBody.data
            // console.log(`API response for ${inputId}:`, res);
            console.log('res :: ',res)
            set_psa_val_submit(res.status)
            let valid_status = res.status
            console.log('single submit status :: ',valid_status)
            
            if(valid_status == true){
              botHttpClient.post('/uibot/submitGridRow',payload )
              .then(resp => {
                {
                  setLoading(false)
                  let res = resp.data;
                  if(res.status){
                    if(mess_indx!=null){
                    const temp_button_list = [...submit_button_list]
                    temp_button_list.push(mess_indx)
                    set_submit_button_list(temp_button_list) 
                    }     
                    props.triggerNotification('success', 'submitted successfully');
                    let response_data = get_resp_check(k,0,ques_block_list)
                    try{
                      let payload2 = {
                        phone:null,
                        token:localStorage.getItem('vector_token'),
                        search_key: subform_search_key,
                        quest_id: ques_block_list[k][0]['ques_id'],
                        instance_id:subforms_data["subform_cf_instance_id"],
                        form_id:ques_block_list[k][0]['form_id'],
                        resp_type:ques_block_list[k][0].free_text,
                        ques_resp_list_struct : ques_block_list[k][0],
                        page_no : 1,
                        master_id :response_data["resp"]
                      }   
                      httpClient.post('/bot/checkMasterExistAfterSubmit',payload2 )
                      .then(res => {
                        let exist_status = res.data
                        if(exist_status.status){
                          clear_multi_sub_resp(k)
                          console.log('on grid row submit :: ',subforms_data.validator);
                          // if(subforms_data.validator){
                          //   handlePsaValidator(subforms_data.validator,'single_row_submit', 'form', ques_block_list[k][0]['response'], null, subforms_data, 'form_submit_subform_row',whole_struct);
                          //   console.log('subform validator :: ',subforms_data.validator)
                          // }
                        }else{
                          remove_master_from_list(k)
                        }
                      })
                      .catch(error => {
                        console.error('checkMasterExistAfterSubmit Error 1:', error);
                        props.triggerNotification('error', 'Something went wrong');
                      });
                      console.log('reset loading ')
                      
                    } catch (error) {
                      console.error('checkMasterExistAfterSubmit Error 2:', error);
                      props.triggerNotification('error', 'Something went wrong');
                    }
                  }else{
                    props.triggerNotification('error', 'Something went wrong');
                  }
                }
              })
              .catch(error => {
                console.error('submitGridRow Error 111:', error);
              });
            }
            else{
              setLoading(false)
            }
            setPsaValMap(previousState => ({
              ...previousState,
              [inputId]: {loading: false, status: res.status, value: res.data, timeoutId:null}
            }));
          })
        }

        console.log('psa val status :: ',psa_val_submit)
        if(subforms_data.validator==null){
        botHttpClient.post('/uibot/submitGridRow',payload )
        .then(resp => {
          {
            curr_submit_load_flag = true;
            let res = resp.data;
            setLoading(false)
            if(res.status){
              if(mess_indx!=null){
                const temp_button_list = [...submit_button_list]
                temp_button_list.push(mess_indx)
                set_submit_button_list(temp_button_list) 
                }     
              props.triggerNotification('success', 'submitted successfully');
              let response_data = get_resp_check(k,0,ques_block_list)
              try{
                let payload2 = {
                  phone:null,
                  token:localStorage.getItem('vector_token'),
                  search_key: subform_search_key,
                  quest_id: ques_block_list[k][0]['ques_id'],
                  instance_id:subforms_data["subform_cf_instance_id"],
                  form_id:ques_block_list[k][0]['form_id'],
                  resp_type:ques_block_list[k][0].free_text,
                  ques_resp_list_struct : ques_block_list[k][0],
                  page_no : 1,
                  master_id :response_data["resp"]
                }
                     
                httpClient.post('/bot/checkMasterExistAfterSubmit',payload2 )
                .then(res => {
                  let exist_status = res.data
                  if(exist_status.status){
                    clear_multi_sub_resp(k)
                    console.log('on grid row submit :: ',subforms_data.validator);
                    // if(subforms_data.validator){
                    //   handlePsaValidator(subforms_data.validator,'single_row_submit', 'form', ques_block_list[k][0]['response'], null, subforms_data, 'form_submit_subform_row',whole_struct);
                    //   console.log('subform validator :: ',subforms_data.validator)
                    // }
                  }else{
                    remove_master_from_list(k)
                  }
                })
                .catch(error => {
                  console.error('checkMasterExistAfterSubmit Error 1:', error);
                  // props.triggerNotification('error', 'Something went wrong!!');
                });
              
              } catch (error) {
                console.error('checkMasterExistAfterSubmit Error 2:', error);
                props.triggerNotification('error', 'Something went wrong!!!');
              }
            }else{
              props.triggerNotification('error', 'Something went wrong!!!!');
            }
          }
        })
        .catch(error => {
          console.error('submitGridRow Error 111:', error);
        });
      }
      
      } catch (error) {
        console.error('submitGridRow Error 222:', error);
      }
      
    }

    function add_one_more_subform_resp(mess_indx){
      let template  = [];
      const updatedResponses = [...CURR_MULTI_SUBFORM_TEMP];
      updatedResponses[updatedResponses.length - 1].forEach(val => template.push(Object.assign({}, val)));
      for(let i = 0; i < template.length; i++) {
        template[i]['response'] = ""
        if(template[i]['file_upload']){
          template[i]['user_resp_files'] = []
        }
      }
      updatedResponses.push(template);
      setCURR_MULTI_SUBFORM_TEMP(updatedResponses);
    }

    function dublicate_last_fill_subform_resp(){
      let template  = [];
      let multi_subform_resp_cache = localStorage.getItem("multi_subform_resp_cache")
      multi_subform_resp_cache = JSON.parse(multi_subform_resp_cache)
      let keyList = [];
      Object.keys(multi_subform_resp_cache).forEach(key => {
        keyList.push(Number(key))
      });
      let maxIndx = keyList.reduce((op, item) => op = op > item ? op : item, 0);
      // ////console.log("key list :: ",keyList,maxIndx)
      if(keyList.length > 0){
        multi_subform_resp_cache[String(maxIndx)].forEach(val => template.push(Object.assign({}, val)));
        CURR_MULTI_SUBFORM_TEMP.push(template)
      }else{
        props.triggerNotification('warning', 'No data for duplicate');
      }  
    }

    function has_overwrite_psa_resp(single_block_temp){
      // ////console.log("\n\nhas_overwrite_psa_resp : ",single_block_temp)
      if (!single_block_temp) {
        return false; // or handle the undefined case appropriately
      }else{
        for (let i = 0; i < single_block_temp.length; i++) {
          if(single_block_temp[i]["overwrite_resp_flag"]){
            return true
          }
        }
      }
      return false
    }

    function has_master_single_opt(single_block_temp){
      if (!single_block_temp) {
        return false; // or handle the undefined case appropriately
      }else{
        for (let i = 0; i < single_block_temp.length; i++) {
          if(single_block_temp[i]["options"].length === 1  && single_block_temp[i]['auto_select_single'] ){
            return true
          }
        }
      }
      return false
    }

    function submit_multiple_subform_atonce(data, msg_id,mess_indx) {
      setLoading(true);
      console.log('subforms data :: ',data)
      // const temp_button_list = [...submit_button_list]
      // temp_button_list.push(mess_indx)
      // set_submit_button_list(temp_button_list)      
      let subforms_data = data["bulk_ques_resp_list"]
      // let ques_block_list = subforms_data["ques_block_list"]
      let q1_toggle = subforms_data['q1_toggle']
      let un_submited_subform_inst = CURR_MULTI_SUBFORM_CF_INST_ID
      
      let multi_subform_resp_cache = get_userResp_TempCacheJson()
      let ques_block_list = [];
      if(q1_toggle && (subforms_data["has_default_resp_flag"] || has_overwrite_psa_resp(CURR_MULTI_SUBFORM_TEMP[0]) || has_master_single_opt(CURR_MULTI_SUBFORM_TEMP[0]))){
        let single_ques_resp_temp = Object.assign([], message['data']['bulk_ques_resp_list']['ques_block_list'][0])
        try{
          let payload = {
            phone:null,
            token:localStorage.getItem('vector_token'),
            search_key: "",
            quest_id: CURR_MULTI_SUBFORM_TEMP[0][0]["ques_id"],
            instance_id:message['data']['bulk_ques_resp_list']['subform_cf_instance_id'],
            form_id:CURR_MULTI_SUBFORM_TEMP[0][0]["form_id"],
            resp_type:CURR_MULTI_SUBFORM_TEMP[0][0]["free_text"],
            ques_resp_list_struct : single_ques_resp_temp,
            construct_for_submit_flag : true,
            already_exist_resp : multi_subform_resp_cache,
            page_no : null,
            master_filter_list : null,
            master_order_list : null,
            page_size : null,
            batch_id : props.batch_id,
            stage_id : props.stage_id,
            stage : props.stage,
            batch_task_id : props.batch_task_id
          }
          // ////console.log("payload :: ",payload)
          httpClient.post('/bot/searchMultiSubformFixedMaster',payload )
          .then(response => {
            let resp = response.data;
            setLoading(false);
            ques_block_list = resp["data"]
            const_and_submit_mul_subform_all_atonce(ques_block_list,q1_toggle,un_submited_subform_inst,msg_id,mess_indx)
          })
          .catch(error => {
            console.error('searchMultiSubformFixedMaster 11 Error 1:', error);
          });
        } catch (error) {
          console.error('searchMultiSubformFixedMaster 22 Error 2:', error);
        }
      }else{
        ques_block_list = Object.values(multi_subform_resp_cache);
        const_and_submit_mul_subform_all_atonce(ques_block_list,q1_toggle,un_submited_subform_inst,msg_id,mess_indx)
      }
    }


    function const_and_submit_mul_subform_all_atonce(ques_block_list,q1_toggle,un_submited_subform_inst,msg_id,mess_indx){
      setLoading(true);
      var whole_struct = []
      // ////console.log("ques_block_list ::",ques_block_list)
      for (let k = 0; k < ques_block_list.length; k++) {
        let sel_opt = ques_block_list[k].map((currElement, index) => {
          if(currElement.response || currElement.user_resp_files.length){return 1}else{return 0}
        });
        const sum = sel_opt.reduce((partialSum, a) => partialSum + a, 0);
        if(((q1_toggle && ques_block_list[k][0].mandatory && sum > 0) || (q1_toggle && !ques_block_list[k][0].mandatory && sum > 1)) || (!q1_toggle && sum > 0)){
          let new_subform = {
                            form_type : "subform",
                            form_id : ques_block_list[k][0]['form_id'],
                            cf_instance_id : un_submited_subform_inst,
                            ques_list : []
                          }
          un_submited_subform_inst = null;
          for (let i = 0; i < ques_block_list[k].length; i++) {
          
            let response_data = get_resp_check(k,i,ques_block_list);
            console.log("response_data ::",response_data);
            let resp = response_data["resp"]
            let file_list = response_data["file_list"]
            new_subform.ques_list.push({
                                          ques_id : ques_block_list[k][i]['ques_id'],
                                          resp_type : ques_block_list[k][i].free_text,
                                          response : resp,
                                          file_list : file_list,
                                          file_upload_flag : ques_block_list[k][i].file_upload,
                                          task_id : ques_block_list[k][i].task_id,
                                          revision : ques_block_list[k][i].revision,
                                          contrib_id : ques_block_list[k][i].contrib_id,
                                          custom_field : ques_block_list[k][i].custom_field,
                                          scope : ques_block_list[k][i].scope,
                                          task_assct_flag : ques_block_list[k][i].task_assct_flag
                                        })
          }
          whole_struct.push(new_subform)
        }
      }
      let out_resp = {
        "primary_form_id":message['data']['bulk_ques_resp_list']['primary_form_id'],
        "subform_instance_id":message['data']['bulk_ques_resp_list']['subform_cf_instance_id']};
      out_resp[SPECIAL_SUBMIT_TYPE_DREAM_DASH] = whole_struct      
      try{
        let payload = {
          token: localStorage.getItem('vector_token'),
          response : out_resp,
          batch_id : props.batch_id,
          stage_id : props.stage_id,
          batch_task_id : props.batch_task_id
        }
        // console.log('out resp whole submit :: ',out_resp)
        // console.log('validator check :: ',message['data']['form_list'][0])
        if(message['data']['form_list'][0].validator != null && out_resp['dirrect_database_upload_dream_dash'].length!=0){
          // console.log('validate data ::: ')
          let whole_submit_output_data = {'form_id':out_resp['dirrect_database_upload_dream_dash'][0]['form_id'],'subform_instance_id':out_resp['subform_instance_id']}
          whole_submit_output_data['ques_resp_list'] = out_resp['dirrect_database_upload_dream_dash']
          // console.log('whole output submit data :: ',whole_submit_output_data)
          let inputId = ('form_'+out_resp['primary_form_id'])
          if(!(inputId in PsaValMap)){
            setPsaValMap(previousState => ({
              ...previousState,
              [inputId]: { loading: true, status: true, value: '',timeoutId: null }
            }));
          }else{
            if(!PsaValMap[inputId].loading){
              setPsaValMap(previousState => ({
                ...previousState,
                [inputId]: { loading: true, status: true, value: '',timeoutId: null }
              }));
            }
            if(PsaValMap[inputId].timeoutId){
              clearTimeout(PsaValMap[inputId].timeoutId);
            }
          }
          const postdata={
            token: localStorage.getItem('vector_token'),
            input: whole_submit_output_data, //resp_obj
            data_type: 'multi_subform_whole_submit',
            validator_info: message['data']['form_list'][0].validator
          }
          httpClient.post('/bot/psaValidMiddleWare',postdata)
          .then(respBody=>{
            let res = respBody.data
            // console.log('whole submit :: ',res)
            let valid_status = res.status
            console.log('valid status whole submit :: ',valid_status)
            if(valid_status == true){
              // console.log('valid true ::')
              botHttpClient.post('/uibot/dirrectSubmitDB',payload )
              .then(res => {
                // console.log('reffresh resp :: ',res)
                if(res.data.form_link_data!=null){
                  props.submit_form(res.data.form_link_data,props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)
                  props.disableWidgetorView(props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)   
                  const temp_button_list = [...submit_button_list]
                  temp_button_list.push(mess_indx)
                  set_submit_button_list(temp_button_list)        
                }
                else{
                  console.log('call close function :: ')
                  enable_disp_form_submit_msg(true)  
                  // props.disableWidgetorView(props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)
                  setLoading(false)
                  // console.log('add list :: ')
                  const temp_button_list = [...submit_button_list]
                  temp_button_list.push(mess_indx)
                  set_submit_button_list(temp_button_list) 
                }
                props.triggerNotification('success', 'submitted successfully');
                
              })
              .catch(error => {
                console.error('dirrectSubmitDB Error 1:', error);
              });
              }
              else{
                setLoading(false)
              }
              setPsaValMap(previousState => ({
                ...previousState,
                [inputId]: {loading: false, status: res.status, value: res.data, timeoutId:null}
              }));
            })
          }
        if(message['data']['form_list'][0].validator==null || out_resp['dirrect_database_upload_dream_dash'].length==0){
        botHttpClient.post('/uibot/dirrectSubmitDB',payload )
        .then(res => {
          //console.log('reffresh resp :: ',res)
          setLoading(false);
          if(res.data.form_link_data!=null){
            props.submit_form(res.data.form_link_data,props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)
            props.disableWidgetorView(props.trigger_section_index,props.trigger_comp_type,props.trigger_comp_index)   
            const temp_button_list = [...submit_button_list]
            temp_button_list.push(mess_indx)
            set_submit_button_list(temp_button_list)        
          }
          else{
            //console.log('call close function :: ')
            //console.log('call close function :: ')
            enable_disp_form_submit_msg(true)  
            const temp_button_list = [...submit_button_list]
            temp_button_list.push(mess_indx)
            set_submit_button_list(temp_button_list) 
          }
          // if(message['data']['form_list'][0].validator){
          //   handlePsaValidator(message['data']['form_list'][0].validator,'single_row_submit', 'form',message['data']['form_list'][0].form_id, null, message['data']['form_list'][0], 'form_submit_subform_row',payload);
          // }
          props.triggerNotification('success', 'submitted successfully');
          
        })
        .catch(error => {
          console.error('dirrectSubmitDB Error 1:', error);
        });
      }
      } catch (error) {
        console.error('dirrectSubmitDB Error 2:', error);
      }
    }
    ///////////////////////////////////////////
    
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl_hrm, setanchorEl_hrm] = useState(null);
    const [anchorEl_time, setanchorEl_time] = useState(null);
    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleDatePickClose = () => {
      setAnchorEl(null);
      setvisble_datepick(false);
    };


    const closeMasterColFilter = () => {
      setAnchorEl(null);
      setvisble_col_filtr(false);
    };

    const openMasterColFilter = (event,cf_indx,each_cf) => {
      ////console.log('each cf :: ',each_cf)
      ////console.log('cf indx current :: ',cf_indx)
      ////console.log('pressed state :: ',pressed)
      ////console.log('visibility :: ',visble_col_filtr)
      setMasterFilterCfIndx(cf_indx);
      setPressed((prevPressed) => !prevPressed);
      setAnchorEl(event.currentTarget);
      ////console.log('pressed state after change :: ',pressed)
      setvisble_col_filtr(true);
      notOpt_multiSub_filt_visible(true,cf_indx)
      let temp_cf_filter_index = [...filter_cf_index_list]
      if(temp_cf_filter_index.includes(cf_indx)){
          temp_cf_filter_index = temp_cf_filter_index.filter((item) => item != cf_indx)
      }
      else{
        temp_cf_filter_index.push(cf_indx)
      }
      const unique_filter_cf_index_list =  Array.from(new Set(temp_cf_filter_index));   
      ////console.log('unique filter index :: ',unique_filter_cf_index_list)   
      set_filter_cf_index_list(unique_filter_cf_index_list)
      ////console.log('final index list :: ',filter_cf_index_list)
    };

    const handleTimeMenu = (event,message_index,formIndex,ques_inx,formtype,curr_resp,ques_id,ques,free_text_no,is_multiple_subform = false,mul_sub_index = null) => {
      //console.log('handleTimeMenu :: ',event.currentTarget);
      if(validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],is_multiple_subform)=== 'error'){
        setwidgets((prevMessage) =>
        produce(prevMessage, (draft) => {
          // ////console.log('all in one and curr resp and prev message:: ',new_opt_list, curr_resp, prevMessage)
          draft[message_index]['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_inx]['response'] = ''
          ////console.log('draft :: ',draft)
        }))
        curr_resp = ''
    };
    //console.log('form type check :: ',formtype)
    SetTimeVisible(true);
    setanchorEl_time(event.currentTarget);
    setCurr_time_pick_mess_indx(message_index)
    setCurr_time_pick_form_indx(formIndex)
    setCurr_time_pick_ques_indx(ques_inx)
    setCurr_time_pick_form_type(formtype)
    setCurr_time_pick_is_multi(is_multiple_subform)
    setCurr_time_pick_sub_form_indx(mul_sub_index)
    if(curr_resp && curr_resp.length == 5 && (curr_resp.includes(':'))){
      let formattedTime = ''
      try{
        const parts = curr_resp.split(':');
        // Reformat the time string in 'HH:MM' format
        if(parts[0].length = 2 && parts[1].length == 2 ){
          formattedTime = `${parts[0]}:${parts[1]}`;
          
        }
      }catch(error){
        formattedTime = "";
      }
      setTimepickvar(formattedTime);

      //console.log('handleTimeMenu formattedTime:: ',formattedTime);
    }else{
      setTimepickvar("");
    }
  }



  const handleHoursTimeMenu = (event,message_index,formIndex,ques_inx,formtype,curr_resp,ques_id,ques,free_text_no,is_multiple_subform = false,mul_sub_index = null) => {
    if(validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],is_multiple_subform)=== 'error'){
      setwidgets((prevMessage) =>
      produce(prevMessage, (draft) => {
        draft[message_index]['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_inx]['response'] = ''
      }))
      curr_resp = ''
      };
      // //console.log('form type check :: ',formtype)
      SetHoursTimeVisible(true)
      setanchorEl_hrm(event.currentTarget);
      setCurr_time_pick_mess_indx(message_index)
      setCurr_time_pick_form_indx(formIndex)
      setCurr_time_pick_ques_indx(ques_inx)
      setCurr_time_pick_form_type(formtype)
      setCurr_time_pick_is_multi(is_multiple_subform)
      setCurr_time_pick_sub_form_indx(mul_sub_index)
      if(curr_resp && curr_resp.length <= 5 && curr_resp.length >= 3 && (curr_resp.includes(':'))){
        let formattedTime = ''
        try{
          const parts = curr_resp.split(':');
          // Reformat the time string in 'HH:MM' format
          if(parts[0].length <=3 && parts[0].length >=1 && parts[1].length == 2 ){
            formattedTime = `${parts[0]}:${parts[1]}`;
            //console.log('set values ')
            setHourVal(parts[0])
            setMinVal(parts[1])
          }
        }catch(error){
          formattedTime = "";
        }
      }
}


    function mergeLists(sourceList, destinationList, key) {
      // Create a set of existing values in the destination list
      const existingValues = new Set(destinationList.map(item => item[key]));
    
      // Iterate through the source list
      for (const sourceItem of sourceList) {
        // Check if the key value of the source item exists in the destination list
        if (!existingValues.has(sourceItem[key])) {
          // Add the source item to the destination list
          destinationList.push(sourceItem);
          // Update the set of existing values
          existingValues.add(sourceItem[key]);
        }
      }
    
      // Return the updated destination list
      return destinationList;
    }

    function handleFilterOptionSelect(e,newInput){
      ////console.log("on filter select :: ",newInput);
      if(newInput){
        const updatedmessage = {...message};
        updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx]['selected_filters'] = mergeLists([newInput], updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx]['selected_filters'], 'val')
        setMessage(updatedmessage);
      }
    }

    function removeObjectsByKey(list, key, textToRemove) {
      // Use the filter method to create a new list excluding items with the specified key value
      const updatedList = list.filter(item => item[key] !== textToRemove);
    
      // Return the updated list
      return updatedList;
    }

    function handleMasterFilterDelete(delKey){
      const updatedmessage = {...message};
      updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx]['selected_filters'] = removeObjectsByKey(updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx]['selected_filters'], 'val',delKey);
      setMessage(updatedmessage);
    }


    function mapdatepick(event,message_index,formIndex,ques_inx,formtype,curr_resp,ques_id,ques,free_text_no,is_multiple_subform = false,mul_sub_index = null){
      if(validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],is_multiple_subform)=== 'error'){
        if(!is_multiple_subform){
          setwidgets((prevMessage) =>
          produce(prevMessage, (draft) => {
            // console.log('all in one and curr resp and prev message:: ', prevMessage)
            draft[message_index]['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_inx]['response'] = ''
            ////console.log('draft :: ',draft)
          }))
        } else {
            console.log("pass");      
        }
        curr_resp = ''
      }
      // console.log('form index check :: ',formIndex)
      handleOpen(event);
      setvisble_datepick(true);
      setCurr_date_pick_mess_indx(message_index);
      setCurr_date_pick_form_indx(formIndex);
      setCurr_date_pick_ques_indx(ques_inx)
      setCurr_date_pick_form_type(formtype)
      setCurr_date_pick_is_multi(is_multiple_subform)
      // ////console.log("\n\n\ncurr_date_pick_is_multi :: ",curr_date_pick_is_multi,curr_date_pick_form_type)
      setCurr_date_pick_sub_form_indx(mul_sub_index)
      if(curr_resp && curr_resp.length > 0 && (curr_resp.includes('/'))){
        let formattedDate = "";
        try{
          const parts = curr_resp.split('/');
          // Reformat the date string in 'mm/dd/yy' format
          if(parts[0].length > 0 && parts[1].length > 0 && parts[2].length > 0){
            formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
          }
        }catch(error){
          formattedDate = "";
        }
        setDatepickvar(formattedDate)
        // OnDatePick(formattedDate)
      }else{
        setDatepickvar("");
      }
    }

    function formatDate(inputDate) {
      const day = String(inputDate.getDate()).padStart(2, '0');
      const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = String(inputDate.getFullYear()).slice(-2);
    
      return `${day}/${month}/${year}`;
    }
    
  
    function OnDatePick(evt){
      // ////console.log("On date pick :: ",evt)
      let new_formdate = formatDate(evt)
      // ////console.log("datepick evnt :: ",new_formdate);
      // ////console.log("curr_date_pick_is_multi :: ",curr_date_pick_form_type,curr_date_pick_is_multi);
      if (curr_date_pick_form_type ==='all_in_one'){ 
        if(!curr_date_pick_is_multi){
          setMessage((prevMessage) =>
            produce(prevMessage, (draft) => {
              draft.data.form_list[curr_date_pick_form_indx].ques_resp_list.data.list[curr_date_pick_ques_indx].response = new_formdate;
            })
          );
          if(message.data.form_list[curr_date_pick_form_indx].ques_resp_list.data.list[curr_date_pick_ques_indx].validator){
            handlePsaValidator(message.data.form_list[curr_date_pick_form_indx].ques_resp_list.data.list[curr_date_pick_ques_indx].validator,new_formdate,curr_date_pick_form_indx,curr_date_pick_ques_indx,curr_date_pick_sub_form_indx,message.data.form_list[curr_date_pick_form_indx].ques_resp_list.data.list[curr_date_pick_ques_indx],'all_in_one_input',null)
          }
          
        }else{
            console.log('multisubform resp ***',new_formdate)
            on_multi_subform_row_update(curr_date_pick_sub_form_indx)
            setCURR_MULTI_SUBFORM_TEMP((prevMessage) =>
              produce(prevMessage, (draft) => {
                draft[curr_date_pick_sub_form_indx][curr_date_pick_ques_indx]['response'] = new_formdate
              })
            );

            setCURR_MULTI_SUBFORM_TEMP((prevMessage) =>
              {
                const updatedCURR_MULTI_SUBFORM_TEMP = produce(prevMessage, (draft) => {
                draft[curr_date_pick_sub_form_indx][curr_date_pick_ques_indx]['response'] = new_formdate;
                
              });
              on_multi_subform_row_update(curr_date_pick_sub_form_indx,updatedCURR_MULTI_SUBFORM_TEMP[curr_date_pick_sub_form_indx]);
              return updatedCURR_MULTI_SUBFORM_TEMP;
            }
            );
          // const updatedResponses = [...CURR_MULTI_SUBFORM_TEMP];
          // updatedResponses[curr_date_pick_sub_form_indx][curr_date_pick_ques_indx]['response'] = new_formdate
          // setCURR_MULTI_SUBFORM_TEMP(updatedResponses);
          setMessage((prevMessage)=>
            produce(prevMessage,(draft)=>{
              draft['data']['bulk_ques_resp_list']['ques_block_list'] = CURR_MULTI_SUBFORM_TEMP
            }))
            console.log(' curr subform :: ',CURR_MULTI_SUBFORM_TEMP)
            console.log('message object :: ',message)
            if(CURR_MULTI_SUBFORM_TEMP[curr_date_pick_sub_form_indx][curr_date_pick_ques_indx].validator){
              console.log('check object :: ',curr_date_pick_sub_form_indx,curr_date_pick_ques_indx)
              handlePsaValidator(CURR_MULTI_SUBFORM_TEMP[curr_date_pick_sub_form_indx][curr_date_pick_ques_indx].validator,new_formdate,curr_date_pick_sub_form_indx,curr_date_pick_ques_indx,curr_date_pick_sub_form_indx,CURR_MULTI_SUBFORM_TEMP[curr_date_pick_sub_form_indx][curr_date_pick_ques_indx],'multi_subform_input',null)
            }
        }
      }
      else{
        const updatedResponses = {...message};
        updatedResponses.data.form_list[curr_date_pick_form_indx].ques_resp_list.data.list[curr_date_pick_ques_indx].response = new_formdate;
        setMessage(updatedResponses);
        console.log('update responses :: ',updatedResponses)
        if(updatedResponses.data.form_list[curr_date_pick_form_indx].ques_resp_list.data.list[curr_date_pick_ques_indx].validator){
          handlePsaValidator(updatedResponses.data.form_list[curr_date_pick_form_indx].ques_resp_list.data.list[curr_date_pick_ques_indx].validator,new_formdate,curr_date_pick_form_indx,curr_date_pick_ques_indx,curr_date_pick_sub_form_indx,updatedResponses.data.form_list[curr_date_pick_form_indx].ques_resp_list.data.list[curr_date_pick_ques_indx],'form_submit_subform_row',null)
        }
      }
      handleDatePickClose()
    }

    function handleMasterSerach(e){
      // ////console.log('on search :: ',e);
      setsubform_search_key(e);
    }

    const enterKeyPress = (event, funct_trigg) => {
      if (event.key === 'Enter') {
        if (event.shiftKey) {
          // Handle shift + enter for creating a new line
          event.preventDefault();
          const currentValue = updateNoteTaskform.description;
          const cursorPosition = event.target.selectionStart;
          const newValue =
            currentValue.substring(0, cursorPosition) + '\n' + currentValue.substring(cursorPosition);
          handleUpdateNoteDescr(newValue);
        } else if (event.ctrlKey || event.metaKey) {
          // Handle ctrl + enter for creating a new line
          event.preventDefault();
          const currentValue = updateNoteTaskform.description;
          const cursorPosition = event.target.selectionStart;
          const newValue =
            currentValue.substring(0, cursorPosition) + '\n' + currentValue.substring(cursorPosition);
          handleUpdateNoteDescr(newValue);
        } else {
          // Handle regular enter key press
          event.preventDefault(); // Prevent the default form submission behavior
          const isMessageEmpty = updateNoteTaskform.description.trim() === '';
          if (isMessageEmpty) {
            if (funct_trigg === 'master_search') {
              triggerMasterSearch(message_index);
            }
          }

          if (!isMessageEmpty) {
            if (funct_trigg === 'update_note') {
              UpdateTaskNotes();
            }
          }
          
        }
      }
    };

    function showFileUpload(message_index,formIndex,ques_inx,formtype,curr_resp,file_upld_type = 'form_response',is_multiple_subform = false,mul_sub_index = null){
      setvisibleFileUpload(true);
      setFileUploadDisable(false);
      settemp_Upld_fileList([]);
      setfileuploadType(file_upld_type);
      if (file_upld_type === 'form_response'){
        setCurr_act_mess_indx(message_index);
        setCurr_act_form_indx(formIndex);
        setCurr_act_ques_indx(ques_inx)
        setCurr_act_form_type(formtype)
        setCurr_act_is_multi(is_multiple_subform)
        setCurr_act_sub_form_indx(mul_sub_index)
      }
    }

    function cancelfileupload(){
      setvisibleFileUpload(false);
      settemp_Upld_fileList([]);
    }

    const handleUplloadedFileChange = (event) => {
      if(event.target.files.length){
        const newFiles = Array.from(event.target.files);
        settemp_Upld_fileList([...temp_Upld_fileList, ...newFiles]);      }
    };

    const handleRemoveUploadedFile = (index) => {
      const updatedFiles = [...temp_Upld_fileList];
      updatedFiles.splice(index, 1);
      settemp_Upld_fileList(updatedFiles);
    };

    function confirmFileUpload(){
      setFileUploadDisable(true)
      setLoading2(true)
      const formData = new FormData()
      let caption = {};
      let file_list_size = 0
      for(let i=0;i<temp_Upld_fileList.length;i++){
        file_list_size = file_list_size +temp_Upld_fileList[i].size
      }
      ////console.log('file list size :: ',file_list_size)
      if(file_list_size > 5000000000){
        ////console.log('file size too large ')
        setLoading2(false)
        setvisibleFileUpload(false);
        props.triggerNotification('error', 'File Size Exceeds limit');
        return false
      }
      if(temp_Upld_fileList.length > 0) {
        for (let i = 0; i < temp_Upld_fileList.length; i++) {
          formData.append('attachments', temp_Upld_fileList[i], temp_Upld_fileList[i].name)
          caption[temp_Upld_fileList[i]['name']] = temp_Upld_fileList[i].iconType
        }
      }
      if(fileuploadType === 'form_response'){
        formData.append('type', 'Task')
      }else if(fileuploadType === 'bulk_form_resp_upload'){
        formData.append('type', 'form')
        formData.append('type_id', CurrBulkUplFormId)
        formData.append('form_additional_data', JSON.stringify(CurrBulkUplAddData))
      }else{
        formData.append('type', 'TaskUpdates')
      }
      formData.append('token', localStorage.getItem('vector_token'))
      formData.append('caption', JSON.stringify(caption))
      // ////console.log("file uploaded formdata ::",fileuploadType)
      if(fileuploadType === 'form_response'){
        // try{
          httpClient.post('/bot/formsFileUpload',formData )
          .then(response => {
            let res = response.data;
            
            if (res.status === true) {
              props.triggerNotification('success', 'Upload sucessfully');
              settemp_Upld_fileList([]);
              setvisibleFileUpload(false);
              console.log("curr_act_is_multi ::",curr_act_is_multi)
              for (let i = 0; i < res.data.length; i++) {
                if(curr_act_is_multi){
                  // console.log("res ::",res)
                  // const updatedResponses = [...CURR_MULTI_SUBFORM_TEMP];
                  // // console.log("curr_act_ques_indx :: ",updatedResponses[curr_act_sub_form_indx][curr_act_ques_indx])
                  // updatedResponses[curr_act_sub_form_indx][curr_act_ques_indx].user_resp_files.push(res.data[i]);
                  // setCURR_MULTI_SUBFORM_TEMP(updatedResponses);
                  setCURR_MULTI_SUBFORM_TEMP((prevTemp) => {
                    const updatedResponses = [...prevTemp];
                    // console.log("CURR_MULTI_SUBFORM_TEMP B ::",CURR_MULTI_SUBFORM_TEMP)
                    updatedResponses[curr_act_sub_form_indx] = [
                      ...updatedResponses[curr_act_sub_form_indx]
                    ];
                    updatedResponses[curr_act_sub_form_indx][curr_act_ques_indx] = {
                      ...updatedResponses[curr_act_sub_form_indx][curr_act_ques_indx],
                      user_resp_files: [
                        ...updatedResponses[curr_act_sub_form_indx][curr_act_ques_indx].user_resp_files,
                        res.data[i]
                      ]
                    };

                    on_multi_subform_row_update(curr_act_sub_form_indx,updatedResponses[curr_act_sub_form_indx]);
                    // console.log("CURR_MULTI_SUBFORM_TEMP A ::",CURR_MULTI_SUBFORM_TEMP)
                    return updatedResponses;
                  });
                  setLoading2(false)
                }else{
                  // const updatedResponses = {...message};
                  handleAllInOneResp(curr_act_form_indx, curr_act_ques_indx,'','all_in_one',null,res.data[i]);
                  // updatedResponses.data.form_list[curr_act_form_indx].ques_resp_list.data.list[curr_act_ques_indx].user_resp_files.push(res.data[i]);
                  // setMessage(updatedResponses);
                  setLoading2(false)
                }
              }
            }
            setLoading2(false)
          })
          .catch(error => {
            console.error('file upload Error 1:', error);
          });
        // } catch (error) {
        //   console.error('file upload Error 2:', error);
        // }
      }else if(fileuploadType === 'bulk_form_resp_upload'){
        try{
          httpClient.post('/forms/uploadFormResponse',formData )
          .then(response => {
            let res = response.data;
            setcurrBulkUpldProgPerct(100);
            // stopProgress();
            if (res.status === true) {
                props.triggerNotification( 'success','Form responses has been submitted successfully')
                settemp_Upld_fileList([]);
                setvisibleFileUpload(false);
            }else {
              props.triggerNotification('error','Please check the response format(s)')
            }
          })
          .catch(error => {
            console.error('file upload Error 1111:', error);
          });
        } catch (error) {
          console.error('file upload Error 2222:', error);
        }
      }else{
        try{
          httpClient.post('/file/insertFile',formData )
          .then(response => {
            let res = response.data;
            if (res.status === true) {
              props.triggerNotification('success', 'Upload sucessfully');
              settemp_Upld_fileList([]);
              setvisibleFileUpload(false);
              for (let i = 0; i < res.data.length; i++) {
                setupdateNoteTaskform((prevObject) => ({
                  ...prevObject,
                  attachments: [...prevObject.attachments, res.data[i]],
                }));
              }
            }
          })
          .catch(error => {
            console.error('file upload Error 1:', error);
          });
        } catch (error) {
          console.error('file upload Error 2:', error);
        }

      }
    }

    function removeSingleOldFile(rowid,file_indx,formIndex,ques_inx,is_multiple_subform = false,mul_sub_index = null) {
      try{
        let payload = {
          token: localStorage.getItem('vector_token'),
          file_row_id: rowid
        }
        httpClient.post('/bot/formsFileArchive',payload )
        .then(response => {
          let res = response.data;
          if (res.status === true) {
            if(is_multiple_subform){
              const updatedResponses = [...CURR_MULTI_SUBFORM_TEMP];
              updatedResponses[mul_sub_index][ques_inx].user_resp_files.splice(file_indx, 1);
              setCURR_MULTI_SUBFORM_TEMP(updatedResponses);
            }else{
              ////console.log('remove file ')
              // const updatedResponses = {...message};
              // updatedResponses.data.form_list[formIndex].ques_resp_list.data.list[ques_inx].user_resp_files.splice(file_indx, 1);
              // ////console.log('file list :: ',updatedResponses.data.form_list[formIndex].ques_resp_list.data.list[ques_inx].user_resp_files)
              // setMessage(updatedResponses);

              setMessage((prevMessage) =>
                produce(prevMessage, (draft) => {
                  draft.data.form_list[formIndex].ques_resp_list.data.list[ques_inx].user_resp_files.splice(file_indx, 1);
                  })
                );
            }
          }
        })
        .catch(error => {
          console.error('file upload Error 1:', error);
        });
      } catch (error) {
        console.error('file upload Error 2:', error);
      }
    }

    const downloadUploadedFile = (fileUrl,fileName) => {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const handleFullScreen = () => {
      ////console.log("called full screen in chat template")
      if(fullScreenToggle){
        ////console.log("close full screen");
        props.toggleFullscreen();
        ////console.log('props object :: ',props)
        setfullScreenToggle(0);
      }else{
        setfullScreenToggle(1);
        ////console.log("open full screen");
        ////console.log('props object :: ',props)
        props.toggleFullscreen();
      }
      ////console.log('Dropdown dimensions:', document.getElementById('demo-simple-select-autowidth').getBoundingClientRect());
      
    };

    function tagOptionCheckChange(present_val,option_indx,option_data,resp_type,mess_indx,formIndex,ques_indx,form_type,is_multiple_subform = false,mul_sub_index = null){
      ////console.log("on check event :: ",present_val)
      if (form_type ==='all_in_one'){ 
        if(!is_multiple_subform){
          // const updatedMessage = {...message};          
          // if(!present_val){
          //   let curr_resp = ((resp_type === 7 ||  resp_type === 8 ||  resp_type === 11) ? option_data['id'] : option_data['val'])
          //   updatedMessage['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['response'] = curr_resp
          //   updatedMessage['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['options'] = makeUncheckOptionExceptId(option_indx,message['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['options'])
          //   if(resp_type === 7 ||  resp_type === 8 ||  resp_type === 11){
          //     let ques_list = updatedMessage['data']['form_list'][formIndex]['ques_resp_list']['data']['list']
          //     let ques = updatedMessage['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]
          //     onOptionSelect(ques_list,ques,mess_indx,formIndex,ques_indx,curr_resp,form_type,is_multiple_subform,mul_sub_index)
          //   }
            
          // }else{
          //   updatedMessage['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['response'] = ""
          // }
          // updatedMessage['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['options'][option_indx]['checked'] = !present_val
          // setwidgets(updatedMessage);

          setMessage(produce((draft=>{       
          if(!present_val){
            let curr_resp = ((resp_type === 7 ||  resp_type === 8 ||  resp_type === 11) ? option_data['id'] : option_data['val'])
            draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['response'] = curr_resp
            draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['options'] = makeUncheckOptionExceptId(option_indx,message['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['options'])
            if(resp_type === 7 ||  resp_type === 8 ||  resp_type === 11){
              let ques_list = draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list']
              let ques = draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]
              onOptionSelect(ques_list,ques,mess_indx,formIndex,ques_indx,curr_resp,form_type,is_multiple_subform,mul_sub_index)
            }
            
          }else{
            draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['response'] = ""
          }
          draft['data']['form_list'][formIndex]['ques_resp_list']['data']['list'][ques_indx]['options'][option_indx]['checked'] = !present_val
          })))
        }else{
          setCURR_MULTI_SUBFORM_TEMP(produce((draft) => {
            if (!present_val) {
              let curr_resp = resp_type === 7 || resp_type === 8 || resp_type === 11 ? option_data['id'] : option_data['val'];
              draft[mul_sub_index][ques_indx]['response'] = curr_resp;
              draft[mul_sub_index][ques_indx]['options'] = makeUncheckOptionExceptId(option_indx, draft[mul_sub_index][ques_indx]['options']);
        
              if (resp_type === 7 || resp_type === 8 || resp_type === 11) {
                let ques_list = draft[mul_sub_index];
                let ques = draft[mul_sub_index][ques_indx];
                onOptionSelect(ques_list, ques, mess_indx, formIndex, ques_indx, curr_resp, form_type, is_multiple_subform, mul_sub_index);
              }
            } else {
              draft[mul_sub_index][ques_indx]['response'] = "";
            }
        
            draft[mul_sub_index][ques_indx]['options'][option_indx]['checked'] = !present_val;
          }));
          on_multi_subform_row_update(mul_sub_index)
        }
      }
    }

    function makeUncheckOptionExceptId(expOptId, option_list) {
      return option_list.map((option, opIndx) => ({
        ...option,
        checked: expOptId !== opIndx ? false : option.checked,
      }));
    }
  
    // function makeUncheckOptionExceptId(expOptId,option_list){
    //   for(let opIndx = 0;opIndx < option_list.length; opIndx++){
    //     if(expOptId !== opIndx){
    //       option_list[opIndx]["checked"] = false;
    //     }
    //   }
    //   return option_list;
    // }

    function clear_checked_if_tag_enable(options) {
      return options.map((originalOption) => ({
        ...originalOption,
        checked: false,
      }));
    }

    function returnImgTitle(item,currIndx,total_len){
      let imgName = ''
      if('custom_field_key' in item){
        imgName = item.custom_field_key + ' - ' + item.file_name
      }else{
        imgName = item.file_name
      }
      return imgName + ' (' + String(currIndx + 1) + '/' + String(total_len) + ')'
    }

    function onImgSlide(event){
      // ////console.log("on img slide",event)
      if(event === 'next' && ((currImgIndx + 1) < imageObject.length)){
        setcurrImgIndx(currImgIndx + 1)
      }
      else if((currImgIndx - 1) >= 0){
        setcurrImgIndx(currImgIndx - 1)
      }
    }

    function onCfImgSlide(event){
      // ////console.log("on img slide",event)
      ////console.log('cf curr img index before :: ',CfcurrImgIndx)
      if(event === 'next' && ((CfcurrImgIndx + 1) < CFimageObject.length)){
        setCfcurrImgIndx(CfcurrImgIndx + 1)
      }
      else if((CfcurrImgIndx - 1) >= 0){
        setCfcurrImgIndx(CfcurrImgIndx - 1)
      }

      ////console.log('cf curr img index :: ',CfcurrImgIndx)
    }

    function construct_dirr_dwld_link(url){
      // Create a URL object
      const parsedUrl = new URL(url);
      // Using URLSearchParams to get the value of the 'file_id' parameter
      const params = new URLSearchParams(new URL(url).search);
      const fileId = params.get("file_id");
      const fullDomain = parsedUrl.origin;
      let dirr_url = (fullDomain + '/backend/database_download?file_id=' + fileId);
      return dirr_url;
    }

    function returnImgLink(item,file_name_key = 'file_name',spec_key = 'link',dirr_ink = false){
      // ////console.log("\n\ncheck img link :: ",item,file_name_key,spec_key);
      // console.log(' file item :: ',item)
      if (item[file_name_key].toLowerCase().match(/.(jpg|jpeg|png|gif|jpe|bmp|svg|webp|tiff)$/i)){
        // ////console.log("ret1",item[file_name_key]);
        return (dirr_ink ? construct_dirr_dwld_link(item[spec_key]) : item[spec_key])
      }else{
        // ////console.log("ret2");
        return (dirr_ink ? construct_dirr_dwld_link(item[spec_key]) : defFileImg)
      }
    }

    function onImgLoad(curr_indx,cfIndx = null,curr_img_indx = 0){
      // if cfIndx not null then load cf files instead task files
      ////console.log('cf indx :: ',cfIndx)
      setcurrImgIndx(curr_img_indx);
      let temp_img_obj = null;
      let cf_temp_obj = null;
      let initial_cf_temp_list = []
      if(cfIndx != null){
        temp_img_obj = CURR_MULTI_SUBFORM_TEMP[curr_indx][0]['master_cf'][cfIndx]['cf_files'].map((item, indx) =>
          new Object({ image: returnImgLink(item), thumbImage: returnImgLink(item),download:item.link,title: returnImgTitle(item,indx,CURR_MULTI_SUBFORM_TEMP[curr_indx][0]['master_cf'][cfIndx]['cf_files'].length)  })
        );
      }else if(CURR_MULTI_SUBFORM_TEMP[curr_indx][0]['master_file_list'].length > 0){
        temp_img_obj = CURR_MULTI_SUBFORM_TEMP[curr_indx][0]['master_file_list'].map((item, indx) =>
        {
        //   if(!('custom_field_key' in item)){
        //     new Object({ image: returnImgLink(item), thumbImage: returnImgLink(item),download:item.link,title: returnImgTitle(item,indx,CURR_MULTI_SUBFORM_TEMP[curr_indx][0]['master_file_list'].length)  })
        // }
        if (!('custom_field_key' in item)) {
          return {
              image: returnImgLink(item),
              thumbImage: returnImgLink(item),
              download: item.link,
              title: returnImgTitle(item, indx, CURR_MULTI_SUBFORM_TEMP[curr_indx][0]['master_file_list'].length)
          };
      }
      else{
        initial_cf_temp_list.push(item)
        return null;
      }
      }
          
        );
      }else{
        temp_img_obj = [{ image: empyImgLink, thumbImage: empyImgLink,title:"No images found",download:empyImgLink }]
      }
      ////console.log(' initial temp list :: ',initial_cf_temp_list)
      const filtered_temp_img_obj = temp_img_obj.filter(item => item !== null);
      ////console.log("image obj :: ",filtered_temp_img_obj);
      if(initial_cf_temp_list.length!=0){
        cf_temp_obj = initial_cf_temp_list.map((item, indx) =>
        new Object({ image: returnImgLink(item), thumbImage: returnImgLink(item),download:item.link,title: returnImgTitle(item,indx,initial_cf_temp_list.length)  })
      );
      ////console.log('cf temp obj :: ',cf_temp_obj)
      setCFimageObject([...cf_temp_obj])
      }
      if(cfIndx!=null){
        ////console.log('not null')
        setCFimageObject([...filtered_temp_img_obj])
      }
      else{
        setimageObject([...filtered_temp_img_obj]);
      }
      
      ////console.log('final image object :: ',imageObject)
      ////console.log('finnal cf image obj  :: ',CFimageObject)
      ////console.log('final cf curr indedx :: ',CfcurrImgIndx )
      ////console.log('final cf :: ',currImgIndx)
    }

    function move_to_form_view(curr_indx,cfIndx = null){
      setcurr_card_view_form_ind(curr_indx);
      onImgLoad(curr_indx)
    }

    function expMultisubRow(task_id,mul_sub_index){
      setform_display_view('single_mul_sub_row');
      // // ////console.log("expMultisubRow ::")
      move_to_form_view(mul_sub_index);
      getTaskUpdateNotes(task_id);
      refresh_update_note_form();
      set_update_not_task_id(task_id);
    }

    function getTaskUpdateNotes(task_id){
      expMasterTaskUpdates = null;
      const data = {
        token: localStorage.getItem('vector_token'),
        task_id:task_id
      }
      try{
        httpClient.post('/bot/getTaskUpdates',data )
        .then(response => {
          let resp = response.data;
          if(resp.status){
            setexpMasterTaskUpdates(resp.data);
            // ////console.log("getTaskUpdates 1 :: ",resp.data)
          }
        })
        .catch(error => {
          console.error('getTaskUpdates 2:', error);
        });
      } catch (error) {
        console.error('getTaskUpdates 3:', error);
      }
    }

    function refresh_update_note_form(){
      setupdateNoteTaskform({
        description: "",
        attachments: [],
        task_id: "",
        revision: 0
      });
    }

    function set_update_not_task_id(master_task_id){
      setupdateNoteTaskform((prevObject) => ({
        ...prevObject,
        task_id: master_task_id,
      }));
    }

    function handleUpdateNoteDescr(e){
      setupdateNoteTaskform((prevObject) => ({
        ...prevObject,
        description: e,
      }));
    }

    function revert_to_mul_sub_view(){
      setform_display_view('multi_sub');
    }

    function reset_update_note_form(){
      setupdateNoteTaskform((prevObject) => ({
        ...prevObject,
        description: "",
        attachments: []
      }));
    }

    function UpdateTaskNotes(){
      try{
        let data ={
          token: localStorage.getItem('vector_token'),
          data:updateNoteTaskform
        }
        httpClient.post('/task/task_updates',data )
        .then(response => {
          let res = response.data;
          if(res.status){
            reset_update_note_form();
            getTaskUpdateNotes(updateNoteTaskform.task_id);
            props.triggerNotification('success','updated successfully');
          } else {
            props.triggerNotification('error', 'Please try again later');
          }
        })
        .catch(error => {
          console.error('getTaskUpdates 2:', error);
        });
      } catch (error) {
        console.error('getTaskUpdates 3:', error);
      }
      
    }

    function removeUpdNoteOldFile(indexToRemove, rowId) {
      try{
        let playLoad = {
          token: localStorage.getItem('vector_token'),
          file_row_id: rowId,
        }
        httpClient.post('/file/removeS3File',playLoad )
        .then(response => {
          let res = response.data;
          if (res.status === true) {
            setupdateNoteTaskform((prevObject) => ({
              ...prevObject,
              attachments: prevObject.attachments.filter((_, index) => index !== indexToRemove),
            }));
            props.triggerNotification('success', 'Files Removed');
          } else {
            props.triggerNotification('error', 'Please try again later');
          }
        })
        .catch(error => {
          console.error('removeS3File 2:', error);
        });
      } catch (error) {
        console.error('removeS3File 3:', error);
      }
    }

    function openImgGal(eIndx,cfIndx = null,masterIndx = null){
      if (cfIndx!=null){
        setCfimgGalVisible(true)
        setCfcurrImgIndx(eIndx)
      }
      else{
        setimgGalVisible(true);
        setcurrImgIndx(eIndx);
      }
      
      ////console.log('epindx, cf index :: ',eIndx,cfIndx)
      
      if(masterIndx != null){
        onImgLoad(masterIndx,cfIndx,eIndx);
      }
    }

    function closeImgGal(){
      setimgGalVisible(false);
    }

    function closeCfImgGal(){
      setCfimgGalVisible(false)
    }

    function showBulkImpExp(form_data,form_indx,form_id,export_form_type = 'all',export_with_master = false){
      // ////console.log("form id :: ",form_id)
      setBulkExImp(true);
      setCurrBulkUplFormIndx(form_indx);
      setCurrBulkUplFormId(form_id);
      setCurrBulkUplFormType(export_with_master);
      let curr_BulkFormUpload__addData = {
                                            scope : form_data.scope,
                                            Task_association : form_data.Task_association,
                                            revision : form_data.revision,
                                            cf_instance_id : form_data.cf_instance_id,
                                            task_id : form_data.task_id,
                                            contrib_id : form_data.contrib_id,
                                            export_form_type : export_form_type,
                                            search : ''
                                        }
      setCurrBulkUplSubFormId(form_data.subform_id);
      setCurrBulkUplAddData(curr_BulkFormUpload__addData);
    }

    function closeBulkExpImp(){
      setBulkExImp(false);
    }

    function exportFromRespTemplate(dirr_val = null){
      setLoading(true)
      ////console.log('dirr_val :: ',dirr_val)
      ////console.log('curr bulk upload data :: ',CurrBulkUplAddData)
      if(dirr_val == null){
        ////console.log('bulk form ::')
        CurrBulkUplAddData['export_form_type'] ='all'
        CurrBulkUplAddData['subform_id'] = undefined
      }
      ////console.log('curr bulk upload data after change :: ',CurrBulkUplAddData)
      try{
        const postdata = {
          token: localStorage.getItem('vector_token'),
          form_id : CurrBulkUplFormId,
          form_additional_data : (dirr_val !== null ? dirr_val : CurrBulkUplAddData)
        }
        ////console.log('postdata :: ',postdata)
        httpClient.post('/forms/exportFormRespTemplate',postdata,{
          responseType: 'arraybuffer'})
        .then(response => {
          ////console.log('response data :: ',response.data)
          downLoadFile(response.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;")
          setLoading(false)
        })
        .catch(error => {
          console.error('exportFormRespTemplate 2:', error);
        });
      } catch (error) {
        console.error('exportFormRespTemplate 3:', error);
      }
    }

  function downLoadFile(data, type) {
    var a = document.createElement("a");
    document.body.appendChild(a);

    let blob = new Blob([data], { type: type});
    // ////console.log("blob  :: ",blob)
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "Bulk_Response_Upload_" +  new Date().getTime() + EXCEL_EXTENSION
    a.click();
    window.URL.revokeObjectURL(url);
  }

  function refreshBulkFileUpldStatus(){
    try{
      const postdata ={
        token:localStorage.getItem('vector_token'),
        upload_type_id : CurrBulkUplFormId
      }
      httpClient.post('/get_bulk_upload_status',postdata)
      .then(response => {
        let res = response.data;
        if(res.status===true){
          setFile_status_list(res.data);
        }
      })
      .catch(error => {
        console.error('get_bulk_upload_status 2:', error);
      });
    } catch (error) {
      console.error('get_bulk_upload_status 3:', error);
    }
  }

  function openFileStatusModal(){
    setfileStatusModal(true);
    refreshBulkFileUpldStatus();
  }

  function closeBulkImpFileStatus(){
    setfileStatusModal(false);
  }

  function download_uploaded_file(file_id){
    try{
      const postdata = {
        token: localStorage.getItem('vector_token'),
        file_id : file_id
      }
      httpClient.post('/get_file_obj_from_file_id',postdata,{
        responseType: 'arraybuffer'})
      .then(response => {
        downLoadFile(response.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;")
      })
      .catch(error => {
        console.error('get_file_obj_from_file_id 2:', error);
      });
    } catch (error) {
      console.error('get_file_obj_from_file_id 3:', error);
    }
  }

  function download_uploaded_file_with_status(form_id,bu_instance_id,uploaded_file_id){
    try{
      const postdata ={
        token:localStorage.getItem('vector_token'),
        form_id : form_id,
        instance_id: bu_instance_id,
        file_id : uploaded_file_id
      }
      httpClient.post('/exp_bulk_upl_file_with_status',postdata,{
        responseType: 'arraybuffer'})
      .then(response => {
        downLoadFile(response.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;")
      })
      .catch(error => {
        console.error('exp_bulk_upl_file_with_status 2:', error);
      });
    } catch (error) {
      console.error('exp_bulk_upl_file_with_status 3:', error);
    }
  }

  function download_failed_rows(inst_id){
    let temp_add_data = {
      "Task_association": 0,
      "cf_instance_id": null,
      "contrib_id": null,
      "export_form_type": "all",
      "revision": null,
      "scope": "",
      "search": "",
      "task_id": null
    }
    try{
      const postdata={
        token: localStorage.getItem('vector_token'),
        instance_id:inst_id,
        form_additional_data : temp_add_data
      }
      httpClient.post('/export_bulk_upload_rejected_rows',postdata,{
        responseType: 'arraybuffer'})
      .then(response => {
        downLoadFile(response.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;")
      })
      .catch(error => {
        console.error('export_bulk_upload_rejected_rows 2:', error);
      });
    } catch (error) {
      console.error('export_bulk_upload_rejected_rows 3:', error);
    }
  }

  function exportMaster(){ 
    setLoading(true)
    let temp_currBulkUpldAddData = {...CurrBulkUplAddData};
    temp_currBulkUpldAddData['export_form_type'] = EXP_FORM_MASTER;
    temp_currBulkUpldAddData['subform_id'] = CurrBulkUplSubFormId;
    temp_currBulkUpldAddData['search'] = subform_search_key;
    exportFromRespTemplate(temp_currBulkUpldAddData);
    setCurrBulkUplAddData(temp_currBulkUpldAddData);
  }

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      '& .MuiTooltip-arrow': {
        color: theme.palette.common.white, // Match the tooltip background color
      },
    
    },
  }));

  const hasMultipleFilledResponses = (row,block_sno) => {
    // Count the number of columns with filled responses
    // ////console.log('each_row :: ',row)
    // ////console.log('mul sub index list :: ',mul_sub_index_list)
    // ////console.log('block no. :: ',block_sno)
    const filledResponsesCount = Object.values(row).reduce((count, column) => {
      return count + ((column.response.trim() !== '' || column.user_resp_files.length > 0) && mul_sub_index_list.includes(block_sno) ? 1 : 0);
    }, 0);
    // Change the threshold as needed (e.g., > 1 for more than one filled response)
    return filledResponsesCount > 1;
  };

  function imgGalDownload(imageUrl){
    window.open(imageUrl, '_blank');
  }

  function notOpt_multiSub_filt_visible(e,cf_indx){
    ////console.log("pop over filter togg :: ",e)
    if('filter_visible' in message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]){
      const updatedmessage = {...message};
      updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]['filter_visible'] = e
      setMessage(updatedmessage);
    }else{
      const updatedmessage = {...message};
      updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]['filter_visible'] = e
      updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]['selected_filters'] = []
      setMessage(updatedmessage);
    }
  }

  function on_master_cf_stat_refresh(search_key,cf_indx,each_cf){
    // try{
      ////console.log("on serch :: ",search_key.target.value);
      const postdata ={
        token:localStorage.getItem('vector_token'),
        search_key: search_key.target.value,
        quest_id: CURR_MULTI_SUBFORM_TEMP[0][0]["ques_id"],
        form_id:CURR_MULTI_SUBFORM_TEMP[0][0]["form_id"],
        instance_id:message['data']['bulk_ques_resp_list']['subform_cf_instance_id'],
        quest_id_resp_map:{},
        master_cust_fields:[each_cf]
      }
      httpClient.post('/get-master-cf-stats',postdata)
      .then(response => {
        let resp = response.data;
        if(resp.data){
          ////console.log("on cf search :: ",resp.data);
          const updatedMessage = {...message};
          updatedMessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]['filters'] = resp.data;
          setMessage(updatedMessage);
        } 
      })
    //   .catch(error => {
    //     console.error('get-master-cf-stats 2:', error);
    //   });
    // } catch (error) {
    //   console.error('get-master-cf-stats 3:', error);
    // }
  }

  function OnApplyMultiSubFilters(cf_data,cf_indx){
    closeMasterColFilter();
    ////console.log('cf data :: ',cf_data)
    const updatedmessage = {...message};
    updatedmessage['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cf_indx]['filter_visible'] = false;
    setMessage(updatedmessage);
    if(!(cf_data.selected_filters && cf_data.selected_filters.length > 0)){
      let temp_cf_filter_index = [...filter_cf_index_list]
      if(temp_cf_filter_index.includes(cf_indx)){
          temp_cf_filter_index = temp_cf_filter_index.filter((item) => item != cf_indx)
      }
      const unique_filter_cf_index_list =  Array.from(new Set(temp_cf_filter_index));   
      ////console.log('unique filter index :: ',unique_filter_cf_index_list)   
      set_filter_cf_index_list(unique_filter_cf_index_list)

    }

    ////console.log("test cf puch :: ",cf_data);
    let tempcurr_master_filter_list = {...curr_master_filter_list};
    if(cf_data.cfm_id){
      tempcurr_master_filter_list["cfm"][cf_data.cfm_id] = [];
    }
    if(cf_data.seq_id){
      tempcurr_master_filter_list["seq"][cf_data.seq_id] = [];
    }
    for(let mcf_indx = 0;mcf_indx < cf_data.selected_filters.length;mcf_indx ++ ){
      if(cf_data.cfm_id){
        if(cf_data.cfm_id in tempcurr_master_filter_list["cfm"] ){
          tempcurr_master_filter_list["cfm"][cf_data.cfm_id].push(cf_data.selected_filters[mcf_indx]["val"])
        }else{
          tempcurr_master_filter_list["cfm"][cf_data.cfm_id] = [cf_data.selected_filters[mcf_indx]["val"]]
        }
      }
      if(cf_data.seq_id){
        if(cf_data.seq_id in tempcurr_master_filter_list["seq"]){
          tempcurr_master_filter_list["seq"][cf_data.seq_id].push(cf_data.selected_filters[mcf_indx]["val"])
        }else{
          tempcurr_master_filter_list["seq"][cf_data.seq_id] = [cf_data.selected_filters[mcf_indx]["val"]]
        }
      }
    }
    setcurr_master_filter_list(tempcurr_master_filter_list);
    setmultisub_page_no(1);
    ////console.log("on aply filter event :: ",tempcurr_master_filter_list);
    onFixedMasterSearch(message_index,1,null,null,tempcurr_master_filter_list);
  }


  function enable_submit_for_all_in_one(form_list){
    // ////console.log('form list :: ',form_list)
    // set_user_fill_action(false)
    for(let form_index = 0;form_index<form_list.length;form_index++){
        for(let ques_index = 0; ques_index<form_list[form_index].ques_resp_list.data.list.length;ques_index++){
          const ques_id = form_list[form_index].ques_resp_list.data.list[ques_index].ques_id
          const ques = form_list[form_index].ques_resp_list.data.list[ques_index]
          const ques_free_text_no = form_list[form_index].ques_resp_list.data.list[ques_index].free_text
          const user_resp = form_list[form_index].ques_resp_list.data.list[ques_index].response
          const valid_check = validate_response_format(ques_id,ques,ques_free_text_no,user_resp,false)
          const mandatory_check = validate_mandatory(ques)
          let psa_validation = false;
          let comb_fq_indx = (form_index + '_' + ques_index);
          if(comb_fq_indx in PsaValMap){
            psa_validation = (!PsaValMap[comb_fq_indx].status || PsaValMap[comb_fq_indx].loading);
          }
          // //console.log('valid chaeck :: ',valid_check)
          if(valid_check == 'error' || mandatory_check == false || psa_validation){
            // //console.log('erro is thre')
            return true;
          }
        }
    }
    // ////console.log('error not there')
    return false
  }
  function enable_single_row_grid_submit(data,k){
    // set_user_fill_action(false)
    let subforms_data = data["bulk_ques_resp_list"]
    let ques_block_list = CURR_MULTI_SUBFORM_TEMP
    let temp_cf_instance_id = subforms_data["subform_cf_instance_id"]
    let whole_struct = [];
    // ////console.log('subform data :: ',subforms_data)
    // ////console.log('ques block list :: ',ques_block_list)
    // ////console.log(' k :: ',k)
    for(let subform_ques_index = 0;subform_ques_index<ques_block_list[k].length;subform_ques_index++){
      const ques_id = ques_block_list[k][subform_ques_index]['ques_id']
      const ques = ques_block_list[k][subform_ques_index]
      const ques_free_text_no = ques_block_list[k][subform_ques_index].free_text
      let response_data = get_resp_check(k,subform_ques_index,ques_block_list)
      const user_resp = response_data["resp"]
      const valid_check = validate_response_format(ques_id,ques,ques_free_text_no,user_resp,false)
      const mandatory_check = validate_mandatory(ques)
      let psa_validation = false;
      // let comb_fq_indx = (ques_block_list[k][0].response + '_' + subform_ques_index);
      let comb_fq_indx = (k+ '_' + subform_ques_index);
      if(comb_fq_indx in PsaValMap){
        psa_validation = (!PsaValMap[comb_fq_indx].status || PsaValMap[comb_fq_indx].loading);
      }
      if(valid_check == 'error' || mandatory_check == false || psa_validation){
        // //console.log('erro is thre')
        return true
      }
    }
    return false
  }

  function enable_multiple_subform_atonce_submit(data, msg_id,mess_indx){
    let subforms_data = data["bulk_ques_resp_list"]
    let bulk_upload_form_id = subforms_data['bulk_upload_form_id']
    let mandatory_check = true
    let q1_toggle = subforms_data['q1_toggle']
    let un_submited_subform_inst = CURR_MULTI_SUBFORM_CF_INST_ID
    let check_mandatory = false
    let multi_subform_resp_cache = get_userResp_TempCacheJson();
    for (const [key, ques_resp_list] of Object.entries(multi_subform_resp_cache)) {
      check_mandatory = false
      for(let j= 0;j<ques_resp_list.length;j++){
        const fixed_col_check = 'fixed_col' in ques_resp_list[j]
        if((ques_resp_list[j].response != '' && ques_resp_list[j].response != null) && fixed_col_check == false ){
          check_mandatory = true
        }
      }
      // ////console.log('check mandatory before :: ',check_mandatory)
      for(let i =0;i<ques_resp_list.length;i++){
        const valid_check = validate_response_format(ques_resp_list[i].ques_id,ques_resp_list[i],ques_resp_list[i].free_text,ques_resp_list[i].response,true)
        if(check_mandatory==true){
          mandatory_check = validate_mandatory(ques_resp_list[i])
        }
        let psa_validation = false;
        let comb_fq_indx = (q1_toggle ? (key + "_" + i) : ((key + '_' + i)));
        // let comb_fq_indx =  ('form_'+bulk_upload_form_id); 
        if(comb_fq_indx in PsaValMap){
          psa_validation = (!PsaValMap[comb_fq_indx].status || PsaValMap[comb_fq_indx].loading);
        }
        if(valid_check == 'error' || mandatory_check == false || psa_validation){
          return true
        }
      }
    }
    let ques_block_list = [];
    if(q1_toggle && (subforms_data["has_default_resp_flag"] || has_overwrite_psa_resp(CURR_MULTI_SUBFORM_TEMP[0]) || has_master_single_opt(CURR_MULTI_SUBFORM_TEMP[0]))){
      let single_ques_resp_temp = Object.assign([], message['data']['bulk_ques_resp_list']['ques_block_list'][0])
      ////console.log('single ques res temp :: ',single_ques_resp_temp)
    }
  }

  const fileInputRef = useRef(null);

  const handleClickFileUpload = () => {
    fileInputRef.current.click(); // Programmatically trigger file input click
  };

  function handleEscapeKey(event) {
    if ((event.key === 'Escape' || event.keyCode === 27) && fullScreenToggle) {
      setfullScreenToggle(0);
      props.toggleFullscreen();
    }
  }


  function close_forms(){
    set_submit_button_list([]);
    props.triggerCloseForms_check(true);
    props.setSectionIndex(props.trigger_section_index);
    props.setCompType(props.trigger_comp_type);
  }

  
  function handleTimeChange(){

  }

  const handleSelectTime = (newTime) => {
    //console.log("handleSelectTime ::",newTime);
    set_selected_time(newTime);
    if(curr_time_pick_form_type === 'all_in_one'){
      if(!curr_time_pick_is_multi){
        setMessage((prevMessage) => 
        produce(prevMessage,(draft)=>{
          //console.log('form index in change :: ',curr_time_pick_form_indx)
          //console.log('message check :: ',draft.data.form_list[curr_time_pick_form_indx])
          draft.data.form_list[0].ques_resp_list.data.list[curr_time_pick_ques_indx].response = newTime
        }));
      }
      else{
        on_multi_subform_row_update(curr_time_pick_sub_form_indx)
          setCURR_MULTI_SUBFORM_TEMP((prevMessage) => 
            produce(prevMessage, (draft) => {
              draft[curr_time_pick_sub_form_indx][curr_time_pick_ques_indx]['response'] = newTime
            })
          );
      }
    }
    else{
      const updatedResponses = {...message};
      updatedResponses.data.form_list[curr_time_pick_form_indx].ques_resp_list.data.list[curr_time_pick_ques_indx].response = newTime;
      setMessage(updatedResponses);
    }
    handleCloseMenu();
  };

  const handleCloseMenu = () => {
    SetTimeVisible(false)
    setanchorEl_time(null);
  };

  const handleSelectHours = (hour_val) => {
    setHourVal(hour_val)
    //console.log('curr_time_pick_is_multi :: ',curr_time_pick_is_multi)
    if(curr_time_pick_form_type == 'all_in_one'){
      if(!curr_time_pick_is_multi){
        setMessage((prevMessage) => 
        produce(prevMessage,(draft)=>{
          draft.data.form_list[0].ques_resp_list.data.list[curr_time_pick_ques_indx].response = hour_val +':' + min_value
        }));
      }
      else{
        //console.log('multi subform')
        on_multi_subform_row_update(curr_time_pick_sub_form_indx)
          setCURR_MULTI_SUBFORM_TEMP((prevMessage) => 
            produce(prevMessage, (draft) => {
              //console.log('message check :: ',prevMessage)
              draft[curr_time_pick_sub_form_indx][curr_time_pick_ques_indx]['response'] = hour_val +':' + min_value
            })
          );
          setCURR_MULTI_SUBFORM_TEMP((prevMessage) =>
            {
              const updatedCURR_MULTI_SUBFORM_TEMP = produce(prevMessage, (draft) => {
              draft[curr_time_pick_sub_form_indx][curr_time_pick_ques_indx]['response'] = hour_val +':' + min_value;
              
            });
            on_multi_subform_row_update(curr_time_pick_sub_form_indx,updatedCURR_MULTI_SUBFORM_TEMP[curr_time_pick_sub_form_indx]);
            return updatedCURR_MULTI_SUBFORM_TEMP;
          }
          );
      }
    }
    else{
      const updatedResponses = {...message};
      updatedResponses.data.form_list[curr_time_pick_form_indx].ques_resp_list.data.list[curr_time_pick_ques_indx].response = hour_val +':' + min_value;
      setMessage(updatedResponses);
    }

  }

  const handleSelectMinutes = (min_val) => {
    setMinVal(min_val)
    if(curr_time_pick_form_type == 'all_in_one'){
      if(!curr_time_pick_is_multi){
        setMessage((prevMessage) => 
        produce(prevMessage,(draft)=>{
          draft.data.form_list[0].ques_resp_list.data.list[curr_time_pick_ques_indx].response = hour_value +':' + min_val
        }));
      }
      else{
        on_multi_subform_row_update(curr_time_pick_sub_form_indx)
          setCURR_MULTI_SUBFORM_TEMP((prevMessage) => 
            produce(prevMessage, (draft) => {
              //console.log('message check :: ',prevMessage)
              draft[curr_time_pick_sub_form_indx][curr_time_pick_ques_indx]['response'] = hour_value +':' + min_val
            })
          );
          setCURR_MULTI_SUBFORM_TEMP((prevMessage) =>
            {
              const updatedCURR_MULTI_SUBFORM_TEMP = produce(prevMessage, (draft) => {
              draft[curr_time_pick_sub_form_indx][curr_time_pick_ques_indx]['response'] = hour_value +':' + min_val;
              
            });
            on_multi_subform_row_update(curr_time_pick_sub_form_indx,updatedCURR_MULTI_SUBFORM_TEMP[curr_time_pick_sub_form_indx]);
            return updatedCURR_MULTI_SUBFORM_TEMP;
          }
          );
      }
    }
    else{
      const updatedResponses = {...message};
      updatedResponses.data.form_list[curr_time_pick_form_indx].ques_resp_list.data.list[curr_time_pick_ques_indx].response = hour_value +':' + min_val;
      setMessage(updatedResponses);
    }
  }

  const closeHoursandMinWindow = () =>{
    SetHoursTimeVisible(false);
    setanchorEl_hrm(null);
  }

  // Add event listener for the keydown event
  document.addEventListener('keydown', handleEscapeKey);

  const parseTimeStringToDate = (timeString) => {
    if (!timeString || !timeString.includes(':')) return null; // Return null if timeString is empty
    // Define values for hours and minutes
    console.log('timestring :: ',timeString)
    const [hours, minutes] = timeString.split(':').map(Number);
    // liveDate is declared in starting
    // Set the hours and minutes to the predefined values
    liveDate.setHours(hours);
    liveDate.setMinutes(minutes);
    liveDate.setSeconds(0); // Ensure seconds are set to 0 to remove any existing seconds
    // // Get the time zone offset in minutes
    // const timeZoneOffset = liveDate.getTimezoneOffset();

    // // Adjust the time zone offset to convert to UTC time
    // liveDate.setMinutes(liveDate.getMinutes() + timeZoneOffset);

    // Format the date-time string as 'YYYY-MM-DDTHH:mm'
    const formattedDateTime = liveDate.toString();
    let tempDateobj = dayjs(formattedDateTime);
    // //console.log("parseTimeStringToDate :: ",liveDate,hours, minutes,formattedDateTime,tempDateobj);
    return tempDateobj;
  };

  // Handler function for input change
 function handlePsaValidator(validator_info,inputData,formIndx,QuesIndx,mul_sub_index,ques_data,data_type,whole_data,actual_data = null,multi_ques_block_list = null){
    // console.log("handlePsaValidator :: ",inputData,formIndx,QuesIndx,mul_sub_index,ques_data);
    // Trigger API call with debouncing
    // console.log('data type :: ',data_type)
    // console.log('message :: ',ques_data)
    // console.log('input data :: ',inputData)
    // console.log('ques index :: ',QuesIndx)
    // console.log('form index :: ',formIndx)
    // console.log('mulsub index :: ',mul_sub_index)
    let resp_obj = null
    let valid_status = false
    let Message = null
    let curr_multi_subform = null
    let bulk_upload_form_id = null
    let each_row_submit = false
    if(actual_data!=null && data_type == 'all_in_one_input'){
      // console.log('all in one condition ',actual_data)
      Message = actual_data
    }
    else if (data_type == 'all_in_one_input' && actual_data == null){
      Message = message
    }
    if(data_type == 'multi_subform_input' && actual_data!=null){
      Message = actual_data
      curr_multi_subform = multi_ques_block_list
      // console.log('Message ccheck key :: ',Message)
       bulk_upload_form_id = Message['data']['bulk_ques_resp_list']['bulk_upload_form_id']
       each_row_submit = Message['data']['bulk_ques_resp_list']['each_row_submit']
    }
    else if(data_type == 'multi_subform_input' && actual_data==null){
      Message = message
      curr_multi_subform = CURR_MULTI_SUBFORM_TEMP
      // console.log('Message ccheck key :: ',Message)
      bulk_upload_form_id = Message['data']['bulk_ques_resp_list']['bulk_upload_form_id']
      each_row_submit = Message['data']['bulk_ques_resp_list']['each_row_submit']
    }
    // console.log('Message :: ',Message)
    if(data_type == 'all_in_one_input'){
      // console.log('check immutability of parent object :: ',isImmutable(Message.data.form_list[formIndx].ques_resp_list.data.list[QuesIndx]))
      resp_obj = JSON.parse(JSON.stringify(Message.data.form_list[formIndx]))
    }
    else if (data_type == 'multi_subform_input'){
      // console.log('message object :: ',message)
      resp_obj = {'form_id':Message['data']['form_list'][0]['bulk_upload_form_id'],'cf_instance_id':Message['data']['form_list'][0]['ques_resp_list']['data']['list'][0]['cf_instance_id']}
      // console.log('resp object :: ',CURR_MULTI_SUBFORM_TEMP[mul_sub_index])
      resp_obj['ques_list'] = JSON.parse(JSON.stringify(curr_multi_subform[mul_sub_index]))
      if(inputData!= null && inputData.constructor == Object && resp_obj !={}){
        if(inputData.id!=''){
          resp_obj['ques_list'][QuesIndx]['response'] = inputData.id
        }
        else{
          resp_obj['ques_list'][QuesIndx]['response'] = inputData.val
        }
      }
      else{
        resp_obj['ques_list'][QuesIndx]['response'] = inputData
      }
    }
    else if(data_type == 'form_submit_subform_row'){
      resp_obj = inputData['dirrect_database_upload_grid_row_submit_dream_dash']
    }
    // let resp_obj = {...message.data.form_list[formIndx]}
    // console.log('new obj :: ',resp_obj)
    // console.log('data type cerck  :: ',data_type)
    const type = data_type
    if(inputData == 'form_submit'){
      resp_obj = ques_data
    }

    // console.log('ques data :: ',Message.data.form_list[formIndx])
    
    if((data_type == 'all_in_one_input' )  && Object.keys(resp_obj).length !== 0 && inputData!='form_submit'){
      if(inputData!= null && inputData.constructor == Object && resp_obj !={})
      {
        // console.log('resp obj check :: ',resp_obj.ques_resp_list.data.list[QuesIndx].response)
        if (inputData.id != ''){
          // console.log('id check :: ')
          resp_obj.ques_resp_list.data.list[QuesIndx].response = inputData.id
        }
        else{
          resp_obj.ques_resp_list.data.list[QuesIndx].response = inputData.val
        }
        // console.log('resp obj :: ',resp_obj)
      }
      else if ( Object.keys(resp_obj).length !== 0 && inputData!='form_submit'){
        if (data_type == 'all_in_one_input'){
          // console.log('free text check :: ',inputData)
          // console.log('check mutability :: ',isImmutable(resp_obj.ques_resp_list.data.list[QuesIndx].response))
          resp_obj.ques_resp_list.data.list[QuesIndx].response = inputData
          // resp_obj = null
      } 
    }      
  }

   
    // console.log('initialised resp obj with user responses :: ',resp_obj)
    let inputId = (formIndx + '_' + QuesIndx);
    let inputID_2 = ('form_'+bulk_upload_form_id)
    // console.log("inputId :: ",inputId);
    
    // Set loading state to true for this input field
    if ( true){
      // console.log('psa val map set')
      if(!(inputId in PsaValMap)){
        // console.log('loadign set imput id :: ',inputId)
        setPsaValMap(previousState => ({
          ...previousState,
          [inputId]: { loading: true, status: true, value: '',timeoutId: null }
        }));
      }else{
        if(!PsaValMap[inputId].loading){
          // console.log('loadign set 2 :: ',PsaValMap)
          setPsaValMap(previousState => ({
            ...previousState,
            [inputId]: { loading: true, status: true, value: '',timeoutId: null }
          }));
        }
        if(PsaValMap[inputId].timeoutId){
          // console.log('loadign set time :: ',PsaValMap)
          clearTimeout(PsaValMap[inputId].timeoutId);
        }
      }
      }



    // Set new timeout
    const newTimeoutId = setTimeout(() => {
      try{
        // console.log('data type cehck :: ',type)
        // console.log("display message obj :: ",Message.data.form_list[formIndx])
        const postdata={
          token: localStorage.getItem('vector_token'),
          input: resp_obj, //resp_obj
          data_type: type,
          validator_info: validator_info
        }
        // console.log('input data before payload :: ',inputData)
        if ( true){
          httpClient.post('/bot/psaValidMiddleWare',postdata)
          .then(respBody => {
              let res = respBody.data;
              // console.log(`API response for ${inputId}:`, res);
              // Update state with response details
              // setPsaValMap(prevState => ({
              //   ...prevState,
              //   [inputId]: { loading: false, status: res.status, value: res.data } // Store loading state and response
              // }));
              // console.log('res :: ',res)
              set_psa_val_submit(res.status)
              valid_status = res.status
              setPsaValMap(previousState => ({
                ...previousState,
                [inputId]: {loading: false, status: res.status, value: res.data, timeoutId:null}
              }));
            }).catch(error => {
              console.error('dynApi Error 1:', error);
            });

        }
      } catch (error) {
        console.error('dynApi Error 2:', error);
      }
      // setTimeoutId(null); // Reset timeoutId after execution
    }, 2000);

    // // Update timeoutId state variable
    // setTimeoutId(newTimeoutId);
    setPsaValMap(previousState => ({
      ...previousState,
      [inputId]: {
        ...previousState[inputId], // Copy the previous state of the specific inputId
        timeoutId: newTimeoutId // Update the timeoutId value
      }
    }));
    // /////////////////////////////////////////////////////////////////////////
    // console.log('valid status :: ',valid_status)
    // valid_status = true
    return valid_status
  };


  function debouncedhandlePsaValidator(validatorInfo,inputData,formIndx,QuesIndx,mul_sub_index,ques_data,data_type,whole_data,actual_data = null,multi_ques_block_list = null){
      handlePsaValidator(validatorInfo,inputData, formIndx, QuesIndx, mul_sub_index, ques_data,data_type,whole_data, actual_data,multi_ques_block_list);
  };

  function getrUniq_Id(formIndex, qIndx, mul_sub_index, qData){
    if(mul_sub_index != null){
      return (((message['data']['bulk_ques_resp_list']['q1_toggle']) ? (
        qData.response
      ) : (
        mul_sub_index
      )) + '_' + qIndx);
    }else{
      return (formIndex + '_' + qIndx);
    }
  }

  const renderPSAVali = (formIndex, qIndx, mul_sub_index, qData) => {
    let rUniq = getrUniq_Id(formIndex, qIndx, mul_sub_index, qData)
    // console.log('runi q :: ',rUniq)
    // console.log('psa val map :: ',PsaValMap)
    return (
       (rUniq in PsaValMap)?(
          <>
            {PsaValMap[rUniq].loading ? (
              <LinearProgress/>
            ):(
              <>
                {PsaValMap[rUniq].status?(
                  <CheckIcon fontSize="small" color="success" style={{ verticalAlign: 'middle' }} />
                ):(
                  <HighlightOffIcon fontSize="small" color="error" style={{ verticalAlign: 'middle' }} />
                  // <span style={{ fontSize: 'large', color: 'red', verticalAlign: 'middle' }}>
                  //       X 
                  //     </span>
                  )}  
                <span className={`${PsaValMap[rUniq].status ? 'success' : 'fail'}`}>
                  { PsaValMap[rUniq].value}
                </span>
              </>  
            )}
          </>
        ):null
      );
  };


  const renderPSAValiStatus = (formIndex, qIndx, mul_sub_index, qData) => {
    let rUniq = null;
    if(mul_sub_index != null){
      rUniq = (((message['data']['bulk_ques_resp_list']['q1_toggle']) ? (
        qData.response
      ) : (
        mul_sub_index
      )) + '_' + qIndx);
    }else{
      rUniq = (formIndex + '_' + qIndx);
    }
    // console.log('runi q :: ',rUniq)
    // console.log('psa val map :: ',PsaValMap)
    return (
       (rUniq in PsaValMap)?(
            PsaValMap[rUniq].loading ? (
             true
            ):(
              PsaValMap[rUniq].status?  false : true    
            )
        ): false
      );
  };

  function refreshPSaVal(){
    setTimeoutId(null);
    setPsaValMap({});
  }

  function check_pre_filled_response_for_validation(form_resp){
    if(form_resp.data.form_or_sub == 'form'){
      const ques_resp_list = form_resp.data.form_list[0].ques_resp_list.data.list
      for(let i = 0; i<ques_resp_list.length;i++){
        // console.log('resp :: ',ques_resp_list.response)
        if(ques_resp_list[i].response != '' && ques_resp_list[i].response!=null && ques_resp_list[i].response != undefined && ques_resp_list[i].validator != null){
          let Response = ques_resp_list[i].response
          // console.log('free text check :: ',ques_resp_list[i].free_text)
          let temp_resp = Response
          // handleAllInOneResp(0,i,ques_resp_list[i].response,form_resp.data.form_type,null,null,ques_resp_list[i].ques_id,ques_resp_list[i],ques_resp_list[i].free_text,ques_resp_list[i].response,false)
          if([7,8,11].includes(form_resp.data.form_list[0].ques_resp_list.data.list[i].free_text)){
            // console.log('response for master :: ',Response)
            // temp_resp = (Response ? Response.id : "");
            temp_resp = Response
          }else if([9].includes(form_resp.data.form_list[0].ques_resp_list.data.list[i].free_text)){
            // //console.log("cond pass1")
            if(Response){
              
              // const dateObject = new Date(Response);
              // const hours = dateObject.getHours().toString().padStart(2, '0');
              // const minutes = dateObject.getMinutes().toString().padStart(2, '0');
              // // //console.log("cond pass2 :: ",dateObject,hours,minutes);
              // temp_resp = `${hours}:${minutes}`;
              temp_resp = Response
              // console.log('temp resp :: ',temp_resp)
            }else{
              temp_resp = "";
            }
          }else{
            // pass
          }
          Response = temp_resp
          // console.log('immediate resp :: ',Response)
          // console.log('message data :: ',form_resp)
          debouncedhandlePsaValidator(form_resp.data.form_list[0].ques_resp_list.data.list[i].validator,Response,0, i,null,form_resp.data.form_list[0].ques_resp_list.data.list[i],'all_in_one_input',form_resp.data.form_list[0], form_resp);
        }
      }
    }
    else if(form_resp.data.form_or_sub == 'subform'){
      const ques_resp_block_list = form_resp.data.bulk_ques_resp_list.ques_block_list
      for(let i = 0; i<ques_resp_block_list.length;i++){
        let ques_resp_list = ques_resp_block_list[i]
        // console.log('multi ques resp list :: ',ques_resp_list)
        for(let j = 0; j<ques_resp_block_list[i].length;j++){
          if(ques_resp_list[j].response != '' && ques_resp_list[j].response!=null && ques_resp_list[j].response != undefined && ques_resp_list[j].validator != null){
            let Response = ques_resp_list[j].response
            // console.log('free text check :: ',ques_resp_list[i].free_text)
            let temp_resp = Response
            // handleAllInOneResp(0,i,ques_resp_list[i].response,form_resp.data.form_type,null,null,ques_resp_list[i].ques_id,ques_resp_list[i],ques_resp_list[i].free_text,ques_resp_list[i].response,false)
            if([7,8,11].includes(ques_resp_list[j].free_text)){
              // console.log('response for master :: ',Response)
              // temp_resp = (Response ? Response.id : "");
              temp_resp = Response
            }else if([9].includes(ques_resp_list[j].free_text)){
              // //console.log("cond pass1")
              if(Response){
                
                // const dateObject = new Date(Response);
                // const hours = dateObject.getHours().toString().padStart(2, '0');
                // const minutes = dateObject.getMinutes().toString().padStart(2, '0');
                // // //console.log("cond pass2 :: ",dateObject,hours,minutes);
                // temp_resp = `${hours}:${minutes}`;
                temp_resp = Response
                // console.log('temp resp :: ',temp_resp)
              }else{
                temp_resp = "";
              }
            }else{
              // pass
            }
            Response = temp_resp 
            debouncedhandlePsaValidator(ques_resp_list[j].validator,Response,i, j,i,ques_resp_list[j],'multi_subform_input',form_resp.data.form_list[0],form_resp, ques_resp_block_list);
          }
          }
      }
    }
  }
      
  // html /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
  <div className={loading ? "loading-div active" : "loading-div"}>
     {loading && <img src="https://vector.cloobot.ai/backend/database_download?file_id=293c02cd-011c-4d50-8185-2f0988d0ef57" alt="Loading..." />}
  <div id='load&vwb'>
    {(wholePageLoad) ? (
    <>
      <Stack spacing={1}>
        <Skeleton
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
        <Skeleton 
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
        <Skeleton 
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
      </Stack>
    </>) : (
      <>
        { (message && message.type === 'custom_form' && message.display ==='new') ? (
          <div id='custom_forms' >
            { message.data.form_list.map((form, formIndex) => (
              <div id='section_name'>
                <div className='sectionName' id='sect_name'> 
                  <div className='sameLine' id='sameLine'> {form.name} </div>
                  <div className='sameLine' id='sameLine2'>
                    <Avatar
                      sx={{ width: 35, height: 35 , backgroundColor: 'white', color: '#00AAFF',cursor:'pointer',marginLeft: '10px'}}
                      onClick={()=>showBulkImpExp(form,formIndex,form.form_id,'all',false)}
                      title="Load bulk Response "
                    >
                      <FileUploadOutlinedIcon />
                    </Avatar>
                  </div>
                </div>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3, }} >
                  { form.ques_resp_list.data.list.map((ques, sno) => (
                    <Grid item xs={3}>
                      <Grid container key={sno} style={{ height: '100%' }}>
                        <Grid item xs={12}>
                          <div key={sno + 'q'} className='question' id={`question_${sno}`}> 
                            ({ques.ques_no}) {ques.question}{ques.mandatory === 1 && <span style={{ color: 'red' }}>*</span>}
                          </div>
                        </Grid>
                        <Grid item xs={12} sx={{display : "flex"}} >
                          <div className='quesRespBetw' id={`quesRespBetw_${sno}`}>
                              { (ques['free_text'] >= 1 && ques['file_upload'] === 0 && ques['free_text'] !== 7 && ques['free_text'] !== 8 && ques['free_text'] !== 11) ? (
                                <>
                                  {(ques['free_text'] !== 9 && ques['free_text'] !== 6 && ques['free_text'] !== 10) ? ( 
                                      <TextField
                                      multiline
                                      // rows={2}
                                        fullWidth
                                        value={ques['response']}
                                        onChange={(e) => handleAllInOneResp(formIndex,sno,e.target.value,'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false )}
                                        className="GridinputBox"
                                        error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                        helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                        key={sno + 'ft'}
                                        size='small'
                                        disabled={submit_button_list.includes(formIndex)}
                                      />
                                      
                                    ) : null}
                                  {(ques['free_text'] === 6) ? (
                                      <TextField
                                        fullWidth
                                        value={ques['response']}
                                        onChange={(e) => handleAllInOneResp(formIndex,sno,e.target.value,'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false)}
                                        className="GridinputBox"
                                        error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                        helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                        key={sno + 'ft6'}
                                        size='small'
                                        InputProps={{
                                          endAdornment: (
                                            <IconButton  onClick={(e) => mapdatepick(e,message_index,formIndex,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'],false)} >
                                              <CalendarTodayIcon style={{fontSize:'15px'}} />
                                            </IconButton>
                                          ),
                                        }}
                                        disabled={submit_button_list.includes(formIndex)}
                                      />
                                    ) : null}
                                  {(ques['free_text'] === 9) ? (
                                    //   <TextField
                                    //   fullWidth
                                    //   placeholder="HH:MM"
                                    //   value={ques['response']}
                                    //   onChange={(e) => handleAllInOneResp(formIndex,sno,e.target.value,'all_in_one')}
                                    //   className="GridinputBox"
                                    //   error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                    //   helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                    //   key={sno + 'ft9'}
                                    //   size='small'
                                    //   InputProps={{
                                    //     endAdornment: (
                                    //       <IconButton onClick={(e) =>handleTimeMenu(e,message_index,formIndex,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'],false)}>
                                    //         <AccessTimeIcon style={{fontSize:'15px'}} />
                                    //       </IconButton>
                                    //     ),
                                    //   }}
                                    // /> 
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <TimePicker 
                                              ampm={false}
                                              onChange={(e) =>handleAllInOneResp(formIndex,sno,e,'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false)}
                                              className="GridinputBox"
                                              key={sno + 'ft9'}
                                              format='HH:mm'
                                              value={parseTimeStringToDate(ques['response'])}
                                              slotProps={{ textField: { size: 'small' } }}
                                              renderInput={
                                                (params) => 
                                                <input 
                                                  {...params.inputProps}
                                                  onChange={(e) =>handleAllInOneResp(formIndex,sno,e,'all_in_one')}
                                                  error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                                  helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                                />
                                              } // Use input for displaying time
                                              
                                            /> 
                                        </LocalizationProvider>
                                    ) : null}
                                  {(ques['free_text'] === 10)?(
                                    <TextField
                                        fullWidth
                                        value={ques['response']}
                                        placeholder="HH:MM"
                                        className="GridinputBox"
                                        onChange={(e) => handleAllInOneResp(formIndex,sno,e.target.value,'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false)}
                                        error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                        helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                        key={sno + 'ft10'}
                                        size='small'
                                        InputProps={{
                                          endAdornment: (
                                            <IconButton onClick={(e) =>handleHoursTimeMenu(e,message_index,formIndex,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'],false)}>
                                              <AccessTimeIcon style={{fontSize:'15px'}} />
                                            </IconButton>
                                          ),
                                        }}
                                      />
                                  ):null} 
                                </>
                              ):null}
                              { (ques['free_text'] === 7 ||  ques['free_text'] === 8 ||  ques['free_text'] === 11) ? (
                                <>
                                  <Autocomplete
                                    options={ques['options']}
                                    getOptionLabel={(option) => (option.val) || ""}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    onChange={(e,newInputValue) => handleAllInOneResp(formIndex,sno,newInputValue,'all_in_one')}
                                    onOpen={() => reloadOptions('refresh',form['ques_resp_list']['data']['list'],ques,message_index,formIndex,sno,null,'all_in_one')}
                                    clearOnBlur
                                    clearOnEscape
                                    value={ques['options'].find(option => option.id === ques['response']) || null} // Pre-select the option if response is given
                                    disabled={submit_button_list.includes(formIndex)}
                                    renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      onChange={(event) => reloadOptions('search',form['ques_resp_list']['data']['list'],ques,message_index,formIndex,sno,event.target.value,'all_in_one')}
                                      error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                      helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                      sx={{ backgroundColor: 'white'}}
                                      size='small'
                                      disabled={submit_button_list.includes(formIndex)}
                                    />)} />
                                    <div key={sno + '_mastercf'} id= { `mastercf_${formIndex}`}>
                                      {ques['master_cf_value_pairs'].map((each_cf,each_cf_index)=>(
                                        <div key={sno + '_cf_key_val' + each_cf.cf_key + each_cf.cf_value} id={`each_cf_index_${each_cf_index}`}>
                                          {each_cf.cf_key }: {each_cf.cf_value}
                                        </div>
                                      ))}
                                    </div>
                                  </>
                              ):null}
                              { ((ques['options'].length!==0 || ques['free_text'] === 0) && ques['free_text'] !== 7 && ques['free_text'] !== 8 && ques['free_text'] !== 11 && ques['file_upload'] !== 1 && !ques['tag_option_flag']) ? (
                              
                                <Autocomplete
                                  options={ques['options']}
                                  getOptionLabel={(option) => option.val || ques['response']}
                                  onChange={(e,newInputValue) => handleAllInOneResp(formIndex,sno,(newInputValue ? newInputValue.val : ''),'all_in_one')}
                                  clearOnBlur
                                  clearOnEscape
                                  className="GridinputBox"
                                  size='small'
                                  value={ques['options'].find(option => option.val === ques['response']) || ""} // Pre-select the option if response is given
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                      helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                      sx={{ backgroundColor: 'white' }}
                                    />
                                  )}
                                  key={sno + 'ft12'}
                                />
                              ) : null} 
                              { (ques['free_text'] === 0 && ques['file_upload'] === 1) ? (
                                <>
                                <Button 
                                  fullWidth
                                  variant="contained"
                                  onClick={() => showFileUpload(message_index,formIndex,sno,'all_in_one',ques['response'],'form_response')} 
                                    sx={{backgroundColor : 'white', color: 'black',
                                          '&:hover': {
                                          backgroundColor: '#00AAFF', // Adjust the alpha value to control transparency
                                          color: 'white'
                                      } }}
                                  >
                                  <UploadFileIcon />
                                  <span> - Upload File</span>
                                </Button>
                                {(ques.user_resp_files.length > 0) ? (
                                  <Paper
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      flexWrap: 'wrap',
                                      listStyle: 'none',
                                      p: 0.5,
                                      border: '1px dotted #00AAFF',
                                      marginTop:'10px'
                                    }}
                                    component="ul"
                                  >
                                    {ques.user_resp_files.map((file, findex) => (
                                    <Chip label={file.file_name} icon={<SimCardDownloadIcon />} sx={{marginRight: '5px'}} variant="outlined" onClick={() => downloadUploadedFile(file.link,file.file_name)} onDelete={() => removeSingleOldFile(file.file_row_id,findex,formIndex,sno)} />
                                    ))}
                                  </Paper>
                                ) : null}
                                </>
                              ) : null}
                              { (ques['tag_option_flag'] && ques['file_upload'] !== 1) ? (
                                <Grid key={sno + 'ft13'} container sx={{boxShadow: '0px 0px 4px 0px #00000040',borderRadius:'5px',marginTop:'10px'}}>
                                  {ques['options'].map((option,optInd)=>(
                                    <Grid item key={optInd} >
                                      <Chip
                                      label={option['val']}
                                      style={{backgroundColor:(option['checked'] ? '#008FD7' : '#E5F6FF'),color:(option['checked'] ? 'white' : 'black'), height: '20px', margin: '4px', }}
                                      onClick={() => tagOptionCheckChange(option['checked'],optInd,option,ques['free_text'],message_index,formIndex,sno,'all_in_one')} />
                                    </Grid>
                                  ))}
                                </Grid>
                              ) : null}
                              {('edit_task_hint_val' in ques)?(
                                <span style={{fontStyle:'italic'}}><b>Current Value : </b>{ques['edit_task_hint_val']}</span>
                              ):null}
                              {renderPSAVali(formIndex,sno,null,ques)}
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    ))}
                </Grid>
                <div style={{textAlign: 'left',margin:'10px'}} id='submitBtnincformindx'>
                  {!submit_button_list.includes(formIndex) ?(
                  <Button 
                  size="large" 
                  variant="contained" 
                  color="primary" 
                  onClick={() => formsubMit(message['data']['form_list'],message['id'],'normal_sumbit',formIndex)} 
                  sx={{backgroundColor : 'white', color: 'black',
                          '&:hover': {
                          backgroundColor: '#00AAFF', // Adjust the alpha value to control transparency
                          color: 'white'
                      },borderRadius:'25px' }}
                  disabled={enable_submit_for_all_in_one(message['data']['form_list']) || submit_button_list.includes(formIndex)}
                  >
                    Submit
                    <KeyboardArrowRightIcon />
                  </Button>
                  ):null}
                  {renderPSAVali('form',form.form_id,null,form)}
                </div>
              </div>
            ))}
            {(disp_form_submit_msg)?(
              <div style={{display: 'flex', padding: '5px', alignItems: 'center'}} id='submissionMsg'>
                <div id='submission_inner' style={{fontSize:18}}><CheckCircleIcon style={{color:'#40DC3C', fontSize:40 }}></CheckCircleIcon></div>
                <div id='submission_inner_2' style={{fontSize: '20px',fontWeight: 600,marginLeft:'20px'}}>Form has been submitted successfully</div>
                <div id='btn' style={{fontSize:18,marginLeft: '55%' , color:'blue' , float:'right'}}>
                  <Button
                    size="large" 
                    variant="contained" 
                    color="primary"
                    sx={{
                      backgroundColor: '#00AAFF',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#00AAFF',
                        color: 'white'
                      },
                      borderRadius: '25px'
                    }}
                    onClick={() => close_forms()}
                  >
                    Close
                  </Button>
                </div>
              </div>
            ):null}
          </div>
 
        ) : null }
        { (message && message['type']==='menu_on_all_in_one' && message['display']==='new') ? (
          <div id='for_moaio'>
            <div id='for_all_in_one' >
              {/* Start - Normall All in one */}
              {(message['data']['form_type'] === 'form' && !have_bulk_subform(message['data'])) ? (
                <div id='form_indx'>
                  { message.data.form_list.map((form, formIndex) => (
                  <div id={`sect_index_normal_${formIndex}`}>
                    <div className='sectionName' id='sect_name_normal'> 
                    <div className='sameLine' id='same_line_normal'>{form.name}</div>
                      <div className='sameLine' id='same_line_normal_1'>
                        <Avatar
                          sx={{ width: 35, height: 35 , backgroundColor: 'white', color: '#00AAFF',cursor:'pointer',marginLeft: '10px'}}
                          onClick={()=>showBulkImpExp(form,formIndex,form.bulk_upload_form_id,'all',false)}
                          title="Load bulk Response"
                        >
                          <FileUploadOutlinedIcon />
                        </Avatar>
                      </div>
                    </div>
                    
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} >
                      { form.ques_resp_list.data.list.map((ques, sno) => (
                        <Grid item xs={3}>
                          <Grid container key={sno} style={{ height: '100%' }}>
                            <Grid item xs={12}>
                              <label className='question'>({ques.ques_no}) {ques.question}{ques.mandatory === 1 && <span style={{ color: 'red' }}>*</span>}</label>
                            </Grid>
                            <Grid item xs={12} sx={{display : "flex"}} >
                              <div className='quesRespBetw' id={`quest_and_response_normal_${sno}`}>
                                { (ques['free_text'] >= 1 && ques['file_upload'] === 0 && ques['free_text'] !== 7 && ques['free_text'] !== 8 && ques['free_text'] !== 11) ? (
                                  <>
                                    {(ques['free_text'] !== 9 && ques['free_text'] !== 6 && ques['free_text'] !== 10) ? (
                                        <TextField
                                        multiline
                                          fullWidth
                                          value={ques['response']}
                                          onChange={(e) => handleAllInOneResp(formIndex,sno,e.target.value,'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false)}
                                          error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                          helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                          key={sno + 'ft'}
                                          className="GridinputBox"
                                          size='small'
                                        />
                                      ) : null}
                                    {(ques['free_text'] === 6) ? (
                                        <TextField
                                          fullWidth
                                          value={ques['response']}
                                          onChange={(e) => handleAllInOneResp(formIndex,sno,e.target.value,'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false)}
                                          className="GridinputBox"
                                          error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                          helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                          key={sno + 'ftes'}
                                          size='small'
                                          InputProps={{
                                            endAdornment: (
                                              <IconButton  onClick={(e) => mapdatepick(e,message_index,formIndex,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'])}>
                                                <CalendarTodayIcon style={{fontSize:'15px'}} />
                                              </IconButton>
                                            ),
                                          }}
                                        />
                                      ) : null}
                                    {(ques['free_text'] === 9) ? (
                                    //  <TextField
                                    //       fullWidth
                                    //       label="HH:MM"
                                    //       placeholder="HH:MM"
                                    //       value={ques['response']}
                                    //       onChange={(e) => handleAllInOneResp(formIndex,sno,e.target.value,'all_in_one')}
                                    //       className="GridinputBox"
                                    //       error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                    //       helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                    //       key={sno + 'ft9'}
                                    //       size='small'
                                    //       InputProps={{
                                    //         endAdornment: (
                                    //           <IconButton onClick={(e) =>handleTimeMenu(e,message_index,formIndex,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'],false)}>
                                    //             <AccessTimeIcon style={{fontSize:'15px'}} />
                                    //           </IconButton>
                                    //         ),
                                    //       }}
                                    //     />
                                    
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                          <TimePicker 
                                            ampm={false}
                                            onChange={(e) =>handleAllInOneResp(formIndex,sno,e,'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false)}
                                            className="GridinputBox"
                                            key={sno + 'ft9'}
                                            format='HH:mm'
                                            value={parseTimeStringToDate(ques['response'])}
                                            slotProps={{ textField: { size: 'small' } }}
                                            renderInput={
                                              (params) => 
                                              <TextField
                                                {...params}
                                                fullWidth 
                                                onChange={(e) =>handleAllInOneResp(formIndex,sno,e,'all_in_one')}
                                                error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                                helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)} 
                                                InputProps={{ inputProps: { step: 60 } }} // Set step prop to 60 seconds (1 minute)
                                              />
                                            } // Use input for displaying time
                                            
                                          /> 
                                      </LocalizationProvider>
                                      ) : null}
                                          
                                    {(ques['free_text'] === 10)?(
                                      <TextField
                                          fullWidth
                                          value={ques['response']}
                                          placeholder="HH:MM"
                                          className="GridinputBox"
                                          onChange={(e) => handleAllInOneResp(formIndex,sno,e.target.value,'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false)}
                                          error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                          helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                          key={sno + 'ft10'}
                                          size='small'
                                          InputProps={{
                                            endAdornment: (
                                              <IconButton onClick={(e) =>handleHoursTimeMenu(e,message_index,formIndex,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'])}>
                                                <AccessTimeIcon style={{fontSize:'15px'}} />
                                              </IconButton>
                                            ),
                                          }}
                                        />
                                    ):null}     
                                  </>
                                ):null}
                                { (ques['free_text'] === 7 ||  ques['free_text'] === 8 ||  ques['free_text'] === 11) ? (
                                  <>
                                    <Autocomplete
                                      options={ques['options']}
                                      getOptionLabel={(option) => option.val || ""}
                                      getOptionSelected={(option, value) => option.id === value.id}
                                      onChange={(e,newInputValue) => handleAllInOneResp(formIndex,sno,newInputValue,'all_in_one')}
                                      onOpen={() => reloadOptions('refresh',form['ques_resp_list']['data']['list'],ques,message_index,formIndex,sno,null,'all_in_one')}
                                      clearOnBlur
                                      clearOnEscape
                                      className="GridinputBox"
                                      size='small'
                                      value={ques['options'].find(option => option.id === ques['response']) || null} // Pre-select the option if response is given
                                      id={`ddoption_${sno}`}
                                      renderOption={(props, option) => (
                                        <Box id={`option_${sno}`} component="li" {...props} key={option.id}>
                                          {option.val}
                                        </Box>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          fullWidth
                                          onChange={(event) => reloadOptions('search',form['ques_resp_list']['data']['list'],ques,message_index,formIndex,sno,event.target.value,'all_in_one')}
                                          error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                          helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                          sx={{ backgroundColor: 'white'}}
                                          disabled={submit_button_list.includes(formIndex)}
                                        />
                                      )}
                                    />
                                    {/* {JSON.stringify(ques['master_cf_value_pairs'])} */}
                                    <div key={sno + '_mastercf'} id={`mastercf_pairs_${formIndex}`}>
                                      {ques['master_cf_value_pairs'].map((each_cf,each_cf_index)=>(
                                        <div key={sno + '_cf_key_val' + each_cf.cf_key + each_cf.cf_value} id={`each_cf_key_val_${each_cf_index}`}>
                                          {each_cf.cf_key }: {each_cf.cf_value}
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                ):null}
                                { ((ques['options'].length!==0 || ques['free_text'] === 0) && ques['free_text'] !== 7 && ques['free_text'] !== 8 && ques['free_text'] !== 11 && ques['file_upload'] !== 1) ? (
                                
                                  <Autocomplete
                                    options={ques['options']}
                                    getOptionLabel={(option) => option.val || ques['response']}
                                    onChange={(e,newInputValue) => handleAllInOneResp(formIndex,sno,(newInputValue ? newInputValue.val : ''),'all_in_one',null,null,ques['ques_id'],ques,ques['free_text'],ques['response'],false)}
                                    clearOnBlur
                                    clearOnEscape
                                    className="GridinputBox"
                                    size='small'
                                    value={ques['options'].find(option => option.val === ques['response']) || ""} // Pre-select the option if response is given
                                    renderInput={(params) => (
                                      <TextField id={`renderinput_${sno}`}
                                        {...params}
                                        fullWidth
                                        error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],false) === 'error'}
                                        helperText={get_validate_message(ques['ques_id'],ques['free_text'],false)}
                                        sx={{ backgroundColor: 'white' }}
                                      />
                                    )}
                                    key={sno + 'ft12'}
                                  />
                                ) : null} 
                                { (ques['free_text'] === 0 && ques['file_upload'] === 1) ? (
                                  <>
                                    <Button 
                                      fullWidth
                                      variant="contained"
                                      onClick={() => showFileUpload(message_index,formIndex,sno,'all_in_one',ques['response'],'form_response')} 
                                        sx={{backgroundColor : 'white', color: 'black',
                                              '&:hover': {
                                              backgroundColor: '#00AAFF', // Adjust the alpha value to control transparency
                                              color: 'white'
                                          } }}
                                      >
                                      <UploadFileIcon />
                                      <span> - Upload File</span>
                                    </Button>
                                    {(ques.user_resp_files.length > 0) ? (
                                      <Paper
                                        sx={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                          flexWrap: 'wrap',
                                          listStyle: 'none',
                                          p: 0.5,
                                          border: '1px dotted #00AAFF'
                                        }}
                                        component="ul"
                                      >
                                        {ques.user_resp_files.map((file, findex) => (
                                        <Chip label={file.file_name} icon={<SimCardDownloadIcon />} sx={{marginRight: '5px'}} variant="outlined" onClick={() => downloadUploadedFile(file.link,file.file_name)} onDelete={() => removeSingleOldFile(file.file_row_id,findex,formIndex,sno)} />
                                        ))}
                                      </Paper>
                                    ) : null}
                                  </>
                                ) : null}
                                {('edit_task_hint_val' in ques)?(
                                  <span style={{fontStyle:'italic'}}><b>Current Value : </b>{ques['edit_task_hint_val']}</span>
                                ):null}
                                {renderPSAVali(formIndex,sno,null,ques)}
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                        ))}
                    </Grid>
                    

                  </div>
                ))}
                </div>
              ) : null}
              {/* End - Normall All in one */}

              {/* <!--start multiple subform start --> */}
              {(have_bulk_subform(message['data'])) ? (
                (form_display_view === 'multi_sub') ? (
                  <div id='multi_sub_display_view'>
                    {(message['data']['bulk_ques_resp_list']['q1_toggle']) ? (
                      <div id ='multi_sub_table_wrapper'>
                        <div style={{marginBottom: '10px'}} id='multi_sub'>
                          <Grid container  alignItems="center" justifyContent="center">
                            <Grid  item  xs={4}>
                              {/* {(props.trigger_form_data.type_id == message['data']['bulk_ques_resp_list']['subform_id'])?(
                                <div className='sectionName'>{message['data']['bulk_ques_resp_list']['subform_name']}</div>
                              ):null} */}
                              <div className='sectionName' id='have_bulk_subform_multisub'>{message['data']['bulk_ques_resp_list']['subform_name']}</div>
                            </Grid>
                            <Grid  item xs={8} >
                              <Grid container alignItems="center" justifyContent="center">
                                <Grid  item  xs={3}>
                                  <Paper
                                    component="form"
                                    sx={{ display: 'flex', alignItems: 'center', width: '95%',borderRadius: 50,height:30, padding:'2px' }}
                                  >
                                    <InputBase
                                      sx={{ ml: 2, flex: 2,pl: 0,fontSize:'12px' }}
                                      placeholder="Search Records"
                                      value={subform_search_key}
                                      onChange={(e) => handleMasterSerach(e.target.value)}
                                      onKeyDown={(e) => enterKeyPress(e,'master_search')}
                                    />
                                    <IconButton type="button" sx={{ p: '2px',width: '40px',height: '40px', borderRadius: '50%' }} aria-label="search" onClick={() => triggerMasterSearch(message_index)}>
                                      <SearchIcon sx={{ width: '20px',height: '20px' }}/>
                                    </IconButton>
                                  </Paper>
                                </Grid>
                                <Grid  item  xs={2}>
                                  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="flex-start">
                                    <Grid  item  xs={6} >
                                    <Button sx={{backgroundColor: '#00AAFF',borderRadius:'200px',color: 'white',padding: '6px 15px',width: '40%',width: 'fit-content','&:hover': {
                                      backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                                      color: 'black'
                                      }}} onClick={() => reset_multisub()} title="Reset filters & sort" >
                                          Reset
                                      </Button>
                                    </Grid>
                                    <Grid  item  xs={6} style={{textAlign: 'center'}} >
                                    <Button onClick={() => refresh_mutiSub()} title="Refresh data with applied filters & sort" sx={{backgroundColor: '#00AAFF',borderRadius:'200px',color: 'white',padding: '6px 15px',width: '40%',width: 'fit-content','&:hover': {
                                      backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                                      color: 'black'
                                      }}}>
                                        <ReplayIcon />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={5} >                            
                                    <Grid container alignItems="center" justifyContent="center">

                                      {/* <Grid item xs={1} >
                                        <Button variant="text" sx={{color:'#4D4D4D',minWidth:'20px'}} onClick={() => onPageForwRBACK("back")} disabled={multisub_page_no===1}>
                                          <ArrowBackIosOutlinedIcon sx={{width:'15px'}}/>
                                        </Button>
                                      </Grid>
                                      <Grid item xs={2} >
                                        <Select
                                          value={multisub_page_no}
                                          onChange={(e) => onPageChange(e)}
                                          sx={{color:'#4D4D4D',height:'35px',borderRadius:'10px',backgroundColor:'white'}}
                                          autoWidth
                                          size='smallz
                                        >
                                          {Array.from({ length: CURR_MULTI_SUBFORM_TOTAL_PAGE_NO }, (_, index) => (
                                            <MenuItem key={index + 1} value={index + 1}>
                                            {index + 1}
                                            </MenuItem>
                                        ))}
                                        </Select>
                                      </Grid>
                                      <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',color:'#4D4D4D',fontSize:'20px' }}>
                                        <span style={{verticalAlign:'middle',position: 'relative', top: '-2px' }}>/ {CURR_MULTI_SUBFORM_TOTAL_PAGE_NO}</span>
                                      </Grid>
                                      <Grid item xs={1} >
                                        <Button sx={{color:'#4D4D4D',minWidth:'20px'}} onClick={() => onPageForwRBACK("front")} disabled={multisub_page_no===CURR_MULTI_SUBFORM_TOTAL_PAGE_NO}>
                                          <ArrowForwardIosOutlinedIcon sx={{width:'15px'}} />
                                        </Button>
                                      </Grid> */}
                                      <Grid item xs={6}  >
                                        <div class="pgcontainer" id='pgcontainer'>
                                          <div style={{display: 'flex'}} id='paginationDiv'>
                                            <div  style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} id='pagination_inner'>
                                              <Button variant="text" sx={{color:'#4D4D4D',minWidth:'20px'}} onClick={() => onPageForwRBACK("back")} disabled={multisub_page_no===1}>
                                                <ArrowBackIosOutlinedIcon sx={{fontSize: 25}}/>
                                              </Button>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} id='pagination_content'  >
                                              <FormControl size="small">
                                                <Select
                                                  value={multisub_page_no}
                                                  onChange={(e) => onPageChange(e)}
                                                  autoWidth
                                                  size='small'
                                                  sx={{color:'#4D4D4D',height:'30px',borderRadius:'5px',backgroundColor:'white',padding:'0px'}}
                                                >
                                                  {Array.from({ length: CURR_MULTI_SUBFORM_TOTAL_PAGE_NO }, (_, index) => (
                                                    <MenuItem key={index + 1} value={index + 1}>
                                                    {index + 1}
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                              </FormControl>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} id='icon_forw_func'>
                                              <p style={{verticalAlign:'middle',position: 'relative',marginLeft: '10px',fontSize: '20px', fontWeight: '300' }}>/ {CURR_MULTI_SUBFORM_TOTAL_PAGE_NO} </p>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} id='arrowForward'>
                                              <Button variant="text" sx={{color:'#4D4D4D',minWidth:'20px'}}  onClick={() => onPageForwRBACK("front")} disabled={multisub_page_no===CURR_MULTI_SUBFORM_TOTAL_PAGE_NO}>
                                                <ArrowForwardIosOutlinedIcon sx={{fontSize: 25}} />
                                              </Button>
                                            </div>
                                          </div>
                                        </div>
                                      </Grid>
                                      <Grid item xs={2}>
                                          <Select
                                              value={MULTI_SUB_BATCH_COUNT}
                                              onChange={(e) => onPageSizeChange(e)}
                                              size='small'
                                              sx={{color:'#4D4D4D',height:'30px',borderRadius:'5px',backgroundColor:'white'}}
                                            >
                                              <MenuItem value={15}>15</MenuItem>
                                              <MenuItem value={25}>25</MenuItem>
                                              <MenuItem value={50}>50</MenuItem>
                                              <MenuItem value={100}>100</MenuItem>
                                            </Select>
                                      </Grid>

                                      <Grid item xs={2}>
                                        <Avatar
                                          sx={{ width: 35, height: 35 , backgroundColor: 'white', color: '#00AAFF',cursor:'pointer',marginLeft: '10px'}}
                                          onClick={()=>showBulkImpExp(message['data']['bulk_ques_resp_list'],0,message['data']['bulk_ques_resp_list']['bulk_upload_form_id'],'all',true)}
                                        >
                                          <FileUploadOutlinedIcon />
                                        </Avatar>
                                      </Grid>
                                      <Grid item xs={2}>
                                        <Avatar
                                          sx={{ width: 35, height: 35 , backgroundColor: 'white', color: '#00AAFF',cursor:'pointer',marginLeft: '10px'}}
                                          onClick={handleFullScreen}
                                        >
                                          {fullScreenToggle?(<FullscreenExitIcon />):(<FullscreenOutlinedIcon />)}
                                        </Avatar>
                                      </Grid>
                                    </Grid>
                                  {/* </Paper> */}
                                </Grid>
                                <Grid xs={2}>
                                {(!message['data']['bulk_ques_resp_list']['each_row_submit'] ) ? (
                                  (!submit_button_list.includes(message_index)) ?(
                                    <Button 
                                    sx={{backgroundColor: '#00AAFF',borderRadius:'200px',color: 'white',padding: '6px 15px',width: 'fit-content','&:hover': {
                                      // sx={{'font-family': 'Montserrat','font-style': 'normal','font-weight': '600','font-size': '13px','line-height': '20px',display: 'flex','align-items': 'center','text-align': 'center',backgroundColor : 'white', color: 'black','border-radius': '200px',border: 'none !important',transition: '0.3s ease',color:'#4D4D4D',boxShadow: '0px 0px 4px 0px #00000040',padding:'3px 15px',width: 'fit-content','&:hover': {

                                      backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                                      color: 'black'
                                      }}} onClick={() => submit_multiple_subform_atonce(message['data'],message['id'],message_index)} title="Submit" 
                                      disabled = {enable_multiple_subform_atonce_submit(message['data'],message['id'],message_index) }> 
                                      Submit All
                                    </Button>
                                ):null
                                  
                                  ) : null}
                                  {renderPSAVali('form',message['data']['form_list'][0]['bulk_upload_form_id'],null,null)}
                                </Grid> 
                              </Grid>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    ):(
                      <div style={{marginBottom: '10px'}} id='sect_indxx'>
                        <div className='sectionName' id='section_name_2'> 
                          <div className='sameLine' id='same_line_2'>
                            <div className='sectionName' id='section_name_3'>{message['data']['bulk_ques_resp_list']['subform_name']}</div>
                          </div>
                          <div className='sameLine' id='same_line_3'>
                            <Avatar
                        sx={{ width: 35, height: 35 , backgroundColor: 'white', color: '#00AAFF',cursor:'pointer',marginLeft: '10px'}}
                        onClick={()=>showBulkImpExp(message['data']['bulk_ques_resp_list'],0,message['data']['bulk_ques_resp_list']['bulk_upload_form_id'],'all',false)}
                      >
                        <FileUploadOutlinedIcon />
                            </Avatar>
                            </div>
                        </div>
                      </div>
                    )}
                    {/* <p>dateaa : {JSON.stringify(CURR_MULTI_SUBFORM_TEMP)}</p> */}
                    {(message['data']['bulk_ques_resp_list']['col_names'].length === 0 && CURR_MULTI_SUBFORM_TEMP.length === 0) ? (
                      <div style={{ textAlign: 'center', fontSize: '22px', marginTop: '50px' }}>
                        No Record Found !
                      </div>
                    ) : null}
                    {(message['data']['bulk_ques_resp_list']['col_names'].length !== 0 && CURR_MULTI_SUBFORM_TEMP.length!==0) ? (
                      <div id='grid_view'>
                        {(message['data']['multi_subform_type'] === 'grid view') ? (
                          <div className='scroll_x_div' id='scroll_x_div' >
                            <div className="resp_outer_horiz" id='resp_outer_horiz'>
                              <div className="Table_Content" id ='Table_Content'>
                                <div id="resp-table" style={{width : multiSubFormWidth}}>
                                  <div id="resp-table-header" >
                                    <div className="table-header-cell-sno" id='table-header-cell-sno'>
                                      <div className='resp-table-cell-content'id='resp-table-cell-content'>Sno</div>
                                    </div>
                                    {(message['data']['bulk_ques_resp_list']['q1_toggle']) ? (
                                      < >
                                        {message['data']['bulk_ques_resp_list']['col_names'].map((each_col,Hindx) => 
                                          <>
                                            <div className="table-header-cell" id='table-header-cell'>
                                              <div className='resp-table-cell-content' id='resp-table-cell-content'>
                                                {each_col.col}{each_col.mandatory === 1 && <span style={{ color: 'red' }}>*</span>}
                                              </div>
                                            </div>
                                            {(each_col.fixed_col)?(
                                                message['data']['bulk_ques_resp_list']['master_cf_ordered_list'].map((each_cf,cf_indx) =>
                                                  <div className="table-header-cell-cf"  id='table-header-cell-cf' style={{width : `${each_cf.col_size}px`}} >
                                                    <div className='resp-table-cell-content' id='resp-table-cell-content'>

                                                    <div className={`icon-container ${ clickedArrows[each_cf.cf_key] === 'asc' || clickedArrows[each_cf.cf_key] === 'desc' ? 'both_arrows' : ''}`} id={`icon-container ${ clickedArrows[each_cf.cf_key] === 'asc' || clickedArrows[each_cf.cf_key] === 'desc' ? 'both_arrows' : ''}`} >
                                                        <a onClick={() => handleSort(cf_indx, each_cf, 'asc',message_index)}>
                                                            <KeyboardArrowUpIcon
                                                              className={`arrow-icon ${clickedArrows[each_cf.cf_key] === 'asc' ? 'pressed' : ''}`}
                                                            />
                                                          </a>
                                                          <a onClick={() => handleSort(cf_indx, each_cf, 'desc',message_index)}>
                                                            <KeyboardArrowDownIcon
                                                              className={`arrow-icon ${clickedArrows[each_cf.cf_key] === 'desc' ? 'pressed' : ''}`}
                                                            />
                                                          </a>
                                                      </div>
                                                      
                                                      {each_cf['cf_key'] && each_cf['cf_key'].length <= cf_trunc_len[each_cf.col_size] ? (
                                                      <div style={{ whiteSpace: 'break-spaces',marginTop:'2px' }} id='cf_key'>
                                                        {each_cf['cf_key']}
                                                      </div>
                                                    ) : (
                                                      <>
                                                        <Tooltip title={each_cf['cf_key']} arrow>
                                                      <span style={{ cursor: 'pointer', marginTop: '16px' }}>
                                                        {each_cf['cf_key'] && each_cf['cf_key'].slice(0, cf_trunc_len[each_cf.col_size])}...
                                                      </span>
                                                    </Tooltip>

                                                      </>
                                                    )}
                                                    
                                                      <a class={`${(each_cf.selected_filters && each_cf.selected_filters.length > 0) ? 'filter_higlight' : ''}`} onClick={(e) => openMasterColFilter(e, cf_indx)}> 
                                                            <FilterAltOutlinedIcon className={`Filtericon ${( filter_cf_index_list.includes(cf_indx)) || (each_cf.selected_filters && each_cf.selected_filters.length > 0)   ? 'pressed' : ''}`}
                                                            style={{ color: (each_cf.selected_filters && each_cf.selected_filters.length > 0) ? '#00AAFF' : 'rgb(66, 66, 71)' }} />
                                                        </a>
                                                     
                                                    </div>
                                                  </div>
                                                )
                                            ):(null)}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {message['data']['bulk_ques_resp_list']['col_names'].map((each_col, Hindx) => (
                                          <div className="table-header-cell" key={'col-' + Hindx} id='table-header-cell_for_indx'>
                                            <div className='resp-table-cell-content' id='resp-table-cell-content_1'>
                                              <p>{each_col.col}</p>
                                              {each_col['mandatory'] === 1 ? <p>*</p> : null}
                                            </div>
                                          </div>
                                        ))}
                                      </>
                                    )}
                                    {(message['data']['bulk_ques_resp_list']['each_row_submit']) ? (
                                      <div className="table-header-cell-cf" id='table-header-cell-cf_2'>
                                        <div className='resp-table-cell-content' id='resp-table-cell-content_3'>
                                          Action
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                  {(onTableRowLoad) ? (
                                    <Stack spacing={1}>
                                      <Skeleton 
                                      sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
                                      animation="wave" />
                                      <Skeleton
                                      sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
                                       animation="wave" />
                                      <Skeleton 
                                      sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
                                      animation="wave" />
                                    </Stack>
                                  ) : (
                                    <div className="resp_outer_vertical" id='resp_outer_vertical'>
                                        <div id="resp-table" style={{'width': (multiSubFormWidth + 'px')}}>
                                            <div id="resp-table-body" >
                                              {CURR_MULTI_SUBFORM_TEMP.map((each_row,block_sno) => (
                                                <>
                                                  <div id={`table_resp-row_${block_sno}`}  key={'row'+block_sno} style={{backgroundColor : ((hasMultipleFilledResponses(each_row,block_sno) && !user_fill_action) ? '#FFFBE5' : 'inherit') }}  className="resp-table-row">
                                                    <div className="table-body-cell-sno" id={`table_body_cell-sno_2_${block_sno}`}>
                                                      <div className='resp-table-cell-content' id={`resp_table_cell_content_${block_sno}`}>{block_sno + 1}</div>
                                                    </div>
                                                    {each_row.map((ques, sno) => (
                                                        (ques['fixed_col']) ? (
                                                          <>
                                                            <div className="table-body-cell" id={`table-body-cell_0_${sno}`}>
                                                              <div className='resp-table-cell-content' id={`resp-table-cell-content_fix_${sno}`}>
                                                                <a className="masterGridHyper" id={`mastergrid_hyper_${sno}`} onClick={() => expMultisubRow(ques['response'], block_sno)}>
                                                                  {ques['response_preview']}
                                                                  {/* {ques['response']} */}
                                                                </a>
                                                              </div>
                                                            </div>
                                                            {(message['data']['bulk_ques_resp_list']['master_cf_ordered_list'].length > 0) ? (
                                                              (ques['master_cf'].length > 0) ? (
                                                                Array.from({ length: message['data']['bulk_ques_resp_list']['master_cf_ordered_list'].length }).map((_, cfref_indx) => {
                                                                  const each_cf_pair = ques['master_cf'][cfref_indx];
                                                                  // console.log("each_cf_pair ::",each_cf_pair)
                                                                return (
                                                                <div key={block_sno + sno + cfref_indx} className="table-body-cell-cf" id={`table_cell_body_cf_${block_sno}_${sno}_${cfref_indx}`} style={{ width: `${each_cf_pair ? each_cf_pair.col_size : message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][cfref_indx]['col_size']}px` }}>
                                                                {/* <div key={block_sno + sno + cfref_indx} className="table-body-cell-cf" id='table_cell_body_cf_4' style={{ width: `${each_cf_pair.col_size}px` }}> */}

                                                                  { (each_cf_pair) ? (<div className='resp-table-cell-content' id={`resp-table-cell-body-content_${block_sno}`}>
                                                                    {(each_cf_pair.cf_files.length === 0) ? (
                                                                      (each_cf_pair['cf_value'].length <= cf_trunc_len[each_cf_pair.col_size]) ? (
                                                                        <div style={{ whiteSpace: 'break-spaces' }} id={`break_space_${block_sno}`}>
                                                                          {each_cf_pair['cf_value']}
                                                                        </div>
                                                                      ) : (
                                                                        <>
                                                                          <LightTooltip
                                                                            title={
                                                                              <>
                                                                                <div style={{ display: 'flex' }}  id={`copy_icon_${block_sno}`}>
                                                                                <ContentCopyIcon
                                                                                  sx={{ fontSize: '16px', color: '#1b55e3',marginRight:'5px',cursor:'pointer' }}
                                                                                  onClick={() => handleCopyClick(each_cf_pair['cf_value'])}
                                                                                />
                                                                                  <Typography sx={{whiteSpace: 'break-spaces'}}>{each_cf_pair['cf_value']}</Typography>
                                                                                </div>
                                                                              </>
                                                                            }
                                                                            arrow
                                                                          >
                                                                            <span style={{ cursor: 'pointer' }}>
                                                                              {each_cf_pair['cf_value'].slice(0, cf_trunc_len[each_cf_pair.col_size])}...
                                                                            </span>
                                                                          </LightTooltip>
                                                                        </>
                                                                      )
                                                                    ) : (
                                                                      <div id={`image_upload_${block_sno}`}>
                                                                        <div id={`file_image_gal_${block_sno}`} style={{ boxShadow: '0px 0px 4px 0px #00000040', borderRadius: '5px', display: 'flex', justifyContent: 'center', verticalAlign: 'middle', width: 'auto', height: 'auto', padding: '10px' }}>
                                                                          {each_cf_pair.cf_files.slice(0, 2).map((file, index) => (
                                                                            file.file_name ?
                                                                            (<div key={index} onClick={() => openImgGal(index, cfref_indx, block_sno)} className="image-container" id={`image_container_${block_sno}`}>
                                                                              <img src={returnImgLink(file)} alt={file.file_name} className="thumbnail" id={`thumbnail_${block_sno}`} />
                                                                            </div>):null
                                                                          ))}
                                                                          {each_cf_pair.cf_files.length > 2 && (
                                                                            <div className="image-view" id={`image_view${block_sno}`} onClick={() => openImgGal(0, cfref_indx, block_sno)}>
                                                                              <div className="count" id={`count_${block_sno}`}>
                                                                                +{each_cf_pair.cf_files.length - 2}
                                                                              </div>
                                                                            </div>
                                                                          )}
                                                                        </div>
                                                                      </div>
                                                                    )}
                                                                  </div>) : " "}
                                                                </div>
                                                            );})) : (
                                                              message['data']['bulk_ques_resp_list']['master_cf_ordered_list'].map((each_cf,cf_indx) =>{
                                                                  return (
                                                                  <div key={block_sno + sno + cf_indx} className="table-body-cell-cf" id='table-body-cel-cf' style={{ width: `${each_cf.col_size}px` }}>
                                                                    <div className='resp-table-cell-content' id='resp-table-cel-cont'>
                                                                      
                                                                    </div>
                                                                  </div>)})
                                                              )
                                                            ) : null}
                                                          </>
                                                        ) : (
                                                              <div className="table-body-cell" id='table-body-cell-file-upload'>
                                                                <div className='resp-table-cell-content' id='resp-table-cell-content_file_upload'>

                                                                  { (ques['free_text'] >= 1 && ques['file_upload'] === 0 && ques['free_text'] !== 7 && ques['free_text'] !== 8 && ques['free_text'] !== 11) ? (
                                                                    <>
                                                                      {(ques['free_text'] !== 9 && ques['free_text'] !== 6 && ques['free_text'] !== 10) ? (
                                                                          <TextField
                                                                          multiline
                                                                            fullWidth
                                                                            value={ques['response']}
                                                                            onChange={(e) => handleAllInOneResp(null,sno,e.target.value,'multi_subform',block_sno,null,ques['ques_id'],ques,ques['free_text'],ques['response'],true)}
                                                                            className="GridinputBox"
                                                                            error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,block_sno) === 'error'}
                                                                            helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,block_sno)}
                                                                            key={'row'+block_sno + 'ques' + sno + 'rt1'}
                                                                            size='small'
                                                                          />
                                                                        ) : null}
                                                                      {(ques['free_text'] === 6) ? (
                                                                          <TextField
                                                                            fullWidth
                                                                            value={ques['response']}
                                                                            onChange={(e) => handleAllInOneResp(null,sno,e.target.value,'multi_subform',block_sno,null,ques['ques_id'],ques,ques['free_text'],ques['response'],true)}
                                                                            className="GridinputBox"
                                                                            error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,block_sno) === 'error'}
                                                                            helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,block_sno)}
                                                                            key={'row'+block_sno + 'ques' + sno + 'rt11'}
                                                                            size='small'
                                                                            InputProps={{
                                                                              endAdornment: (
                                                                                <IconButton  onClick={(e) => mapdatepick(e,message_index,null,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'],true,block_sno)}>
                                                                                  <CalendarTodayIcon style={{fontSize:'15px'}} />
                                                                                </IconButton>
                                                                              ),
                                                                            }}
                                                                          />
                                                                        ) : null}
                                                                      {(ques['free_text'] === 9) ? (
                                                                          // <TextField
                                                                          //   fullWidth
                                                                          //   placeholder="HH:MM"
                                                                          //   value={ques['response']}
                                                                          //   onChange={(e) => handleAllInOneResp(null,sno,e.target.value,'multi_subform',block_sno)}
                                                                          //   className="GridinputBox"
                                                                          //   error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,block_sno) === 'error'}
                                                                          //   helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,block_sno)}
                                                                          //   key={'row'+block_sno + 'ques' + sno + 'rt3'}
                                                                          //   size='small'
                                                                          // />
                                                                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <TimePicker 
                                                                              ampm={false}
                                                                              onChange={(e) =>handleAllInOneResp(null,sno,e,'multi_subform',block_sno)}
                                                                              className="GridinputBox"
                                                                              key={'row'+block_sno + 'ques' + sno + 'rt3'}
                                                                              format='HH:mm'
                                                                              value={parseTimeStringToDate(ques['response'])}
                                                                              slotProps={{ textField: { size: 'small' } }}
                                                                              autoWidth
                                                                              renderInput={
                                                                                (params) => {
                                                                                <input 
                                                                                  {...params.inputProps}
                                                                                  onChange={(e) =>handleAllInOneResp(null,sno,e.target.value,'multi_subform',block_sno,null,ques['ques_id'],ques,ques['free_text'],ques['response'],true)}
                                                                                  error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,block_sno) === 'error'}
                                                                                  helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,block_sno)} 
                                                                                  style={{height:'auto'}}/>
                                                                              }} // Use input for displaying time
                                                                              
                                                                            /> 
                                                                          </LocalizationProvider>
                                                                        ) : null}
                                                                      {(ques['free_text'] === 10)?(
                                                                        <TextField
                                                                            fullWidth
                                                                            value={ques['response']}
                                                                            placeholder="HH:MM"                                                                            className="GridinputBox"
                                                                            onChange={(e) => handleAllInOneResp(null,sno,e.target.value,'multi_subform',block_sno,null,ques['ques_id'],ques,ques['free_text'],ques['response'],true)}
                                                                            error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,block_sno) === 'error'}
                                                                            helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,block_sno)}
                                                                            key={'row'+block_sno + 'ques' + sno + 'rt3'}
                                                                            size='small'
                                                                            InputProps={{
                                                                              endAdornment: (
                                                                                <IconButton onClick={(e) =>handleHoursTimeMenu(e,message_index,null,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'],true,block_sno)}>
                                                                                  <AccessTimeIcon style={{fontSize:'15px'}} />
                                                                                </IconButton>
                                                                              ),
                                                                            }}                                      
                                                                          />
                                                                      ):null}     
                                                                    </>
                                                                  ):null}
                                                                  { (ques['free_text'] === 7 ||  ques['free_text'] === 8 ||  ques['free_text'] === 11) ? (
                                                                    <>
                                                                    <Autocomplete
                                                                      options={ques['options']}
                                                                      getOptionLabel={(option) => option.val || ''}
                                                                      getOptionSelected={(option, value) => option.id === value.id}
                                                                      onChange={(e,newInputValue) => handleAllInOneResp(null,sno,newInputValue,'multi_subform',block_sno,null,ques['ques_id'],ques,ques['free_text'],ques['response'],true)}
                                                                      onOpen={() => reloadOptions('refresh',each_row,ques,message_index,null,sno,null,'all_in_one',true,block_sno)}
                                                                      clearOnBlur
                                                                      clearOnEscape
                                                                      className='GridinputBox'
                                                                      value={ques.options.find((opt) => opt.id === ques.response) || null} // Set the input value
                                                                      filterOptions={(x) => x}
                                                                      renderInput={(params) => (
                                                                        <TextField id={`renderinput_${sno}`}
                                                                          {...params}
                                                                          fullWidth
                                                                          onChange={(event) => reloadOptions('search',each_row,ques,message_index,null,sno,event.target.value,'all_in_one',true,block_sno)}
                                                                          error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,block_sno) === 'error'}
                                                                          helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,block_sno)}
                                                                          className='GridinputBox'
                                                                          size='small'
                                                                        />
                                                                      )}
                                                                      id={`ddoption_${block_sno+sno}`}
                                                                      key={'row'+block_sno + 'ques' + sno + 'rt5'}
                                                                      renderOption={(props, option) => (
                                                                        <Box component="li" {...props} key={option.id}>
                                                                          {option.val}
                                                                        </Box>
                                                                      )}
                                                                    />
                                                                    </>
                                                                  ):null}
                                                                  { (!ques['tag_option_flag'] && (ques['options'].length!==0 || ques['free_text'] === 0) && ques['free_text'] !== 7 && ques['free_text'] !== 8 && ques['free_text'] !== 11 && ques['file_upload'] !== 1) ? (
                                                                  
                                                                    <Autocomplete
                                                                      options={ques['options']}
                                                                      getOptionLabel={(option) => option.val || ques['response']}
                                                                      onChange={(e,newInputValue) => handleAllInOneResp(null,sno,(newInputValue ? newInputValue.val : ''),'multi_subform',block_sno,null,ques['ques_id'],ques,ques['free_text'],ques['response'],true)}
                                                                      clearOnBlur
                                                                      clearOnEscape
                                                                      className='GridinputBox'
                                                                      value={ques['options'].find(option => option.val === ques['response']) || ""} // Pre-select the option if response is given
                                                                      renderInput={(params) => (
                                                                        <TextField id={`renderinput_${sno}`}
                                                                          {...params}
                                                                          fullWidth
                                                                          error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,block_sno) === 'error'}
                                                                          helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,block_sno)}
                                                                          size='small'
                                                                        />
                                                                      )}
                                                                      key={'row'+block_sno + 'ques' + sno + 'rt6'}
                                                                    />
                                                                  
                                                                  ) : null} 
                                                                  { (ques['free_text'] === 0 && ques['file_upload'] === 1) ? (
                                                                    <>
                                                                      <Grid container >
                                                                        <Grid  item  xs={12}>
                                                                          <Button 
                                                                            fullWidth
                                                                            onClick={() => showFileUpload(message_index,null,sno,'multi_subform',ques['response'],'form_response',true,block_sno)} 
                                                                              sx={{backgroundColor : 'white', color: 'black',border:'1px solid #00AAFF',
                                                                                    '&:hover': {
                                                                                    backgroundColor: '#00AAFF', // Adjust the alpha value to control transparency
                                                                                    color: 'white'
                                                                                } }}
                                                                            >
                                                                            <UploadFileIcon />
                                                                            <span> - Upload File</span>
                                                                          </Button>
                                                                        </Grid>
                                                                        <Grid  item  xs={12}>
                                                                          {(ques.user_resp_files.length > 0) ? (
                                                                            <Paper
                                                                              sx={{
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                flexWrap: 'wrap',
                                                                                listStyle: 'none',
                                                                                p: 0.5,
                                                                                border: '1px dotted #00AAFF'
                                                                              }}
                                                                              component="ul"
                                                                            >
                                                                              {ques.user_resp_files.map((file, findex) => (
                                                                              <Chip label={file.file_name} icon={<SimCardDownloadIcon />} sx={{marginRight: '5px'}} variant="outlined" onClick={() => downloadUploadedFile(file.link,file.file_name)} onDelete={() => removeSingleOldFile(file.file_row_id,findex,null,sno,true,block_sno)} />
                                                                              ))}
                                                                            </Paper>
                                                                          ) : null}
                                                                        </Grid>
                                                                      </Grid>
                                                                    </>
                                                                  ) : null}
                                                                  {(ques['tag_option_flag'] && ques['file_upload'] !== 1) ? (
                                                                    <>
                                                                      <Grid container sx={{ boxShadow: '0px 0px 4px 0px #00000040', borderRadius: '5px' }} justifyContent="center" alignItems="center">
                                                                        {ques['options'].map((option, optInd) => (
                                                                          <Grid item key={optInd}>
                                                                            <Chip
                                                                              label={option['val']}
                                                                              style={{
                                                                                backgroundColor: option['checked'] ? '#008FD7' : '#E5F6FF',
                                                                                color: option['checked'] ? 'white' : 'black',
                                                                                height: '20px',
                                                                                margin: '2px',
                                                                              }}
                                                                              onClick={() => tagOptionCheckChange(option['checked'], optInd, option, ques['free_text'], message_index, null, sno, 'all_in_one', true, block_sno)}
                                                                            />
                                                                          </Grid>
                                                                        ))}
                                                                      </Grid>
                                                                    </>
                                                                  ) : null}
                                                                  
                                                                </div>
                                                                <div id='outer_cont'>
                                                                  {(('edit_task_hint_val' in ques) && !message['data']['bulk_ques_resp_list']['hide_curr_value'])?(
                                                                    <span style={{fontStyle:'italic'}}><b>Current Value : </b>{ques['edit_task_hint_val']}</span>
                                                                  ):null}
                                                                  { ((ques['free_text'] === 7 ||  ques['free_text'] === 8 ||  ques['free_text'] === 11) && !message['data']['bulk_ques_resp_list']['hide_curr_value']) ? (
                                                                  <div key={sno + '_mastercf'}>
                                                                    {ques['master_cf_value_pairs'].map((each_cf,each_cf_index)=>(
                                                                      <div key={sno + '_cf_key_val' + each_cf.cf_key + each_cf.cf_value}>
                                                                        {each_cf.cf_key }: {each_cf.cf_value}
                                                                      </div>
                                                                    ))}
                                                                  </div>
                                                                  ): null}
                                                                  {/* {renderPSAVali(null,sno,block_sno,each_row[0])} */}
                                                                  {renderPSAVali(null,sno,block_sno,{'response':block_sno})}
                                                                </div>
                                                              </div>
                                                          )
                                                      ))}
                                                    {(message['data']['bulk_ques_resp_list']['each_row_submit']) ? (
                                                    <div className="table-body-cell-cf" id='table_body-eell_cus_form' >
                                                      <div className='margintopcust' id='margintopcust'>
                                                        <Button 
                                                          id={`submit_button_${block_sno}`} // Unique ID based on block_sno
                                                          onClick={() => submit_single_row_grid_view(message['data'], block_sno)} 
                                                          title="Submit" 
                                                          sx={{
                                                            backgroundColor: '#00AAFF',
                                                            borderRadius: '25px',
                                                            color: 'white',
                                                            '&:hover': {
                                                              backgroundColor: 'white', // Adjust the alpha value to control transparency
                                                              color: 'black',
                                                              border: '1px solid #00AAFF'
                                                            }
                                                          }}
                                                          disabled={enable_single_row_grid_submit(message['data'], block_sno)}
                                                        > 
                                                          <ArrowRightAltIcon />
                                                        </Button>
                                                        {renderPSAVali('form',each_row[0].response,null,each_row[0])}
                                                      </div>
                                                    </div>
                                                    ) : null}
                                                  </div>
                                                  
                                                </>
                                              )
                                              )}
                                            </div>
                                        </div>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        ) : null }
                      </div>
                    ) : null }
                  </div>
                ) : (
                  <div className='multi_sub_single_div' id='multi_sub_single_div'>
                    <div className="headersingle" id='headerSingle'>
                      <Fab style={{backgroundColor:'white'}}  onClick={revert_to_mul_sub_view}>
                        <KeyboardBackspaceIcon />
                      </Fab>
                      <span className='breadcrum'>
                        &nbsp;&nbsp;{message['data']['bulk_ques_resp_list']['subform_name']}
                        &nbsp;/&nbsp;
                        {CURR_MULTI_SUBFORM_TEMP[curr_card_view_form_ind][0]['response_preview']}
                      </span>
                    </div>
                    <br></br>
                    <div >
                      <Grid container>
                        <Grid item xs={4}>
                          <Grid container>
                            <Divider orientation="vertical" flexItem></Divider>
                            <Grid item xs={2} style={{ display: 'flex' }}>
                              &nbsp; <ModeEditIcon sx={{fontSize: 18}} />&nbsp; Edit &nbsp;
                            </Grid>
                            <Divider orientation="vertical" flexItem></Divider>
                            <Grid item xs={4} style={{ display: 'flex' }}>
                              &nbsp; <MarkChatUnreadIcon sx={{fontSize: 20}} />&nbsp; Update Note &nbsp;
                            </Grid>
                            <Divider orientation="vertical" flexItem></Divider>
                            {/* <Grid item xs={4} style={{ display: 'flex' }}>
                              &nbsp; <ListAltIcon sx={{fontSize: 20}} />&nbsp; Activity Log &nbsp;
                            </Grid> */}
                          </Grid>
                        </Grid>
                        <Grid item xs={8}></Grid>
                      </Grid>
                      <br></br>
                      <Divider />
                    </div>
                    <br></br>
                    <div className='customFields' id='customFieldView'>
                      <Grid container rowSpacing={2} columnSpacing={1}>
                        {CURR_MULTI_SUBFORM_TEMP[curr_card_view_form_ind][0]['master_cf'].map((each_cf_pair,ecfIndx) => (
                          <>
                          {
                            (each_cf_pair['cf_files'].length == 0 )?(
                              <Grid item xs={3.9} key={ecfIndx} >
                                <Grid container>
                                  <Grid item xs={5}><b>{each_cf_pair['cf_key']}</b></Grid>
                                  <Grid item xs={1}>:</Grid>
                                  <Grid item xs={6}>
                                    {each_cf_pair['cf_value']}
                                  </Grid>
                                </Grid>
                              </Grid>
                            ): 
                            (
                              <Grid item xs={3.9} key={ecfIndx} >
                                <Grid container>
                                  <Grid item xs={5}><b>{each_cf_pair['cf_key']}</b></Grid>
                                  <Grid item xs={1}>:</Grid>
                                  {/* <Grid item xs={6}>
                                    {each_cf_pair.cf_files.map((cf_file,cf_file_index)=>{
                                      return(                                                         
                                        (cf_file_index<2)?
                                        (<div key={cf_file_index} onClick={() => openImgGal(cf_file_index, ecfIndx,curr_card_view_form_ind)} className="image-container">
                                        <img src={returnImgLink(cf_file)} alt={cf_file.file_name} className="thumbnail" />
                                      </div>):null
                                      )
                                      })}
                                      {(each_cf_pair.cf_files.length > 2) ? (
                                          <Fab size="small" onClick={() => openImgGal(0,ecfIndx,curr_card_view_form_ind)} style={{backgroundColor:'white',color:'#00AAFF',fontWeight:'500',fontSize:'1rem',margin:'auto'}} >
                                            + {(each_cf_pair.cf_files.length - 2)}
                                          </Fab>
                                        ):null}
                                  </Grid> */}
                                  <Grid item xs={6}>
                                    <div style={{backgroundColor:'white',padding:'10px'}}>
                                      <Grid container columnSpacing={1} >
                                        <>
                                          {each_cf_pair.cf_files.map((cf_file,cf_file_index) => (
                                            (cf_file_index <= 1)?(
                                              <Grid key={cf_file_index} item xs={4}>
                                                <Avatar onClick={() => openImgGal(cf_file_index, ecfIndx,curr_card_view_form_ind)} src={defFileImg} sx={{boxShadow: '0px 0px 2px 0px #00000040',height:'70px',width:'55px'}} variant="rounded" />
                                              </Grid>
                                            ):null
                                          ))}
                                          {(each_cf_pair.cf_files.length > 2) ? (
                                            <Fab size="small" onClick={() => openImgGal(0,ecfIndx,curr_card_view_form_ind)} style={{backgroundColor:'white',color:'#00AAFF',fontWeight:'500',fontSize:'1rem',margin:'auto'}} >
                                              + {(each_cf_pair.cf_files.length - 2)}
                                            </Fab>
                                          ):null}
                                        </>
                                      </Grid>
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )
                            
                          }
                          </>
                        ))}
                        {(imageObject.length > 0)? (
                          <Grid item xs={3.9} key="attachments" >
                            <Grid container>
                              <Grid item xs={3}><b>Attachments</b></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={8}>
                                <div style={{backgroundColor:'white',padding:'10px'}} id='imageobject'>
                                  <Grid container columnSpacing={1} >
                                    <>
                                      {imageObject.map((efile,eIndx) => (
                                        (eIndx <= 2)?(
                                          <Grid key={eIndx} item xs={3}>
                                            <Avatar onClick={() => openImgGal(eIndx)} src={efile.thumbImage} sx={{boxShadow: '0px 0px 2px 0px #00000040',height:'70px',width:'55px'}} variant="rounded" />
                                          </Grid>
                                        ):null
                                      ))}
                                      {(imageObject.length > 3) ? (
                                        <Fab size="small" onClick={() => openImgGal(0)} style={{backgroundColor:'white',color:'#00AAFF',fontWeight:'500',fontSize:'1rem',margin:'auto'}} >
                                          + {(imageObject.length - 3)}
                                        </Fab>
                                      ):null}
                                    </>
                                  </Grid>
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        ) : null}
                      </Grid>
                    </div>
                    <br></br>
                    <br></br>
                    <div className='SinglformDiv' id='singleformdiv'>
                      <div className='formName' id='form_name'>Edit</div>
                      <div>
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                          {CURR_MULTI_SUBFORM_TEMP[curr_card_view_form_ind].map((ques,sno)=>(
                          (ques.fixed_col !== true) && (
                          <Grid item xs={4}>
                            <div style={{padding: '10px'}} key={sno} id='s_no_question-container'>
                              <div key={sno + 'q'} className='question' id='ques'> {ques.question}{ques.mandatory === 1 && <span style={{ color: 'red' }}>*</span>}  </div>
                                { (ques['free_text'] >= 1 && ques['file_upload'] === 0 && ques['free_text'] !== 7 && ques['free_text'] !== 8 && ques['free_text'] !== 11) ? (
                                  <>
                                    {(ques['free_text'] !== 9 && ques['free_text'] !== 6 && ques['free_text'] !== 10) ? (
                                        <TextField
                                          fullWidth
                                          value={ques['response']}
                                          onChange={(e) => handleAllInOneResp(null,sno,e.target.value,'multi_subform',curr_card_view_form_ind)}
                                          className="GridinputBox"
                                          error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,curr_card_view_form_ind) === 'error'}
                                          helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,curr_card_view_form_ind)}
                                          key={'row'+curr_card_view_form_ind + 'ques' + sno + 'rt1'}
                                          size='Large'
                                        />
                                      ) : null}
                                    {(ques['free_text'] === 6) ? (
                                        <TextField
                                          fullWidth
                                          value={ques['response']}
                                          onChange={(e) => handleAllInOneResp(null,sno,e.target.value,'multi_subform',curr_card_view_form_ind)}
                                          className="GridinputBox"
                                          error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,curr_card_view_form_ind) === 'error'}
                                          helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,curr_card_view_form_ind)}
                                          key={'row'+curr_card_view_form_ind + 'ques' + sno + 'rt11'}
                                          size='small'
                                          InputProps={{
                                            endAdornment: (
                                              <IconButton  onClick={(e) => mapdatepick(e,message_index,null,sno,'all_in_one',ques['response'],ques['ques_id'],ques,ques['free_text'],true,curr_card_view_form_ind)}>
                                                <CalendarTodayIcon style={{fontSize:'15px'}} />
                                              </IconButton>
                                            ),
                                          }}
                                        />
                                      ) : null}
                                    {(ques['free_text'] === 9) ? (
                                        // <TextField
                                        //   fullWidth
                                        //   placeholder="HH:MM"
                                        //   value={ques['response']}
                                        //   onChange={(e) => handleAllInOneResp(null,sno,e.target.value,'multi_subform',curr_card_view_form_ind)}
                                        //   className="GridinputBox"
                                        //   error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,curr_card_view_form_ind) === 'error'}
                                        //   helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,curr_card_view_form_ind)}
                                        //   key={'row'+curr_card_view_form_ind + 'ques' + sno + 'rt3'}
                                        //   size='small'
                                        // />
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                          <TimePicker 
                                            ampm={false}
                                            onChange={(e) =>handleAllInOneResp(null,sno,e,'multi_subform',curr_card_view_form_ind)}
                                            className="GridinputBox"
                                            key={'row'+curr_card_view_form_ind + 'ques' + sno + 'rt3'}
                                            slotProps={{ textField: { size: 'small' } }}
                                            format='HH:mm'
                                            value={parseTimeStringToDate(ques['response'])}
                                            renderInput={
                                              (params) => 
                                              <input 
                                                {...params.inputProps}
                                                onChange={(e) =>handleAllInOneResp(null,sno,e,'multi_subform',curr_card_view_form_ind)}
                                                error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,curr_card_view_form_ind) === 'error'}
                                                helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,curr_card_view_form_ind)} />
                                            } // Use input for displaying time
                                            
                                          /> 
                                        </LocalizationProvider>
                                      ) : null}
                                    {(ques['free_text'] === 10)?(
                                      <TextField
                                        type="date"
                                        fullWidth
                                        value={ques['response']}
                                        onChange={(e) => handleAllInOneResp(null,sno,e.target.value,'multi_subform',curr_card_view_form_ind)}
                                        error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,curr_card_view_form_ind) === 'error'}
                                        helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,curr_card_view_form_ind)}
                                        placeholder="HH:MM"
                                        size='small'
                                        InputProps={{
                                          inputProps: {
                                            pattern: '([01]?[0-9]|2[0-3]):[0-5][0-9]',
                                          },
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <span>:</span>
                                            </InputAdornment>
                                          ),
                                        }}
                                        className="GridinputBox"
                                        key={'row'+curr_card_view_form_ind + 'ques' + sno + 'rt4'}
                                      />
                                    ):null}     
                                  </>
                                ):null}
                                { (ques['free_text'] === 7 ||  ques['free_text'] === 8 ||  ques['free_text'] === 11) ? (
                                  <>
                                  <Autocomplete
                                    options={ques['options']}
                                    getOptionLabel={(option) => option.val || ''}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    onChange={(e,newInputValue) => handleAllInOneResp(null,sno,newInputValue,'multi_subform',curr_card_view_form_ind)}
                                    onOpen={() => reloadOptions('refresh',CURR_MULTI_SUBFORM_TEMP[curr_card_view_form_ind],ques,message_index,null,sno,null,'all_in_one',true,curr_card_view_form_ind)}
                                    clearOnBlur
                                    clearOnEscape
                                    className='GridinputBox'
                                    value={ques.options.find((opt) => opt.id === ques.response) || null} // Set the input value
                                    renderInput={(params) => (
                                      <TextField id={`renderinput_${sno}`}
                                        {...params}
                                        fullWidth
                                        onChange={(event) => reloadOptions('search',CURR_MULTI_SUBFORM_TEMP[curr_card_view_form_ind],ques,message_index,null,sno,event.target.value,'all_in_one',true,curr_card_view_form_ind)}
                                        error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,curr_card_view_form_ind) === 'error'}
                                        helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,curr_card_view_form_ind)}
                                        className='GridinputBox'
                                        size='small'
                                      />
                                    )}
                                    key={'row'+curr_card_view_form_ind + 'ques' + sno + 'rt5'}
                                    id={`ddoption_${curr_card_view_form_ind+sno}`}
                                    renderOption={(props, option) => (
                                      <Box id={`option_${sno}`} component="li" {...props} key={option.id}> 
                                        {option.val}
                                      </Box>
                                    )}
                                  />
                                  </>
                                ):null}
                                { (!ques['tag_option_flag'] && (ques['options'].length!==0 || ques['free_text'] === 0) && ques['free_text'] !== 7 && ques['free_text'] !== 8 && ques['free_text'] !== 11 && ques['file_upload'] !== 1) ? (
                                
                                  <Autocomplete
                                    options={ques['options']}
                                    getOptionLabel={(option) => option.val || ques['response']}
                                    onChange={(e,newInputValue) => handleAllInOneResp(null,sno,(newInputValue ? newInputValue.val : ''),'multi_subform',curr_card_view_form_ind)}
                                    clearOnBlur
                                    clearOnEscape
                                    className='GridinputBox'
                                    value={ques.options.find((opt) => opt.val === ques.response) || ""} // Set the input value
                                    renderInput={(params) => (
                                      <TextField id={`renderinput_${sno}`}
                                        {...params}
                                        fullWidth
                                        error={validate_response_format(ques['ques_id'],ques,ques['free_text'],ques['response'],true,curr_card_view_form_ind) === 'error'}
                                        helperText={get_validate_message(ques['ques_id'],ques['free_text'],true,curr_card_view_form_ind)}
                                        size='small'
                                      />
                                    )}
                                    key={'row'+curr_card_view_form_ind + 'ques' + sno + 'rt6'}
                                  />
                                
                                ) : null} 
                                { (ques['free_text'] === 0 && ques['file_upload'] === 1) ? (
                                  <>
                                    <Grid container >
                                      <Grid  item  xs={12}>
                                        <Button 
                                          fullWidth
                                          onClick={() => showFileUpload(message_index,null,sno,'multi_subform',ques['response'],'update_note',true,curr_card_view_form_ind)} 
                                            sx={{backgroundColor : 'white', color: 'black',border:'1px solid #00AAFF',
                                                  '&:hover': {
                                                  backgroundColor: '#00AAFF', // Adjust the alpha value to control transparency
                                                  color: 'white'
                                              } }}
                                          >
                                          <UploadFileIcon />
                                          <span> - Upload File</span>
                                        </Button>
                                      </Grid>
                                      <Grid  item  xs={12}>
                                        {(ques.user_resp_files.length > 0) ? (
                                          <Paper
                                            sx={{
                                              display: 'flex',
                                              justifyContent: 'center',
                                              flexWrap: 'wrap',
                                              listStyle: 'none',
                                              p: 0.5,
                                              border: '1px dotted #00AAFF'
                                            }}
                                            component="ul"
                                          >
                                            {ques.user_resp_files.map((file, findex) => (
                                            <Chip label={file.file_name} icon={<SimCardDownloadIcon />} sx={{marginRight: '5px'}} variant="outlined" onClick={() => downloadUploadedFile(file.link,file.file_name)} onDelete={() => removeSingleOldFile(file.file_row_id,findex,null,sno,true,curr_card_view_form_ind)} />
                                            ))}
                                          </Paper>
                                        ) : null}
                                      </Grid>
                                    </Grid>
                                  </>
                                ) : null}
                                { (ques['tag_option_flag'] && ques['file_upload'] !== 1) ? (
                                  <Grid container  sx={{boxShadow: '0px 0px 4px 0px #00000040',borderRadius:'5px'}}>
                                    {ques['options'].map((option,optInd)=>(
                                      <Grid item key={optInd} >
                                        <Chip
                                        label={option['val']}
                                        style={{backgroundColor:(option['checked'] ? '#008FD7' : '#E5F6FF'),color:(option['checked'] ? 'white' : 'black'), height: '20px', margin: '4px', }}
                                        onClick={() => tagOptionCheckChange(option['checked'],optInd,option,ques['free_text'],message_index,null,sno,'all_in_one',true,curr_card_view_form_ind)} 
                                        />
                                      </Grid>
                                    ))}
                                  </Grid>
                                ) : null}
                                {('edit_task_hint_val' in ques)?(
                                  <span style={{fontStyle:'italic'}}><b>Current Value : </b>{ques['edit_task_hint_val']}</span>
                                ):null}
                                {renderPSAVali(null,sno,curr_card_view_form_ind,CURR_MULTI_SUBFORM_TEMP[curr_card_view_form_ind][0])}
                            </div>
                          </Grid>)
                          ))}
                        </Grid>
                        <br></br>
                        {(message['data']['bulk_ques_resp_list']['each_row_submit']) ? (

                        (!submit_button_list.includes(message_index))?(
                          <>
                            <Button onClick={() => submit_single_row_grid_view(message['data'],curr_card_view_form_ind,message_index)} title="Submit" sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white','&:hover': {
                                                    backgroundColor: 'white', // Adjust the alpha value to control transparency
                                                    color: 'black',
                                                    border: '1px solid #00AAFF'
                                                }}}
                                                disabled = {enable_single_row_grid_submit(message['data'],curr_card_view_form_ind)}> 
                              Submit <ArrowRightAltIcon />
                            </Button>
                            {renderPSAVali('form',CURR_MULTI_SUBFORM_TEMP[curr_card_view_form_ind][0].response,null,CURR_MULTI_SUBFORM_TEMP[curr_card_view_form_ind][0])}
                          </>):null
                        ) : null}
                      </div>
                    </div>
                    <div className='SinglformDiv' id='sub_form_div'>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <div className='formName' id='form_name_div'>Update Note</div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div id='noteForm'>
                          <List className='scrollable-all' sx={{ width: '99%',height:'400px',whiteSpace: 'pre-wrap',overflowY:'scroll', bgcolor: 'background.paper',padding:'10px',boxShadow:'inset 0 0 0.4em rgba(0, 0, 0, 0.2)' }}>
                            {expMasterTaskUpdates.map((value,i)=>(
                              <ListItem key={i} alignItems="flex-start" sx={{border: '0.1px solid gray',borderRadius:'5px',marginTop:'10px'}}>
                                <ListItemAvatar >
                                  <Avatar style={{backgroundColor:"#00AAFF"}}>{value.created_user[0]}</Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={value.created_user}
                                  secondary={
                                    <React.Fragment>
                                      <Typography>
                                        <b>{value.description}</b>
                                      </Typography>
                                      {(value.attachments.length > 0) ? (
                                        <Grid container sx={{marginTop:'20px',width:'auto'}} >
                                          <Grid item xs={12}><b>Attachments : </b></Grid>
                                          <Grid item xs={12}>
                                            <div style={{backgroundColor:'white',padding:'10px',borderRadius:'10px',boxShadow:'0px 0px 2px 0px #00000040',height:'70px'}}>
                                              <Grid container columnSpacing={1} >
                                                <>
                                                  {value.attachments.map((efile,eIndx) => (
                                                    // (eIndx <= 2)?(
                                                      <Grid key={eIndx} item xs={1}>
                                                        <Avatar onClick={() => imgGalDownload(returnImgLink(efile,'file_name','link',true))} src={returnImgLink(efile,'file_name','link',false)} sx={{boxShadow: '0px 0px 2px 0px #00000040',height:'70px',width:'55px',objectFit:'contain'}} variant="rounded" />
                                                      </Grid>
                                                    // ):null
                                                  ))}
                                                  {/* {(value.attachments.length > 3) ? (
                                                    <Fab size="small" onClick={() => openImgGal(0)} style={{backgroundColor:'white',color:'#00AAFF',fontWeight:'500',fontSize:'1rem',margin:'auto'}} >
                                                      + {(value.attachments.length - 3)}
                                                    </Fab>
                                                  ):null} */}
                                                </>
                                              </Grid>
                                            </div>
                                          </Grid>
                                        </Grid>
                                      ) : null}
                                      {value.created_date}
                                    </React.Fragment>
                                  }
                                />
                            </ListItem>
                            ))}
                          </List>
                        </div>
                        <Grid container spacing={0.5} style={{marginTop:'10px'}}>
                          <Grid item xs={11.5}>
                            <Paper
                              component="form"
                              elevation={8}
                              className="scrollable-paper"
                              sx={{ display: 'flex', alignItems: 'end',borderRadius: '5px',
                              padding:'2px',
                              }}
                            >
                              <IconButton type="button" sx={{ p: '10px',position: 'sticky',
                                top: 0,
                                zIndex: 1, }} aria-label="search" onClick={() => showFileUpload(message_index,null,null,'multi_subform',null,'TaskUpdates',true,curr_card_view_form_ind)}>
                                <AttachFileIcon />
                              </IconButton>
                              <TextField
                                id="outlined-multiline-static"
                                multiline
                                fullWidth
                                maxRows={4}
                                placeholder="Type your updates here, use Shift+Enter to go next line, Press Enter to send"
                                onChange={(e) => handleUpdateNoteDescr(e.target.value)}
                                onKeyDown={(e) => enterKeyPress(e,'update_note')}
                                value={updateNoteTaskform.description}
                                sx={{
                                  borderRadius:'5px',
                                  '& textarea::-webkit-scrollbar': {
                                    width: '4px',
                                  },
                                  '& textarea::-webkit-scrollbar-track': {
                                    backgroundColor: '#f1f1f1',
                                  },
                                  '& textarea::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#c1c1c1',
                                  },
                                  '& textarea::-webkit-scrollbar-thumb:hover': {
                                    backgroundColor: '#a1a1a1',
                                  },
                                }}
                              />
                            </Paper>
                          </Grid>
                          <Grid item xs={0.5} style={{alignItems:'end',display:'flex'}}>
                            <Fab size="small" style={{backgroundColor:'#00AAFF',color:'white',margin:'0 0 5px 5px'}} onClick={UpdateTaskNotes}>
                              <SendIcon />
                            </Fab>
                          </Grid>
                        </Grid>
                        {(updateNoteTaskform.attachments.length > 0) ? (
                          <Paper
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              flexWrap: 'wrap',
                              listStyle: 'none',
                              p: 0.5,
                              border: '1px dotted #00AAFF'
                            }}
                            component="ul"
                          >
                            {updateNoteTaskform.attachments.map((file, findex) => (
                            <Chip key={findex} label={file.file_name} icon={<SimCardDownloadIcon />} sx={{marginRight: '5px'}} variant="outlined" onClick={() => downloadUploadedFile(file.link,file.file_name)} onDelete={() => removeUpdNoteOldFile(findex,file.file_row_id)} />
                            ))}
                          </Paper>
                        ) : null}
                      </AccordionDetails>
                    </Accordion>
                    </div>
                  </div>
                )
              ):null}
              {/* <!-- multiple sybform end --> */}
              {(message['data']['form_type'] === 'subform_list') ? (
                <div style={{marginTop:'20px'}} id='subform_list' >
                  <List>
                      {message['data']['subform_list'].map((each_subform,subfIndx) => {
                        <ListItem disablePadding>
                          <ListItemButton onClick={() => sendmsg(each_subform['as'],message['id'])}>
                            <EditNoteIcon />
                            <ListItemText primary={each_subform.subform_name} />
                          </ListItemButton>
                        </ListItem>
                      })}
                  </List>
                </div>
              ):null}
            </div>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              {(!have_bulk_subform(message['data'])) ? (
                <Grid  item xs={3}>
                  <div style={{margin:'10px'}} id='submit_button_ls'>
                  {!submit_button_list.includes(message_index)?(
                    <Button 
                    size="large" 
                    variant="contained" 
                    color="primary" 
                    onClick={() => formsubMit(message['data']['form_list'],message['id'],'submit_and_continue',message_index)} 
                    sx={{backgroundColor : '#00AAFF', color: 'white', border: '1px solid', borderColor: '#00AAFF'}}
                    // disabled={() =>{ enable_submit_for_all_in_one(message['data']['form_list'])}}
                    disabled={enable_submit_for_all_in_one(message['data']['form_list']) || submit_button_list.includes(message_index)}
                    >
                      Submit
                      <KeyboardArrowRightIcon />
                    </Button>
                  ):null}
                      {/* <Button 
                      size="large" 
                      variant="contained" 
                      color="primary" 
                      onClick={() => formsubMit(message['data']['form_list'],message['id'],'submit_and_continue',message_index)} 
                      sx={{backgroundColor : '#00AAFF', color: 'white', border: '1px solid', borderColor: '#00AAFF'}}
                      // disabled={() =>{ enable_submit_for_all_in_one(message['data']['form_list'])}}
                      disabled={enable_submit_for_all_in_one(message['data']['form_list']) || submit_button_list.includes(message_index)}
                      >
                        Submit
                        <KeyboardArrowRightIcon />
                      </Button> */}
                  </div>
                  {renderPSAVali('form',message.data.form_list[0].form_id,null,message.data.form_list[0])}
                </Grid>
                ) : (<>
                    {(!message['data']['bulk_ques_resp_list']['q1_toggle']) ? (
                        <Grid item xs={9}>
                          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{padding:'20px'}}>
                            <Grid item  xs={3}>
                              <Button  
                                size="small" 
                                variant="contained" 
                                color="primary" 
                                onClick={() => add_one_more_subform_resp(message_index)} title="add one more row"
                                sx={{backgroundColor : '#00AAFF', color: 'white', border: '1px solid', borderColor: '#00AAFF'}}
                                >
                                  Add One More
                                <AddIcon />
                              </Button>
                            </Grid>
                            {/* <Grid item  xs={3}>
                              <Button 
                                size="small" 
                                variant="contained" 
                                color="primary" 
                                onClick={() => dublicate_last_fill_subform_resp()} title="Duplicate last filled"
                                sx={{backgroundColor : '#00AAFF', color: 'white', border: '1px solid', borderColor: '#00AAFF'}}
                                >
                                  Duplicate Last Fill
                                <AddIcon />
                              </Button>
                            </Grid> */}
                            <Grid  item  xs={3}>
                              {(!message['data']['bulk_ques_resp_list']['each_row_submit'] ) ? (
                                (!submit_button_list.includes(message_index)) ?(
                                <Button 
                                  size="small" 
                                  variant="contained" 
                                  color="primary" 
                                  sx={{backgroundColor : '#00AAFF', color: 'white', border: '1px solid', borderColor: '#00AAFF',width: 'fit-content'}} 
                                  onClick={() => submit_multiple_subform_atonce(message['data'],message['id'],message_index)} title="Submit" 
                                > 
                                  Submit All
                                </Button>
                              ):null
                              ) : null}
                              {renderPSAVali('form',message['data']['form_list'][0]['bulk_upload_form_id'],null,null)}
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : null}</>
                )
              }
            </Grid>
            <br/>
            {(disp_form_submit_msg)?(
              <div style={{display: 'flex', padding: '5px', alignItems: 'center'}} id='submission-message'>
                <div id='submission_inner' style={{fontSize:18}}><CheckCircleIcon style={{color:'#40DC3C', fontSize:40 }}></CheckCircleIcon></div>
                <div id='submission_inner_2' style={{fontSize: '20px',fontWeight: 600,marginLeft:'20px'}}>Form has been submitted successfully</div>
                <div id='btn' style={{fontSize:18,marginLeft: '55%' , color:'blue' , float:'right'}}>
                  <Button
                    size="large" 
                    variant="contained" 
                    color="primary"
                    sx={{
                      backgroundColor: '#00AAFF',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#00AAFF',
                        color: 'white'
                      },
                      borderRadius: '25px'
                    }}
                    onClick={() => close_forms()}
                  >
                    Close
                </Button>
              </div>
            </div>
        ):null}
          </div>
        ) : null}
        <Popover
          open={visble_datepick}
          anchorEl={anchorEl}
          onClose={handleDatePickClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <Calendar onChange={(event) => OnDatePick(event)} value={datepickvar} />
        </Popover>

        {visble_col_filtr ? (<Popover
          open={visble_col_filtr}
          anchorEl={anchorEl}
          onClose={closeMasterColFilter}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        > <div style={{width:'350px',padding:'10px'}} id='fltr_dlt_outer'>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={12}>
                {(message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx].selected_filters.length > 0) ? (
                  <Paper sx={{padding:'10px',boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',margin:'10px'}}>
                      {message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx].selected_filters.map((each_sel_filt,scfindx) => {
                        return (
                          <Chip
                            key={scfindx}
                            label={each_sel_filt.val}
                            onDelete={() => handleMasterFilterDelete(each_sel_filt.val)}
                          />
                        );
                      })}
                    </Paper>
                ) : null}
                  
                <Autocomplete
                  options={message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx].filters}
                  getOptionLabel={(option) => (option.val  + '(' + option.count + ')')}
                  getoptionselected={(option, value) => option === value}
                  onChange={(e,newInput) => handleFilterOptionSelect(e,newInput)}
                  renderInput={(params) => (
                    <TextField 
                    {...params} 
                    onChange={(e) => on_master_cf_stat_refresh(e,MasterFilterCfIndx,message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx])}
                      />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Button onClick={() =>OnResetMultiSubFilters(message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx],MasterFilterCfIndx)}>
                  Reset
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button onClick={() =>OnApplyMultiSubFilters(message['data']['bulk_ques_resp_list']['master_cf_ordered_list'][MasterFilterCfIndx],MasterFilterCfIndx)}>
                    Apply
                </Button>
              </Grid>
            </Grid>
          </div>
        </Popover>) : null}
        <Dialog open={visibleFileUpload} onClose={() => cancelfileupload()} fullWidth maxWidth="sm">
        {/* {loading2 ? ( <LinearProgress/>):null} */}
        <br/>
          <DialogTitle>File Upload</DialogTitle>
          <DialogContent>
            <DialogContentText>Upload a file or view uploaded files.</DialogContentText>
              <Button 
                onClick={() => handleClickFileUpload()}
                fullWidth
                variant="contained"
                sx={{backgroundColor : 'white', color: 'black',
                      '&:hover': {
                      backgroundColor: '#00AAFF', // Adjust the alpha value to control transparency
                      color: 'white'
                  } }}
                >Choose File
              </Button>
              <input
                id="file-upload"
                type="file"
                multiple
                ref={fileInputRef}
                onChange={handleUplloadedFileChange}
                style={{ display: 'none' }} // Hide the default file input
              />
              <List>
                {temp_Upld_fileList.map((file, index) => (
                  <ListItem key={index}>
                    <ListItemText primary={index + 1 + ') '} />
                    <ListItemText primary={file.name} />
                    <ListItemSecondaryAction>
                      <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveUploadedFile(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelfileupload} color="primary">
              Cancel & Close
            </Button>
            <Button onClick={confirmFileUpload} color="primary" disabled={temp_Upld_fileList.length === 0}>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        {imgGalVisible ? (
          <Dialog open={imgGalVisible} onClose={() => closeImgGal()} PaperProps={{ style: { backgroundColor:'transparent' } }} maxWidth="xl">
            <DialogContent>
              <div className='imgGalCont' id='imgGalCont' >
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid xs={0.5}>
                  <div style={{ display: 'grid', placeItems: 'center', height: '100%' }} id='onImgSlide'>
                    <IconButton onClick={()=>onImgSlide('prev')} style={{ color: 'black',backgroundColor:'white',width:'40px',height:'40px' }} disabled={currImgIndx === 0}>
                      <ChevronLeftIcon size='large' />
                    </IconButton>
                  </div>
                </Grid>
                <Grid xs={11}>
                  <Card sx={{ display: 'flex', flexDirection: 'column',maxWidth: 350, margin: 'auto' }}>
                    <CardMedia
                      component="img"
                      sx={{ height: 450 }}
                      alt={`Image ${currImgIndx + 1}`}
                      src={`${imageObject[currImgIndx]['image']}`}
                      style={{ objectFit: 'contain' }}
                    />
                    <CardActions>
                      <Button onClick={() => imgGalDownload(imageObject[currImgIndx]['download'])} size="small">{imageObject[currImgIndx]['title']}</Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid xs={0.5}>
                  <div style={{ display: 'grid', placeItems: 'center', height: '100%' }} id='onImgSlide2'>
                    <IconButton onClick={()=>onImgSlide('next')} style={{ color: 'black',backgroundColor:'white',width:'40px',height:'40px' }} disabled={currImgIndx === imageObject.length - 1}>
                      <ChevronRightIcon size='large' />
                    </IconButton>
                  </div>
                </Grid>
                </Grid>
              </div>
            </DialogContent>
        </Dialog>
        ) : null}
        {CfimgGalVisible ? (
          <Dialog open={CfimgGalVisible} onClose={() => closeCfImgGal()} PaperProps={{ style: { backgroundColor:'transparent' } }} maxWidth="xl">
            <DialogContent>
              <div className='imgGalCont' id='imggal_cont'>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid xs={0.5}>
                  <div style={{ display: 'grid', placeItems: 'center', height: '100%' }} id='imggal_cont2'>
                    <IconButton onClick={()=>onCfImgSlide('prev')} style={{ color: 'black',backgroundColor:'white',width:'40px',height:'40px' }} disabled={CfcurrImgIndx === 0}>
                      <ChevronLeftIcon size='large' />
                    </IconButton>
                  </div>
                </Grid>
                <Grid xs={11}>
                  <Card sx={{ display: 'flex', flexDirection: 'column',maxWidth: 350, margin: 'auto' }}>
                    <CardMedia
                      component="img"
                      sx={{ height: 450 }}
                      alt={`Image ${CfcurrImgIndx + 1}`}
                      src={`${CFimageObject[CfcurrImgIndx]['image']}`}
                      style={{ objectFit: 'contain' }}
                    />
                    <CardActions>
                      <Button onClick={() => imgGalDownload(CFimageObject[CfcurrImgIndx]['download'])} size="small">{CFimageObject[CfcurrImgIndx]['title']}</Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid xs={0.5}>
                  <div style={{ display: 'grid', placeItems: 'center', height: '100%' }} id='oncf_img_slide'>
                    <IconButton onClick={()=>onCfImgSlide('next')} style={{ color: 'black',backgroundColor:'white',width:'40px',height:'40px' }} disabled={CfcurrImgIndx === CFimageObject.length - 1}>
                      <ChevronRightIcon size='large' />
                    </IconButton>
                  </div>
                </Grid>
                </Grid>
              </div>
            </DialogContent>
        </Dialog>
        ) : null}
        <Dialog open={BulkExImp} onClose={() => closeBulkExpImp()} fullWidth  maxWidth={CurrBulkUplFormType ? 'sm' : 'xs'}>
          {/* <DialogTitle>Bulk Export Import</DialogTitle> */}
          <DialogContent>
            {loading ? ( <LinearProgress/>):null}
            <br/>
            <Grid container>
              <Grid item sx={CurrBulkUplFormType ? 8 : 12}>
                <div style={{border:'1px dotted #00AAFF',borderRadius:'15px',padding:'10px'}} id='bulk_resp_upload'> 
                  <h4>Bulk Response Upload</h4>
                  <Grid container >
                    <Grid item sx={6}>
                      <Button sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white',marginLeft: '10px',padding: '6px 15px','&:hover': {
                                        backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                            color: 'black'
                            }}} onClick={() => exportFromRespTemplate()} title="Download Template" >
                        <SimCardDownloadIcon /> Template
                      </Button>
                    </Grid>
                    <Grid item sx={6}>
                      <Button sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white',marginLeft: '10px',padding: '6px 15px','&:hover': {
                                        backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                            color: 'black'
                            }}} onClick={() => showFileUpload(message_index,null,null,null,null,'bulk_form_resp_upload')} title="Upload file" >
                              <UploadFileIcon />  Upload
                      </Button>
                      <Button sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white',marginLeft: '10px',padding: '6px 15px','&:hover': {
                                        backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                            color: 'black'
                            }}} onClick={() => openFileStatusModal()} title="Uploaded file status" >
                              <InfoIcon />
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              {CurrBulkUplFormType ? (
                <Grid item sx={4} >
                  <div style={{border:'1px dotted #00AAFF',borderRadius:'15px',padding:'10px'}} id='for_export_masterXL'> 
                    <h4>Export Master Excel</h4>
                    <Button sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white',marginLeft: '10px',padding: '6px 15px','&:hover': {
                      backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                      color: 'black'
                      }}} onClick={() => exportMaster()} title="Export Master Fields as Excel" >
                      Master Export
                    </Button>
                  </div>
                </Grid>
              ) : null}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeBulkExpImp} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog 
         fullWidth
         maxWidth="xl" // You can adjust the maxWidth to your preference
         open={fileStatusModal} 
         onClose={() => closeBulkImpFileStatus()} >
          <DialogTitle>Bulk Import File Status</DialogTitle>
            <DialogContent>
              <div style={{textAlign:'right'}} id='refresh_bulk_upload_sts'>
                <Button sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white',marginLeft: '10px',padding: '6px 15px','&:hover': {
                  backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                  color: 'black'
                  }}} onClick={() => refreshBulkFileUpldStatus()} title="Refresh Status"
                >
                  <RefreshIcon />
                </Button>
              </div>
              <TableContainer component={Paper}>
                <Table  >
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="right">File Name</TableCell>
                      <TableCell align="right">Uploaded Datetime</TableCell>
                      <TableCell align="right">Event Validation Status</TableCell>
                      <TableCell align="right">Event Completion Status</TableCell>
                      <TableCell align="right">Progress</TableCell>
                      <TableCell align="right">Primary & Sub Forms Submitted</TableCell>
                      <TableCell align="right">Total Actions</TableCell>
                      <TableCell align="right">Actual Actions</TableCell>
                      <TableCell align="right">Failed Actions</TableCell>
                      <TableCell align="right">Export Uploaded File</TableCell>
                      <TableCell align="right">Export With Status</TableCell>
                      <TableCell align="right">Export Failed Rows</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {File_status_list.map((data,inx) => (
                      <TableRow
                        key={inx}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell >{inx+1}</TableCell>
                        <TableCell >{data.file_name}</TableCell>
                        <TableCell >{data.timestamp}</TableCell>
                        <TableCell>
                          {(data.validation_status)?(<div className='succBadge'></div>):null}
                          {(!data.validation_status)?(
                          <div id='load_circular' >
                              <CircularProgress />
                              {(data.total_forms_submitted)?(<Badge color="secondary" badgeContent={data.total_forms_submitted} /> ):null}
                          </div>
                          ):null}
                        </TableCell>
                        <TableCell>
                          {(data.validation_status)?(
                            <>
                              {(data.completed_status)?( <Chip label="completed" color="success" />):null}
                              {(!data.completed_status)?( <Chip label="In progress" color="warning" />):null}
                            </>
                          ):(
                            <Chip label="In progress" color="warning" />
                          )}
                        </TableCell>
                        <TableCell>
                          {(data.validation_status)?(
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                              <CircularProgress variant="determinate" />
                              <Box
                                sx={{
                                  top: 0,
                                  left: 0,
                                  bottom: 0,
                                  right: 0,
                                  position: 'absolute',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <Typography variant="caption" component="div" color="text.secondary">
                                  {data.completion_percentage}
                                </Typography>
                              </Box>
                            </Box>
                            ):(
                              <Chip label="In progress" color="warning" />
                            )}
                        </TableCell>
                        <TableCell>
                          {(data.validation_status)?(
                            <Chip label={data.total_forms_submitted} color="success" />
                            ):(
                              <Chip label="In progress" color="warning" />
                            )}
                        </TableCell>
                        <TableCell>
                          {(data.validation_status)?(
                            <Chip label={data.total_expected_actions} color="success" />
                          ):(
                            <Chip label="In progress" color="warning" />
                          )}
                        </TableCell>
                        <TableCell>
                          {(data.validation_status)?(
                            <Chip label={data.total_actual_actions} color="success" />
                          ):(
                            <Chip label="In progress" color="warning" />
                          )}
                        </TableCell>
                        <TableCell>
                          {(data.completed_status)?(
                            <Chip label={data.total_fail_actions} color="error" />
                          ):(
                            <Chip label="In progress" color="warning" />
                          )}
                        </TableCell>
                        <TableCell>
                          <Button sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white',marginLeft: '10px',padding: '6px 15px','&:hover': {
                                          backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                              color: 'black'
                              }}} onClick={() => download_uploaded_file(data.uploaded_file_id)}
                              title="Uploaded file status" >
                                <FileDownloadOutlinedIcon />
                          </Button>
                        </TableCell>
                        <TableCell>
                          <Button sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white',marginLeft: '10px',padding: '6px 15px','&:hover': {
                                          backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                              color: 'black'
                              }}} onClick={() => download_uploaded_file_with_status(currBulkUploadForm_formResp,data.instance_id,data.uploaded_file_id)}
                              disabled={(!data.completed_status)}
                              title="Uploaded file status" >
                                <FileDownloadOutlinedIcon />
                          </Button>
                        </TableCell>
                        <TableCell>
                          <Button sx={{backgroundColor: '#00AAFF',borderRadius:'25px',color: 'white',marginLeft: '10px',padding: '6px 15px','&:hover': {
                                          backgroundColor: '#E5F6FF', // Adjust the alpha value to control transparency
                              color: 'black'
                              }}} onClick={() => download_failed_rows(data.instance_id)} title="Uploaded file status"
                              disabled={((data.completed_status) && (data.total_fail_actions === 0))} >
                                <FileDownloadOutlinedIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
          <DialogActions>
            <Button onClick={closeBulkImpFileStatus} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Popover
          open={TimeVisible}
          anchorEl={anchorEl_time}
          onClose={handleCloseMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        > 
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
          {/* <TimePicker 
          open ={TimeVisible} 
          onChange={(newValue) => handleSelectTime(newValue)} 
          value={timepickvar} 
          renderInput={() => null} />  */}
          {/* <TimePicker
              onChange={(newValue) => handleSelectTime(newValue)} 
              value={timepickvar}
            /> */}
        {/* </LocalizationProvider> */}
        </Popover>

        <Popover 
          open={HoursTimeVisible} 
          anchorEl= {anchorEl_hrm} 
          onClose={() => closeHoursandMinWindow()} 
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }} >
          <Grid container sx={{padding:'10px',width:'250px'}} columnSpacing={{ xs: 2 }}  >
            <Grid item sx={6}>
              <span>hh: </span>
              <Select 
                onChange={(e) => handleSelectHours(e.target.value)} 
                value={hour_value}
                size='small'
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // Maximum height of the menu
                    },
                  },
                }}
              >
              {hhmm_time_opt.map((elem,index)=>(
                <MenuItem value={elem}>{elem}</MenuItem>
              ))}
            </Select>
            </Grid>
            <Grid item sx={6}>
              <span>mm: </span>
              <Select 
                onChange={(e) => handleSelectMinutes(e.target.value)} 
                value = {min_value}
                size='small'
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // Maximum height of the menu
                    },
                  },
                }}
              >
                    {Array.from({ length: 60 }, (_, index) => (
                      <MenuItem value={index.toString().padStart(2, '0')}>{index.toString().padStart(2, '0')}</MenuItem>
                    ))}
              </Select>
            </Grid>
          </Grid>
        </Popover>
      </>
      
    )}
  </div>
  </div>
  )
};

ChatTemplate.propTypes = {};

ChatTemplate.defaultProps = {};

export default ChatTemplate;
